import { UnicodeVM } from '@transparent/unicodevm-ng2';
import * as rxjs from 'rxjs';
import { Observable, of, from, forkJoin, throwError, Subject } from 'rxjs';
import { Cookie } from 'ng2-cookies/cookie';
import * as i0 from '@angular/core';
import { Injectable, InjectionToken, isDevMode, Inject, EventEmitter } from '@angular/core';
import { map as map$1, mergeMap, catchError } from 'rxjs/operators';
import * as i1 from '@angular/common/http';
import JSZip from 'jszip';
const AB_INITO = 'ab-initio';
const ALREADY_INITIALIZED = 103;
const EMPTY = '';
const MAX_PARENTS_TO_SEARCH = 500;
const NOT_INITITALIZED = 301;
const RESUME = 'resume';
const SCORM_ACTIVITY = 'ScormActivity';
const ALTANSWER = 'com.transparent.mon-e.api.altanswer#v1';
const LANGUAGES = 'com.transparent.mon-e.api.languages#v1';
const LIST_REPOSITORY = 'com.transparent.mon-e.api.list#v1';
const MLI = 'com.transparent.mon-e.api.mli#v1';
const SETTINGS = 'com.transparent.mon-e.api.settings#v1';
const SOUND_PLAYER = 'com.transparent.mon-e.api.soundplayer#v1';
const SOUND_RECORDER = 'com.transparent.mon-e.api.soundrecorder#v1';
const SYNCHRONIZATION = 'com.transparent.mon-e.api.synchronization#v1';
const TIMETRACKER = 'com.transparent.mon-e.api.timetracker#v1';
const USER_DATA = 'com.transparent.mon-e.api.userdata#v1';
const USER_PROFILE = 'com.transparent.mon-e.api.userprofile#v1';
const PLATFORM = 'com.transparent.mon-e.api.platform#v1';
const EVENT_TRACKER = 'com.transparent.mon-e.api.eventtracker#v1';
const HANDS_FREE_PLAYER = 'com.transparent.mon-e.api.handsfreeplayer#v1';
const CONTENT_BROWSER = 'com.transparent.mon-e.api.contentbrowser#v1';
const LEARNING_PATH = 'com.transparent.mon-e.api.learningpath#v1';
const ScormState = {
  AB_INITO,
  ALREADY_INITIALIZED,
  EMPTY,
  MAX_PARENTS_TO_SEARCH,
  NOT_INITITALIZED,
  RESUME,
  SCORM_ACTIVITY,
  ALTANSWER,
  LANGUAGES,
  LIST_REPOSITORY,
  MLI,
  SETTINGS,
  SOUND_PLAYER,
  SOUND_RECORDER,
  SYNCHRONIZATION,
  TIMETRACKER,
  USER_DATA,
  USER_PROFILE,
  PLATFORM,
  EVENT_TRACKER,
  HANDS_FREE_PLAYER,
  CONTENT_BROWSER,
  LEARNING_PATH
};
function getAlphabetMode$1(config, list) {
  if (config.url && config.url.endsWith('alphabet.xml')) {
    return true;
  } else if (list && list.name.includes('Alphabet')) {
    return true;
  }
  return false;
}

/**
 * Counts incorrectly entered characters
 */
function countNumCorrectChar(referenceString, userString) {
  const minLength = Math.min(referenceString.length, userString.length);
  let num = 0;
  for (let i = 0; i < minLength; i++) {
    if (referenceString[i] === userString[i]) {
      num++;
    }
  }
  return num;
}
/**
 *
 * keyText
 * answer
 * alternatives
 * transliteration
 * {any}
 */
function selectBestOfWrong(formatter, keyText, answer, alternatives, transliteration = '') {
  let count;
  let res;
  const tempText = formatter(keyText);
  const tempAnswer = formatter(answer);
  const transText = formatter(transliteration);
  const keyCount = countNumCorrectChar(tempText, tempAnswer);
  const transCount = countNumCorrectChar(transText, tempAnswer);
  if (transliteration === '' || keyCount >= transCount) {
    res = keyText;
    count = keyCount;
  } else {
    res = transliteration;
    count = transCount;
  }
  for (const altText of alternatives) {
    const altTxt = formatter(altText);
    if (altTxt.length > 0) {
      const tempCount = countNumCorrectChar(altTxt, tempAnswer);
      if (tempCount > count || altTxt?.trim() === answer?.trim()) {
        count = tempCount;
        res = altText;
      }
    }
  }
  return res;
}
class BykiCard {
  constructor() {
    /**
     *  Hashed id of the card
     */
    this.hid = '';
    /**
     *  BykiCard comment.
     */
    this.cardComment = '';
    /**
     *  BykiCard creation Date and Time (GMT).
     */
    this.cardCreationDate = new Date();
    /**
     *  BykiCard Guid.
     */
    this.cardGuid = '';
    /**
     *  BykiCard Modification Date.
     */
    this.cardModifDate = new Date();
    /**
     *  BykiCard List Position.
     */
    this.cardPosition = 1;
    /**
     *  BykiCard Side1 Hint
     */
    this.cardSide1Hint = '';
    /**
     *  BykiCard Side1 Text
     */
    this.cardSide1Text = '';
    /**
     *  BykiCard Side2 Hint
     */
    this.cardSide2Hint = '';
    /**
     *  BykiCard Side2 Text
     */
    this.cardSide2Text = '';
    /**
     *  BykiCard Translitaration for Side2
     */
    this.cardTranslit = '';
    /**
     *  BykiCard alternative Side2 Phrase for Side2
     */
    this.side2AltPhrase = '';
    /**
     *  BykiCard Side1 Alternative Answers
     */
    this.side1AltAnswers = [];
    /**
     *  BykiCard Side 2 Alternative Answers
     */
    this.side2AltAnswers = [];
    /**
     *  BykiCard Side 1 Sound
     */
    this.soundSide1 = '';
    /**
     *  BykiCard Side 2 Sound
     */
    this.soundSide2 = '';
    /**
     *  BykiCard side1 picture
     */
    this.picture = '';
    /**
     *  Card id
     */
    this.id = 1;
    /**
     *  id of the list this card belongs to for MLI
     */
    this.listId = '';
    /**
     * Count of words for side two. Used for unscramble, etc.
     */
    this.sideTwoWordCount = 0;
    /**
     *  The resulting code of the translation of the side1 text. i.e.:
     *  MAX_PHRASE_LENGTH_EXCEEDED, Indicates that the phrase exceeded the maximum length allowed by the translation service.
     *  NO_TRANSLATION_FOUND Indicates no translation was found for the phrase.
     *  SUCCESSFUL_TRANSLATION Indicates a successful translation.
     *  UNSUPPORTED_LANGUAGE Indicates an unsupported language was specified as either the source or target phrase of the translation.
     */
    this.translationErrorCode = '';
    /**
     * Card score
     */
    this.score = 0;
    this.order = 0;
    this.isCorrect = false;
    this.hideExportPdf = false;
  }
  clone() {
    const dest = new BykiCard();
    dest.hid = this.hid;
    dest.cardComment = this.cardComment;
    dest.cardCreationDate = this.cardCreationDate;
    dest.cardGuid = this.cardGuid;
    dest.cardModifDate = this.cardModifDate;
    dest.cardPosition = this.cardPosition;
    dest.cardSide1Hint = this.cardSide1Hint;
    dest.cardSide1Text = this.cardSide1Text;
    dest.cardSide2Hint = this.cardSide2Hint;
    dest.cardSide2Text = this.cardSide2Text;
    dest.cardTranslit = this.cardTranslit;
    dest.description = this.description;
    dest.side1AltAnswers = this.side1AltAnswers;
    dest.side2AltAnswers = this.side2AltAnswers;
    dest.side2AltPhrase = this.side2AltPhrase;
    dest.soundSide1 = this.soundSide1;
    dest.soundSide2 = this.soundSide2;
    dest.picture = this.picture;
    dest.id = this.id;
    dest.listId = this.listId;
    dest.sideTwoWordCount = this.sideTwoWordCount;
    dest.translationErrorCode = this.translationErrorCode;
    dest.score = this.score;
    dest.order = this.order;
    dest.original = this.original;
    dest.ftb = this.ftb;
    dest.bpahPosition = this.bpahPosition;
    dest.prompt = this.prompt;
    dest.sourceName = this.sourceName;
    dest.sourceUrl = this.sourceUrl;
    dest.sourceId = this.sourceId;
    dest.pictureInfo = this.pictureInfo;
    dest.isCorrect = this.isCorrect;
    dest.hash = this.hash;
    dest.answers = this.answers;
    dest.numPoints = this.numPoints;
    dest.hideExportPdf = this.hideExportPdf;
    return dest;
  }
}
let Base32 = /*#__PURE__*/(() => {
  class Base32 {
    static {
      this.CHAR_ZERO = 0x30;
    }
    static {
      this.base32Chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ234567';
    }
    static {
      this.base32Lookup = [0xFF, 0xFF, 0x1A, 0x1B, 0x1C, 0x1D, 0x1E, 0x1F, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0x00, 0x01, 0x02, 0x03, 0x04, 0x05, 0x06, 0x07, 0x08, 0x09, 0x0A, 0x0B, 0x0C, 0x0D, 0x0E, 0x0F, 0x10, 0x11, 0x12, 0x13, 0x14, 0x15, 0x16, 0x17, 0x18, 0x19, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0x00, 0x01, 0x02, 0x03, 0x04, 0x05, 0x06, 0x07, 0x08, 0x09, 0x0A, 0x0B, 0x0C, 0x0D, 0x0E, 0x0F, 0x10, 0x11, 0x12, 0x13, 0x14, 0x15, 0x16, 0x17, 0x18, 0x19, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF // 'x', 'y', 'z', '{', '|', '}', '~', 'DEL'
      ];
    }

    static encode(bytes) {
      let i = 0;
      let index = 0;
      let digit = 0;
      let nextByte;
      let base32 = '';
      while (i < bytes.length) {
        const currByte = bytes[i] >= 0 ? bytes[i] : bytes[i] + 256;
        /* Is the current digit going to span a byte boundary? */
        if (index > 3) {
          if (i + 1 < bytes.length) {
            nextByte = bytes[i + 1] >= 0 ? bytes[i + 1] : bytes[i + 1] + 256;
          } else {
            nextByte = 0;
          }
          digit = currByte & 0xFF >> index;
          index = (index + 5) % 8;
          digit <<= index;
          digit |= nextByte >> 8 - index;
          i++;
        } else {
          digit = currByte >> 8 - (index + 5) & 0x1F;
          index = (index + 5) % 8;
          if (index === 0) {
            i++;
          }
        }
        base32 += Base32.base32Chars.charAt(digit);
      }
      return base32;
    }
  }
  return Base32;
})();
class Sha1 {
  constructor() {
    this.blockSize = 512 / 8;
    /**
     * Holds the previous values of accumulated variables a-e in the compress
     * function.
     */
    this.chain = [];
    /**
     * A buffer holding the partially computed hash result.
     */
    this.buf = [];
    /**
     * An array of 80 bytes, each a part of the message to be hashed.  Referred to
     * as the message schedule in the docs.
     */
    this.W = [];
    /**
     * Contains data needed to pad messages less than 64 bytes.
     */
    this.pad = [];
    /**
     *
     */
    this.inbuf = 0;
    /**
     *
     */
    this.total = 0;
    this.pad[0] = 128;
    for (let i = 1; i < this.blockSize; ++i) {
      this.pad[i] = 0;
    }
    this.reset();
  }
  reset() {
    this.chain[0] = 0x67452301;
    this.chain[1] = 0xefcdab89;
    this.chain[2] = 0x98badcfe;
    this.chain[3] = 0x10325476;
    this.chain[4] = 0xc3d2e1f0;
    this.inbuf = 0;
    this.total = 0;
  }
  /**
   * Internal compress helper function.
   */
  compress(buf, optOffset) {
    if (!optOffset) {
      optOffset = 0;
    }
    const W = this.W;
    // get 16 big endian words
    if (typeof buf === 'string') {
      for (let i = 0; i < 16; i++) {
        W[i] = buf.charCodeAt(optOffset) << 24 | buf.charCodeAt(optOffset + 1) << 16 | buf.charCodeAt(optOffset + 2) << 8 | buf.charCodeAt(optOffset + 3);
        optOffset += 4;
      }
    } else {
      for (let i = 0; i < 16; i++) {
        W[i] = buf[optOffset] << 24 | buf[optOffset + 1] << 16 | buf[optOffset + 2] << 8 | buf[optOffset + 3];
        optOffset += 4;
      }
    }
    // expand to 80 words
    for (let i = 16; i < 80; i++) {
      const t = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
      W[i] = (t << 1 | t >>> 31) & 0xffffffff;
    }
    let a = this.chain[0];
    let b = this.chain[1];
    let c = this.chain[2];
    let d = this.chain[3];
    let e = this.chain[4];
    let f;
    let k;
    // TODO(user): Try to unroll this loop to speed up the computation.
    for (let i = 0; i < 80; i++) {
      if (i < 40) {
        if (i < 20) {
          f = d ^ b & (c ^ d);
          k = 0x5a827999;
        } else {
          f = b ^ c ^ d;
          k = 0x6ed9eba1;
        }
      } else {
        if (i < 60) {
          f = b & c | d & (b | c);
          k = 0x8f1bbcdc;
        } else {
          f = b ^ c ^ d;
          k = 0xca62c1d6;
        }
      }
      const tt = (a << 5 | a >>> 27) + f + e + k + W[i] & 0xffffffff;
      e = d;
      d = c;
      c = (b << 30 | b >>> 2) & 0xffffffff;
      b = a;
      a = tt;
    }
    this.chain[0] = this.chain[0] + a & 0xffffffff;
    this.chain[1] = this.chain[1] + b & 0xffffffff;
    this.chain[2] = this.chain[2] + c & 0xffffffff;
    this.chain[3] = this.chain[3] + d & 0xffffffff;
    this.chain[4] = this.chain[4] + e & 0xffffffff;
  }
  update(bytes, optLength) {
    optLength = optLength || bytes.length;
    const lengthMinusBlock = optLength - this.blockSize;
    let n = 0;
    // Using local instead of member letiables gives ~5% speedup on Firefox 16.
    const buf = this.buf;
    let inbuf = this.inbuf;
    // The outer while loop should execute at most twice.
    while (n < optLength) {
      if (inbuf === 0) {
        while (n <= lengthMinusBlock) {
          this.compress(bytes, n);
          n += this.blockSize;
        }
      }
      if (typeof bytes === 'string') {
        while (n < optLength) {
          buf[inbuf] = bytes.charCodeAt(n);
          ++inbuf;
          ++n;
          if (inbuf === this.blockSize) {
            this.compress(buf);
            inbuf = 0;
            break;
          }
        }
      } else {
        while (n < optLength) {
          buf[inbuf] = bytes[n];
          ++inbuf;
          ++n;
          if (inbuf === this.blockSize) {
            this.compress(buf);
            inbuf = 0;
            // Jump to the outer loop so we use the full-block optimization.
            break;
          }
        }
      }
    }
    this.inbuf = inbuf;
    this.total += optLength;
  }
  /**
   *
   */
  digest() {
    const digest = [];
    let totalBits = this.total * 8;
    // Add pad 0x80 0x00*.
    if (this.inbuf < 56) {
      this.update(this.pad, 56 - this.inbuf);
    } else {
      this.update(this.pad, this.blockSize - (this.inbuf - 56));
    }
    // Add # bits.
    for (let i = this.blockSize - 1; i >= 56; i--) {
      this.buf[i] = totalBits & 255;
      totalBits /= 256; // Don't use bit-shifting here!
    }

    this.compress(this.buf);
    let n = 0;
    for (let k = 0; k < 5; k++) {
      for (let j = 24; j >= 0; j -= 8) {
        digest[n] = this.chain[k] >> j & 255;
        ++n;
      }
    }
    return digest;
  }
}
function createHid(sideOneText, sideTwoText, sideOneLang, sideTwoLang, magicWord) {
  const normalize = UnicodeVM.Normalize;
  sideOneText = normalize(sideOneText);
  sideTwoText = normalize(sideTwoText);
  let bytes = [];
  bytes[0] = magicWord & 0x00FF;
  bytes[1] = (magicWord & 0xFF00) >> 8;
  bytes = bytes.concat(stringToByteArray(sideOneLang));
  bytes = bytes.concat(stringToByteArray(sideTwoLang));
  bytes = bytes.concat(stringToByteArray(sideOneText));
  bytes = bytes.concat(stringToByteArray(sideTwoText));
  const sha1 = new Sha1();
  sha1.update(bytes);
  const hash = sha1.digest();
  hash.length = 10;
  return Base32.encode(hash);
}
function stringToByteArray(str) {
  const output = [];
  let p = 0;
  for (let i = 0; i < str.length; i++) {
    let c = str.charCodeAt(i);
    output[p++] = c & 0xFF;
    const ex = c >>= 8;
    while (ex > 0xff) {
      output[p++] = ex & 0xff;
      c >>= 8;
    }
    output[p++] = ex;
  }
  return output;
}
let knownCode;
let learnCode;
let rootPath;
/**
 * Gets node text content
 * {Object} item
 * {string} nodeName Name of the node
 * {string}
 */
function getNodeValue$1(item, nodeName) {
  const node = item.getElementsByTagName(nodeName)[0];
  return node ? node.textContent : '';
}
/**
 * Gets answers
 * {Object} item
 * {Array<string>}
 */
function getAnswers(item) {
  const answers = [];
  const xmlAnswers = Array.from(item.getElementsByTagName('answer'));
  for (const answer of xmlAnswers) {
    answers.push(answer.textContent);
  }
  return answers;
}
/**
 * Convert json alphabet object to list of BykiCards
 * items
 * config
 * { BykiCard[]}
 */
function parseXmlToBykiCards(list, config, service) {
  const xmlItems = Array.from(list);
  const cards = [];
  knownCode = config.knownLanguageCode || 'ENGLISH';
  learnCode = config.learningLanguageCode || 'ENGLISH';
  rootPath = config.rootDataPath;
  for (const item of xmlItems) {
    const items = Array.from(item.getElementsByTagName('item'));
    for (const cardItem of items) {
      cards.push(parseItem(cardItem, service));
    }
  }
  return cards;
}
/**
 * Parses item xml and converts it ot BykiCard Obejct
 */
function parseItem(item, service) {
  const card = new BykiCard();
  const sound = getNodeValue$1(item, 'sound');
  const answers = getAnswers(item);
  if (service) {
    card.ftb = getNodeValue$1(item, 'question') || '';
    const target = getNodeValue$1(item, 'target') || '';
    if (target) {
      answers.push(target);
      const question = getNodeValue$1(item, 'question');
      card.ftb = question.replace(new RegExp(target, 'i'), '___');
      service.isFTBMode = true;
    }
    card.cardSide2Hint = getNodeValue$1(item, 'hint');
    card.cardSide1Text = getNodeValue$1(item, 'transliteration') || card.ftb;
    if (answers.length > 0) {
      card.cardSide2Text = answers[0];
      card.original = card.ftb.replace(/_+/ig, card.cardSide2Text);
    } else {
      card.cardSide2Text = card.ftb;
      delete card.ftb;
    }
  } else {
    card.cardSide1Text = getNodeValue$1(item, 'question');
    card.cardSide2Hint = getNodeValue$1(item, 'hint');
    card.cardTranslit = getNodeValue$1(item, 'transliteration');
    card.cardSide2Text = answers[0];
  }
  card.side2AltAnswers = answers;
  if (sound) {
    card.soundSide2 = rootPath + sound;
  }
  if (card.cardSide1Text && card.cardSide2Text) {
    card.hid = createHid(card.cardSide1Text, card.cardSide2Text, knownCode, learnCode);
  }
  return card;
}

/**
 * Replace html entities.
 */
function replaceHTMLEntities(str) {
  const tmp = document.createElement('DIV');
  tmp.innerHTML = (str || '').replace(/&amp;/gm, '&').replace(/\uFEFF/g, '');
  return (tmp.innerText || tmp.textContent || '').replace(/\uFEFF/gm, '');
}
/**
 *
 */
function rgbToHex(rgb) {
  if (rgb === 'transparent' || rgb === 'rgba(0, 0, 0, 0)') {
    return '#FFFFFF';
  } else if (rgb.search('rgb') === -1) {
    return rgb;
  }
  const str = rgb.substring(4, rgb.indexOf(')')).split(',').map(color => {
    color = color.trim();
    return ('0' + parseInt(color, 10).toString(16)).slice(-2);
  }).join('');
  return '#' + str;
}
/**
 * Normalize new lines
 */
function normalizeNewLines(str) {
  return (str || '').split(/\n+|<br\/?>+/).filter(item => item.trim().length > 0).map(txt => `<div>${txt}</div>`).join('');
}

// eslint-disable-next-line
const HALFWIDTH_FULLWIDTH_PUNTUATIONS_UNICODE = '\uFF01\uFF02\uFF03\uFF04\uFF05\uFF06\uFF07\uFF08\uFF09\uFF0A\uFF0B\uFF0C\uFF0D\uFF0E\uFF0F\uFF1A\uFF1B\uFF1C\uFF1D\uFF1E\uFF1F\uFF20\uFF3B\uFF3C\uFF3D\uFF3E\uFF3F\uFF40\uFF5B\uFF5C\uFF5D\uFF5E\uFF5F\uFF60\uFF61\uFF62\uFF63\uFF64\uFF65\uFFE0\uFFE1\uFFE2\uFFE3\uFFE4\uFFE5\uFFE6\uFFE8\uFFE9\uFFEA\uFFEB\uFFEC\uFFED\uFFEE';
// eslint-disable-next-line
const CJK_PUNTUATIONS_UNICODE = `\u3001\u3000\u3002\u3003\u3004\u3005\u3006\u3007\u3008\u3009\u300A\u300B\u300C\u300D\u300E\u300F\u3010\u3011\u3012\u3013\u3014\u3015\u3016\u3017\u3018\u3019\u301A\u301B\u301C\u301D\u301E\u301F\u3020\u3021\u3022\u3023\u3024\u3025\u3026\u3027\u3028\u3029\u302A\u302B\u302C\u302D\u302E\u302F\u3030\u3031\u3032\u3033\u3034\u3035\u3036\u3037\u3038\u3039\u303A\u303B\u303C\u303D\u303E\u303F`;
// eslint-disable-next-line
const PUNCTUATIONS_UNICODE = '\uFF1A\uFF0C\u3002\u002E\u002C\u0023\u0021\u0024\u0025\u005E\u0026\u002A\u002B\u003F\u003B\u003A\u007B\u007D\u007C\u005B\u005C\u005D\u003D\u005C\u002D\u005F\u0022\u0060\u007E\u0028\u0029\u00BF\u00A1\u060C\u061B\u061F\u201D\u201C\u00AB\u00BB\u2026';
// eslint-disable-next-line
const NONE_BRACKETS_PUNCTUATIONS_UNICODE = '\uFF1A\uFF0C\u3002\u002E\u002C\u0023\u0021\u0024\u0025\u005E\u0026\u002A\u002B\u003F\u003B\u003A\u007C\u005C\u003D\u005C\u002D\u005F\u0022\u0060\u007E\u00BF\u00A1\u060C\u061B\u061F\u201D\u201C\u00AB\u00BB\u2026';
const DASHES_UNICODE = '\\u002D\u2010\u2011\u2012\u2013\u2014\u2015\u2E3A\u2E3B\u2E40\u301C\uFE31\uFE32\uFE58\uFE63\uFF0D\u00AD';
/**
 * \u002D   HYPHEN-MINUS
 * \u05BE   HEBREW PUNCTUATION MAQAF
 * \u058A   ARMENIAN HYPHEN
 * \u1806   MONGOLIAN TODO SOFT HYPHEN
 * \u2010   HYPHEN
 * \u2012   FIGURE DASH
 * \u2013   EN DASH
 * \uFE63   SMALL HYPHEN-MINUS
 * \uFF0D   FULLWIDTH HYPHEN-MINUS
 */
const HYPHEN_UNICODE = '\u002D\u05BE\u1806\u2010\u2012\u2013\uFE63\uFF0D';
/**
 * \u0020    SPACE
 * \u00A0    NO-BREAK SPACE
 * \u1680    OGHAM SPACE MARK
 * \u2000    EN QUAD
 * \u2001    EM QUAD
 * \u2002    EN SPACE
 * \u2003    EM SPACE
 * \u2004    THREE-PER-EM SPACE
 * \u2005    FOUR-PER-EM SPACE
 * \u2006    SIX-PER-EM SPACE
 * \u2007    FIGURE SPACE
 * \u2008    PUNCTUATION SPACE
 * \u2009    THIN SPACE
 * \u200A    HAIR SPACE
 * \u200B    ZERO WIDTH SPACE
 * \u202F    NARROW NO-BREAK SPACE
 * \u205F    MEDIUM MATHEMATICAL SPACE
 * \u3000    IDEOGRAPHIC SPACE
 * Resource http://www.fileformat.info/info/unicode/category/Zs/list.htm
 */
// eslint-disable-next-line
const SPACES_UNICODE = '\u0020\u00A0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u200B\u202F\u205F\u3000';
/**
 *
 */
// eslint-disable-next-line
const NO_SPACE_LANGUAGES = ['THAI', 'MANDARIN', 'CHINESE', 'JAPANESE', 'JAPANESE_KANJI', 'CANTONESE', 'MANDARIN_TRADITIONAL', 'KHMER'];
/**
 * Escapes punctuations in string
 */
function escapeRegExpString(str) {
  return str.replace(/[\\^$*+?.()|[\]{}]/g, '\\$&');
}
/**
 * Creates regexp pattern from given string based on learning language code
 */
function createPatternForGivenString(str, learningLanguageCode) {
  return getWordBoundaryRegex(str, NO_SPACE_LANGUAGES.indexOf(learningLanguageCode) === -1);
}
function getWordBoundaryRegex(str, isDelimiterLanguage = true) {
  if (!isDelimiterLanguage) {
    return new RegExp(escapeRegExpString(str), 'gm');
  } else {
    // eslint-disable-next-line
    return new RegExp('(?:^|([' + SPACES_UNICODE + ']+)([' + PUNCTUATIONS_UNICODE + ']))?(' + escapeRegExpString(str) + ')(?=|([' + PUNCTUATIONS_UNICODE + '])?([' + SPACES_UNICODE + ']+)|$)', 'gm');
  }
}
/**
 * Check for delimiter char
 */
function isDelimiter(str = '') {
  return SPACES_UNICODE.indexOf(str) !== -1 || PUNCTUATIONS_UNICODE.indexOf(str) !== -1;
}
/**
 * replace Hyphen with Non-Breaking Hyphen
 */
function replaceHyphenBetweenWords(str) {
  const matcher = match => {
    return match.replace(new RegExp('[' + HYPHEN_UNICODE + ']', 'gmi'), String.fromCharCode(0x2011));
  };
  return (str || '').replace(new RegExp('[\\D]+[' + HYPHEN_UNICODE + '][\\D]*', 'gmi'), matcher).replace(new RegExp('[\\d]+[' + HYPHEN_UNICODE + '][\\D]+', 'gmi'), matcher);
}
const REMOVE_CHARS$1 = /[\u2018\u2019]/gm;
function diffText(userString, originString, splitWordsFn, strictMode = false) {
  const arrUserString = removeEmpty(splitWordsFn(formatterText$1(userString, strictMode)));
  const arrOriginString = removeEmpty(splitWordsFn(formatterText$1(originString, strictMode)));
  const originLen = arrOriginString.length;
  const userLen = arrUserString.length;
  let editLength = 1;
  const maxEditLength = originLen + userLen;
  const bestPath = [{
    newPos: -1,
    components: []
  }];
  // Seed editLength = 0, i.e. the content starts with the same values
  const oldPos = extractCommon(bestPath[0], arrOriginString, arrUserString, 0, strictMode);
  if (bestPath[0].newPos + 1 >= originLen && oldPos + 1 >= userLen) {
    // Identity per the equality and tokenizer
    return [{
      value: arrUserString.join(''),
      count: arrUserString.length
    }];
  }
  // Main worker method. checks all permutations of a given edit length for acceptance.
  const execEditLength = () => {
    for (let diagonalPath = -1 * editLength; diagonalPath <= editLength; diagonalPath += 2) {
      let basePath;
      const addPath = bestPath[diagonalPath - 1];
      const removePath = bestPath[diagonalPath + 1];
      let oldPosition = (removePath ? removePath.newPos : 0) - diagonalPath;
      if (addPath) {
        // No one else is going to attempt to use this value, clear it
        bestPath[diagonalPath - 1] = undefined;
      }
      const canAdd = addPath && addPath.newPos + 1 < originLen;
      const canRemove = removePath && 0 <= oldPosition && oldPosition < userLen;
      if (!canAdd && !canRemove) {
        // If this path is a terminal then prune
        bestPath[diagonalPath] = undefined;
        continue;
      }
      // Select the diagonal that we want to branch from. We select the prior
      // path whose position in the new string is the farthest from the origin
      // and does not pass the bounds of the diff graph
      if (!canAdd || canRemove && addPath.newPos < removePath.newPos) {
        basePath = clonePath(removePath);
        pushComponent(basePath.components, undefined, true);
      } else {
        basePath = addPath; // No need to clone, we've pulled it from the list
        basePath.newPos++;
        pushComponent(basePath.components, true, undefined);
      }
      oldPosition = extractCommon(basePath, arrOriginString, arrUserString, diagonalPath, strictMode);
      // If we have hit the end of both strings, then we are done
      if (basePath.newPos + 1 >= originLen && oldPosition + 1 >= userLen) {
        return buildValues(self, basePath.components, arrOriginString, arrUserString, strictMode);
      } else {
        // Otherwise track this path as a potential candidate and continue.
        bestPath[diagonalPath] = basePath;
      }
    }
    editLength++;
  };
  // Performs the length of edit iteration. Is a bit fugly as this has to support the
  // sync and async mode which is never fun. Loops over execEditLength until a value
  // is produced.
  while (editLength <= maxEditLength) {
    const ret = execEditLength();
    if (ret) {
      return ret;
    }
  }
  return [{
    value: '',
    count: 0
  }];
}
function formatterText$1(value, strictMode = false) {
  if (strictMode) {
    return getSpaceFormatter$1(value);
  }
  return getSpaceFormatter$1(getRegexpFormatter$1(getPunctuationFormatter$1(value)));
}
/**
 * Closure function for space formatter
 */
function getSpaceFormatter$1(value) {
  return (value || '').replace(/\s+/igm, ' ').trim();
}
/**
 * Closure function for regexp formatter
 */
function getRegexpFormatter$1(value) {
  return (value || '').replace(REMOVE_CHARS$1, ' ');
}
/**
 * Closure function for space formatter
 */
function getPunctuationFormatter$1(value) {
  return (value || '').replace(new RegExp('[' + PUNCTUATIONS_UNICODE + ']', 'igm'), '');
}
function equals(left, right, strictMode = false) {
  if (!strictMode) {
    left = left.toLowerCase();
    right = right.toLowerCase();
  }
  return left.trim() === right.trim();
}
function extractCommon(basePath, newString, oldString, diagonalPath, strictMode = false) {
  const newLen = newString.length;
  const oldLen = oldString.length;
  let newPos = basePath.newPos;
  let oldPos = newPos - diagonalPath;
  let commonCount = 0;
  while (newPos + 1 < newLen && oldPos + 1 < oldLen && equals(newString[newPos + 1], oldString[oldPos + 1], strictMode)) {
    newPos++;
    oldPos++;
    commonCount++;
  }
  if (commonCount) {
    basePath.components.push({
      count: commonCount
    });
  }
  basePath.newPos = newPos;
  return oldPos;
}
function clonePath(path) {
  return {
    newPos: path.newPos,
    components: path.components.slice(0)
  };
}
function diffTextToHtml(diffs = []) {
  let count = 0;
  const arr = [];
  for (let i = 0; i < diffs.length; i++) {
    if (diffs[i].added && diffs[i + 1] && diffs[i + 1].removed) {
      const swap = diffs[i];
      diffs[i] = diffs[i + 1];
      diffs[i + 1] = swap;
    }
    let node;
    if (diffs[i].removed || diffs[i].added) {
      node = document.createElement('span');
      node.classList.add(diffs[i].added ? 'no-words' : 'incorrect');
      node.appendChild(document.createTextNode(diffs[i].value));
    } else {
      node = document.createTextNode(diffs[i].value);
    }
    if (node.nodeType === Node.ELEMENT_NODE) {
      if (arr[i - 1 + count] && arr[i - 1 + count].trimRight() === arr[i - 1 + count]) {
        arr.push(' ');
        count++;
      }
    }
    arr.push(node.outerHTML || node.textContent);
  }
  return arr;
}
function buildValues(diff, components, originStringArr, userStringArr, strictMode = false) {
  let componentPos = 0;
  const componentLen = components.length;
  let newPos = 0;
  let oldPos = 0;
  for (; componentPos < componentLen; componentPos++) {
    const component = components[componentPos];
    if (!component.removed) {
      const arr = [];
      for (let i = newPos; i < newPos + component.count; i++) {
        const originalText = originStringArr[i];
        const userString = userStringArr[i] || '';
        arr.push(userString && equals(originalText, userString, strictMode) ? userString : originalText);
      }
      component.value = arr.join('');
      newPos += component.count;
      // Common case
      if (!component.added) {
        oldPos += component.count;
      }
    } else {
      component.value = userStringArr.slice(oldPos, oldPos + component.count).join('');
      oldPos += component.count;
      // Reverse add and remove so removes are output first to match common convention
      // The diffing algorithm is tied to add then remove output and this is the simplest
      // route to get the desired output with minimal overhead.
      if (componentPos && components[componentPos - 1].added) {
        const tmp = components[componentPos - 1];
        components[componentPos - 1] = components[componentPos];
        components[componentPos] = tmp;
      }
    }
  }
  // Special case handle for when one terminal is ignored (i.e. whitespace).
  // For this case we merge the terminal into the prior string and drop the change.
  // This is only available for string mode.
  const lastComponent = components[componentLen - 1];
  if (componentLen > 1 && typeof lastComponent.value === 'string' && (lastComponent.added || lastComponent.removed) && equals('', lastComponent.value, strictMode)) {
    components[componentLen - 2].value += lastComponent.value;
    components.pop();
  }
  return components;
}
function pushComponent(components, added, removed) {
  const last = components[components.length - 1];
  if (last && last.added === added && last.removed === removed) {
    // We need to clone here as the component clone operation is just
    // as shallow array clone
    components[components.length - 1] = {
      count: last.count + 1,
      added,
      removed
    };
  } else {
    components.push({
      count: 1,
      added,
      removed
    });
  }
}
function removeEmpty(array) {
  const ret = [];
  for (const item of array) {
    if (item) {
      ret.push(item);
    }
  }
  return ret;
}
const map = [[0x00C0, [0x0041, 0x0300]], [0x00C1, [0x0041, 0x0301]], [0x1EA2, [0x0041, 0x0309]], [0x00C3, [0x0041, 0x0303]], [0x1EA0, [0x0041, 0x0323]], [0x1EA2, [0x0041, 0x0309]], [0x1EA4, [0X00C2, 0x0301]], [0x1EA6, [0X00C2, 0x0300]], [0x1EA8, [0X00C2, 0x0309]], [0x1EAA, [0X00C2, 0x0303]], [0x1EAC, [0X00C2, 0x0323]], [0x1EAE, [0X0102, 0x0301]], [0x1EB0, [0X0102, 0x0300]], [0x1EB2, [0X0102, 0x0309]], [0x1EB4, [0X0102, 0x0303]], [0x1EB6, [0X0102, 0x0323]], [0x00E0, [0X0061, 0x0300]], [0x00E1, [0X0061, 0x0301]], [0x00E3, [0X0061, 0x0303]], [0x1EA1, [0X0061, 0x0323]], [0x1EA3, [0X0061, 0x0309]], [0x1EA5, [0X00E2, 0x0301]], [0x1EA7, [0X00E2, 0x0300]], [0x1EA9, [0X00E2, 0x0309]], [0x1EAB, [0X00E2, 0x0303]], [0x1EAD, [0X00E2, 0x0323]], [0x1EAF, [0x0103, 0x0301]], [0x1EB1, [0x0103, 0x0300]], [0x1EB3, [0x0103, 0x0309]], [0x1EB5, [0x0103, 0x0303]], [0x1EB7, [0x0103, 0x0323]], [0x1EB8, [0x0045, 0x0323]], [0x1EBA, [0x0045, 0x0309]], [0x1EBC, [0x0045, 0x0303]], [0x00C8, [0x0045, 0x0300]], [0x00C9, [0x0045, 0x0301]], [0x1EBE, [0x00CA, 0x0301]], [0x1EC0, [0x00CA, 0x0300]], [0x1EC2, [0x00CA, 0x0309]], [0x1EC4, [0x00CA, 0x0303]], [0x1EC6, [0x00CA, 0x0323]], [0x00E8, [0x0065, 0x0300]], [0x00E9, [0x0065, 0x0301]], [0x1EB9, [0x0065, 0x0323]], [0x1EBB, [0x0065, 0x0309]], [0x1EBD, [0x0065, 0x0303]], [0x1EBF, [0x00EA, 0x0301]], [0x1EC1, [0x00EA, 0x0300]], [0x1EC3, [0x00EA, 0x0309]], [0x1EC5, [0x00EA, 0x0303]], [0x1EC7, [0x00EA, 0x0323]], [0x0128, [0x0049, 0x0303]], [0x1EC8, [0x0049, 0x0309]], [0x1ECA, [0x0049, 0x0323]], [0x00CC, [0x0049, 0x0300]], [0x00CD, [0x0049, 0x0301]], [0x00EC, [0x0069, 0x0300]], [0x00ED, [0x0069, 0x0301]], [0x0129, [0x0069, 0x0303]], [0x1EC9, [0x0069, 0x0309]], [0x1ECB, [0x0069, 0x0323]], [0x00D2, [0x004F, 0x0300]], [0x00D3, [0x004F, 0x0301]], [0x1ECE, [0x004F, 0x0309]], [0x00D5, [0x004F, 0x0303]], [0x1ECC, [0x004F, 0x0323]], [0x1ED0, [0x00D4, 0x0301]], [0x1ED2, [0x00D4, 0x0300]], [0x1ED4, [0x00D4, 0x0309]], [0x1ED6, [0x00D4, 0x0303]], [0x1ED8, [0x00D4, 0x0323]], [0x1EDA, [0x01A0, 0x0301]], [0x1EDC, [0x01A0, 0x0300]], [0x1EDE, [0x01A0, 0x0309]], [0x1EE0, [0x01A0, 0x0303]], [0x1EE2, [0x01A0, 0x0323]], [0x00F2, [0x006F, 0x0300]], [0x00F3, [0x006F, 0x0301]], [0x1ECF, [0x006F, 0x0309]], [0x00F5, [0x006F, 0x0303]], [0x1ECD, [0x006F, 0x0323]], [0x1ED1, [0x00F4, 0x0301]], [0x1ED3, [0x00F4, 0x0300]], [0x1ED5, [0x00F4, 0x0309]], [0x1ED7, [0x00F4, 0x0303]], [0x1ED9, [0x00F4, 0x0323]], [0x1EDB, [0x01A1, 0x0301]], [0x1EDD, [0x01A1, 0x0300]], [0x1EDF, [0x01A1, 0x0309]], [0x1EE1, [0x01A1, 0x0303]], [0x1EE3, [0x01A1, 0x0323]], [0x00D9, [0x0055, 0x0300]], [0x00DA, [0x0055, 0x0301]], [0x1EE6, [0x0055, 0x0309]], [0x0168, [0x0055, 0x0303]], [0x1EE4, [0x0055, 0x0323]], [0x1EE8, [0x01AF, 0x0301]], [0x1EEA, [0x01AF, 0x0300]], [0x1EEC, [0x01AF, 0x0309]], [0x1EEE, [0x01AF, 0x0303]], [0x1EF0, [0x01AF, 0x0323]], [0x00FA, [0x0075, 0x0301]], [0x00F9, [0x0075, 0x0300]], [0x1EE7, [0x0075, 0x0309]], [0x0169, [0x0075, 0x0303]], [0x1EE5, [0x0075, 0x0323]], [0x1EE9, [0x01B0, 0x0301]], [0x1EEB, [0x01B0, 0x0300]], [0x1EED, [0x01B0, 0x0309]], [0x1EEF, [0x01B0, 0x0303]], [0x1EF1, [0x01B0, 0x0323]], [0x00DD, [0x0059, 0x0301]], [0x1EF2, [0x0059, 0x0300]], [0x1EF4, [0x0059, 0x0323]], [0x1EF6, [0x0059, 0x0309]], [0x1EF8, [0x0059, 0x0303]], [0x00FD, [0x0079, 0x0301]], [0x1EF3, [0x0079, 0x0300]], [0x1EF5, [0x0079, 0x0323]], [0x1EF7, [0x0079, 0x0309]], [0x1EF9, [0x0079, 0x0303]]];
function decomposeVietnamese(str) {
  if (!str || str === '') {
    return str;
  }
  const len = map.length;
  for (let i = 0; i < len; i++) {
    const mapPattern = map[i][1];
    const value = map[i][0];
    const pattern = new RegExp(String.fromCharCode(value), 'g');
    const rstr = String.fromCharCode(mapPattern[0]) + String.fromCharCode(mapPattern[1]);
    str = str.replace(pattern, rstr);
  }
  return str;
}
function normalizeTagalogString(str = '') {
  str = str.replace(/\u2026/ig, '...');
  str = str.replace(/\u00E9\u0323/ig, '\u1EB9\u0301');
  const accents = ['\u0300', '\u0301', '\u0302', '\u0304', '\u0306'];
  const letters = ['a', 'e', 'i', 'o', 'u', 'y'];
  const replacementLetters = [['\u00E0', '\u00E1', '\u00E2', '\u0101', '\u0103'], ['\u00E8', '\u00E9', '\u00EA', '\u0113', '\u0115'], ['\u00EC', '\u00ED', '\u00EE', '\u012B', '\u012D'], ['\u00F2', '\u00F3', '\u00F4', '\u014D', '\u014F'], ['\u00F9', '\u00FA', '\u00FB', '\u016B', '\u016D'], ['\u1EF3', '\u00FD', '\u0177', '\u0233', 'y']];
  for (let i = 0; i < letters.length; i++) {
    for (let j = 0; j < accents.length; j++) {
      const patString = letters[i] + accents[j];
      const pat = new RegExp(patString, 'ig');
      str = str.replace(pat, replacementLetters[i][j]);
    }
  }
  return str;
}
function normalizeEllipsisString(str) {
  if (str) {
    str = str.replace(/\u2026/ig, '...').replace(/\u0074\u0326/g, '\u021B') // ț
    .replace(/\u0054\u0326/g, '\u021A') // Ț
    .replace(/\u0069\u0302/g, '\u00EE') // î
    .replace(/\u0049\u0302/g, '\u00CE') // Î
    .replace(/\u0061\u0306/g, '\u0103') // ă
    .replace(/\u0041\u0306/g, '\u0202') // Ă
    .replace(/\u0061\u0302/g, '\u00E2') // â
    .replace(/\u0041\u0302/g, '\u00C2') // Â
    .replace(/\u0073\u0326/g, '\u0219') // ș
    .replace(/\u0053\u0326/g, '\u0218') // Ș
    .replace(/\u006e\u0307/g, '\u1E45') // ṅ
    .replace(/\u004e\u0307/g, '\u1E44'); // Ṅ
  }

  return str;
}

/**
 * A utility class for resolving and forming url for b4x files
 */
function createFullUrl(url) {
  url = url.trim();
  if (url.indexOf('xml') === -1) {
    if (url[url.length - 1] === '/') {
      url = url.substring(0, url.length - 1);
    }
    return url + '/' + getB4xFolderName(url) + '.xml';
  }
  return url;
}
function getB4xFolderName(url) {
  return url.substring(url.lastIndexOf('/') + 1);
}
function normalizeVietnamese(card) {
  if (card) {
    card.cardSide1Text = decomposeVietnamese(card.cardSide1Text);
    card.cardSide1Hint = decomposeVietnamese(card.cardSide1Hint);
    card.cardSide2Text = decomposeVietnamese(card.cardSide2Text);
    card.cardSide2Hint = decomposeVietnamese(card.cardSide2Hint);
    card.cardTranslit = decomposeVietnamese(card.cardTranslit);
  }
  return card;
}
function normalizeTagalog(card) {
  if (card) {
    card.cardSide1Text = normalizeTagalogString(card.cardSide1Text);
    card.cardSide1Hint = normalizeTagalogString(card.cardSide1Hint);
    card.cardSide2Text = normalizeTagalogString(card.cardSide2Text);
    card.cardSide2Hint = normalizeTagalogString(card.cardSide2Hint);
    card.cardTranslit = normalizeTagalogString(card.cardTranslit);
  }
  return card;
}
function normalizeEllipsis(card) {
  if (card) {
    card.cardSide1Text = normalizeEllipsisString(card.cardSide1Text);
    card.cardSide1Hint = normalizeEllipsisString(card.cardSide1Hint);
    card.cardSide2Text = normalizeEllipsisString(card.cardSide2Text);
    card.cardSide2Hint = normalizeEllipsisString(card.cardSide2Hint);
    card.cardTranslit = normalizeEllipsisString(card.cardTranslit);
  }
  return card;
}
function normalizeString(str) {
  const tags = /(<a|<font|<\/span>|<\/div>|<\/a>)/igm;
  str = (str || '').replace(/&apos;/g, '\'').replace(/&quot;/g, '"').replace(/&gt;/g, '>').replace(/&lt;/g, '<').replace(/&amp;/g, '&').replace(/[\u200E\u200F]/g, ''); // Remove LRT and RTL MARKS.
  if (typeof str === 'string') {
    if (tags.test(str)) {
      const p = /<font color="#(.{6})">(.+)<\/font>/igm;
      str = str.replace(p, '<span style="color:#$1">$2</span>');
      return str;
    }
    return (str || '').replace(/(["'])\s+([\(\{\[])/g, '$1\u2000$2').replace(/(<([^>]+)>)/ig, '').trim();
  } else {
    return str;
  }
}
class BykiList {
  constructor() {
    /**
     *  AAID of the list
     */
    this.aaid = '';
    /**
     *  GUID of the list
     */
    this.guid = '';
    /**
     *  Collection of cards in BykiList.
     */
    this.cards = [];
    /**
     *  BykiList extra content file name.
     */
    this.extraContent = [];
    /**
     *  BykiList extra content Url
     */
    this.extraContentUrl = '';
    /**
     * Sort Name
     */
    this.sortName = '';
    /**
     *  Indicates whether BykiList is ordered. "Ordered"
     */
    this.isOrdered = false;
    /**
     *  Indicates whether BykiList is protected.  "Protected"
     */
    this.isProtected = false;
    /**
     *  Side 1 name for subject lists.   "Side1Name"
     */
    this.side1Name = '';
    /**
     *  Side 2 name for themed lists.  "Side2Name"
     */
    this.side2Name = '';
    /**
     *  BykiList side 1 language.  "Side1Lang"
     */
    this.side1Lang = 'English';
    /**
     *  BykiList side 2 language.  "Side2Lang"
     */
    this.side2Lang = 'Tajiki';
    /**
     *  Indicates whether BykiList is themed. "Themed"
     */
    this.isThemed = false;
    /**
     *  Indicates whether translitaration is used in BykiList. "UseTransliteration"
     */
    this.isTransliterationShown = false;
    /**
     *  BykiList theme name.  "ThemeName"
     */
    this.themeName = '';
    /**
     *  BykiList description. "Description"
     */
    this.description = '';
    /**
     *  Government BykiList. "Government"
     */
    this.isGovernment = false;
    /**
     *  Application where the BykiList was created "AppCreatorName"
     */
    this.appCreatorName = '';
    /**
     *  Creator of the list
     */
    this.creator = '';
    /**
     *  URL of creator of the list
     */
    this.creatorURL = '';
    /**
     *  Subject name
     */
    this.subjectName = '';
    /**
     *  Is it library list
     */
    this.isLibrary = false;
    /**
     *  List protection features
     */
    this.protection = 'PROTECTED';
    /**
     *  URL of the list
     */
    this.url = '';
    /**
     *  A String containing bykicard scores for the list
     */
    this.scores = '';
    /**
     *  List state draft or trashed
     */
    this.listState = 'DRAFT';
    /**
     * Visibility of the list -- PRIVATE or PUBLIC
     */
    this.visibility = 'PRIVATE';
    /**
     *  Name of the BykiList. "Name"
     */
    this.name = '';
    /**
     * The list that is currently selected or unselected.
     */
    this.selected = false;
    /**
     * Temporary list until we changed cards to <code>IList</code>
     */
    this.cardList = [];
    /**
     *  Version of the list
     */
    this.version = 0;
    /**
     * Indicate if the list has change
     */
    this.changed = false;
    this.uuid = '';
  }
  /**
   * Override toString method for BykiList()
   */
  toString() {
    return this.name;
  }
  /**
   * Clone cards
   */
  cloneCards() {
    return this.cards.slice(0).map(card => card.clone());
  }
  /**
   * Collects all cards scores and returns them as string
   */
  getCardScoresAsString() {
    const arr = [];
    const len = this.cards.length;
    for (let i = 0; i < len; i++) {
      arr.push('' + this.cards[i].score);
    }
    this.scores = arr.join('');
    return this.scores;
  }
  /**
   * Clone BykyList
   */
  clone() {
    const dest = new BykiList();
    dest.aaid = this.aaid;
    dest.guid = this.guid;
    dest.cards = this.cloneCards();
    dest.creationDate = this.creationDate;
    dest.extraContent = this.extraContent;
    dest.extraContentUrl = this.extraContentUrl;
    dest.learningModes = this.learningModes;
    dest.sortName = this.sortName;
    dest.isOrdered = this.isOrdered;
    dest.isProtected = this.isProtected;
    dest.side1Name = this.side1Name;
    dest.side2Name = this.side2Name;
    dest.side1Lang = this.side1Lang;
    dest.side2Lang = this.side2Lang;
    dest.isThemed = this.isThemed;
    dest.isTransliterationShown = this.isTransliterationShown;
    dest.themeName = this.themeName;
    dest.description = this.description;
    dest.isGovernment = this.isGovernment;
    dest.appCreatorName = this.appCreatorName;
    dest.creator = this.creator;
    dest.creatorURL = this.creatorURL;
    dest.subjectName = this.subjectName;
    dest.isLibrary = this.isLibrary;
    dest.protection = this.protection;
    dest.url = this.url;
    dest.scores = this.scores;
    dest.listState = this.listState;
    dest.visibility = this.visibility;
    dest.name = this.name;
    dest.selected = this.selected;
    dest.cardList = this.cardList;
    dest.version = this.version;
    dest.changed = this.changed;
    return dest;
  }
}
class ListProtection {
  constructor() {
    /**
     *  Can the someone edit the list
     */
    this.isEditingProtected = false;
    /**
     *  Can the someone copy the list
     */
    this.isCopyingProtected = false;
    /**
     *  Can the someone share the list
     */
    this.isSharingProtected = false;
  }
}
class LearningModes {
  constructor() {
    /**
     * Has the list PreviewIt mode
     */
    this.hasPreviewIt = false;
    /**
     * Has the list SelfReportingRecognizeIt mode
     */
    this.hasSRRecognizeIt = false;
    /**
     * Has the list WrittenRecognizeIt mode
     */
    this.hasWrittenRecognizeIt = false;
    /**
     * Has the list  SelfReportingProduceIt mode
     */
    this.hasSRProduceIt = false;
    /**
     * Has the list WrittenProduceIt mode
     */
    this.hasWrittenProduceIt = false;
  }
}
function isDefined$1(value) {
  return typeof value !== 'undefined';
}
function getNodeValue(nodes) {
  let str = '';
  const node = nodes.length > 0 ? nodes[0] : null;
  if (node) {
    str = node.textContent || '';
  }
  return normalizeString(str);
}
function createBykiListFromXmlList(xml, rootPath, isTranslit) {
  rootPath = rootPath || '';
  if (rootPath !== '' && rootPath[rootPath.length - 1] !== '/') {
    rootPath = rootPath + '/';
  }
  // uuid and version are set as attribute to root element in some list xml
  const rootList = xml.getElementsByTagName('list')[0];
  let uuid = '';
  let vers = '';
  if (rootList) {
    uuid = rootList.getAttribute('uuid');
    vers = rootList.getAttribute('version');
  }
  let bykiList = new BykiList();
  const head = xml.getElementsByTagName('head')[0];
  bykiList.name = getNodeValue(head.getElementsByTagName('name'));
  bykiList.side1Lang = getNodeValue(head.getElementsByTagName('side1_language_key') || head.getElementsByTagName('side1_language'));
  bykiList.side2Lang = getNodeValue(head.getElementsByTagName('side2_language_key') || head.getElementsByTagName('side2_language'));
  // if is translit is not set and language is Cantonese set it to true;
  if (!isDefined$1(isTranslit)) {
    isTranslit = bykiList.side2Lang === 'CANTONESE';
  }
  bykiList.description = getNodeValue(head.getElementsByTagName('description'));
  bykiList.creator = getNodeValue(head.getElementsByTagName('creator'));
  bykiList.creatorURL = getNodeValue(head.getElementsByTagName('creator_url'));
  bykiList.appCreatorName = getNodeValue(head.getElementsByTagName('creator_application'));
  bykiList.subjectName = getNodeValue(head.getElementsByTagName('subject_name'));
  bykiList.side1Name = getNodeValue(head.getElementsByTagName('side1_title'));
  bykiList.side2Name = getNodeValue(head.getElementsByTagName('side2_title'));
  bykiList.creationDate = new Date(getNodeValue(head.getElementsByTagName('creation_date')));
  bykiList.isThemed = getNodeValue(head.getElementsByTagName('is_themed')) === 'true';
  bykiList.isGovernment = getNodeValue(head.getElementsByTagName('is_government')) === 'true';
  bykiList.isLibrary = getNodeValue(head.getElementsByTagName('is_library')) === 'true';
  bykiList.isTransliterationShown = getNodeValue(head.getElementsByTagName('is_transliteration_shown')) === 'true';
  bykiList.isOrdered = getNodeValue(head.getElementsByTagName('is_ordered')) === 'true';
  bykiList.learningModes = parseLearningModes$1(head.getElementsByTagName('LearningFeatures'));
  bykiList.listProtection = parseProtection$1(head.getElementsByTagName('ListProtection'));
  bykiList.uuid = getNodeValue(head.getElementsByTagName('uuid'));
  bykiList.aaid = getNodeValue(head.getElementsByTagName('aaid'));
  if (!bykiList.aaid) {
    bykiList.aaid = uuid + '.' + vers;
  }
  bykiList.version = +getNodeValue(head.getElementsByTagName('version'));
  if (vers) {
    bykiList.version = +vers;
  }
  const cards = xml.getElementsByTagName('card');
  bykiList = parseCards(cards, bykiList, rootPath, isTranslit);
  return bykiList;
}
/**
 * To validate BykiList name we have to get BykiList info
 */
function getBykiListInfo(xml) {
  const rootList = xml.getElementsByTagName('list')[0];
  let vers = '';
  if (rootList) {
    vers = rootList.getAttribute('version');
  }
  const bykiList = new BykiList();
  const head = xml.getElementsByTagName('head')[0];
  bykiList.name = getNodeValue(head.getElementsByTagName('name'));
  bykiList.side1Lang = getNodeValue(head.getElementsByTagName('side1_language_key') || head.getElementsByTagName('side1_language'));
  bykiList.side2Lang = getNodeValue(head.getElementsByTagName('side2_language_key') || head.getElementsByTagName('side2_language'));
  bykiList.uuid = getNodeValue(head.getElementsByTagName('uuid'));
  bykiList.version = +getNodeValue(head.getElementsByTagName('version'));
  if (vers) {
    bykiList.version = +vers;
  }
  return bykiList;
}
function parseProtection$1(obj) {
  const nodes = obj[0];
  const lp = new ListProtection();
  if (nodes) {
    lp.isCopyingProtected = getNodeValue(nodes.getElementsByTagName('is_Protected_Copying')) === 'true';
    lp.isSharingProtected = getNodeValue(nodes.getElementsByTagName('s_Protected_Sharing')) === 'true';
    lp.isEditingProtected = getNodeValue(nodes.getElementsByTagName('is_Protected_Editing')) === 'true';
  }
  return lp;
}
function parseLearningModes$1(learningMode) {
  const nodes = learningMode[0];
  const lm = new LearningModes();
  if (nodes) {
    lm.hasPreviewIt = getNodeValue(nodes.getElementsByTagName('is_PreviewIt')) === 'true';
    lm.hasSRRecognizeIt = getNodeValue(nodes.getElementsByTagName('is_SR_RecognizeIt')) === 'true';
    lm.hasWrittenRecognizeIt = getNodeValue(nodes.getElementsByTagName('is_Written_RecognizeIt')) === 'true';
    lm.hasSRProduceIt = getNodeValue(nodes.getElementsByTagName('is_SR_ProduceIt')) === 'true';
    lm.hasWrittenProduceIt = getNodeValue(nodes.getElementsByTagName('is_Written_ProduceIt')) === 'true';
  }
  return lm;
}
function parseCards(cards, bykiList, rootPath, isTranslit) {
  const parsedCards = [];
  let nf = null;
  const tagPat = /tagalog/ig;
  const vietPat = /vietnamese/ig;
  const yorubaPat = /yoruba/ig;
  if (tagPat.test(bykiList.side2Lang) || yorubaPat.test(bykiList.side2Lang)) {
    nf = normalizeTagalog;
  } else if (vietPat.test(bykiList.side2Lang)) {
    nf = normalizeVietnamese;
  }
  const len = cards.length,
    hids = [];
  for (let i = 0; i < len; i++) {
    const card = cards[i];
    let bc = parseCard(card, bykiList, rootPath, isTranslit);
    if (hids.includes(bc.hid)) {
      let s2 = bykiList.side2Lang;
      if (isTranslit && s2.substr(0, 2) !== 'T_') {
        s2 = 'T_' + s2;
      }
      bc.hid = createHid(bc.cardSide1Text + (bc.cardSide1Hint || 'duplicate hid'), bc.cardSide2Text + (bc.cardSide2Hint || 'duplicate hid'), bykiList.side1Lang, s2);
    }
    hids.push(bc.hid);
    if (nf !== null) {
      bc = nf(bc);
    }
    bc = normalizeEllipsis(bc);
    parsedCards.push(bc);
  }
  bykiList.cards = parsedCards;
  return bykiList;
}
function parseCard(card, bykiList, rootPath, isTranslit) {
  const bc = new BykiCard();
  const pattern = /\s|u+200B/g;
  bc.cardSide1Text = getNodeValue(card.getElementsByTagName('side1_phrase'));
  bc.description = getNodeValue(card.getElementsByTagName('description')) || '';
  const textValue = getNodeValue(card.getElementsByTagName('side2_phrase'));
  const translitValue = getNodeValue(card.getElementsByTagName('side2_transliteration'));
  if (isTranslit && translitValue) {
    bc.cardTranslit = textValue;
  } else {
    bc.cardSide2Text = textValue;
  }
  try {
    bc.sideTwoWordCount = bc.cardSide2Text.split(pattern).length + 1;
  } catch (e) {}
  let asset = card.getElementsByTagName('side1_sound')[0];
  let url = asset ? asset.getAttribute('url') : null;
  if (url) {
    bc.soundSide1 = rootPath + url;
  }
  asset = card.getElementsByTagName('side2_sound')[0];
  url = asset ? asset.getAttribute('url') : null;
  if (url) {
    bc.soundSide2 = rootPath + url;
  }
  asset = card.getElementsByTagName('side2_picture')[0];
  if (asset) {
    url = asset.getAttribute('url');
    if (url) {
      bc.picture = rootPath + url;
    }
    bc.pictureInfo = getNodeValue([asset]);
    if (asset.hasAttribute('sourceName')) {
      bc.sourceName = asset.getAttribute('sourceName');
    }
    if (asset.hasAttribute('sourceUrl')) {
      bc.sourceUrl = asset.getAttribute('sourceUrl');
    }
  }
  bc.cardSide1Hint = getNodeValue(card.getElementsByTagName('side1_hint'));
  bc.cardSide2Hint = getNodeValue(card.getElementsByTagName('side2_hint'));
  bc.side2AltPhrase = getNodeValue(card.getElementsByTagName('alternative_side2_phrase'));
  if (isTranslit && textValue) {
    bc.cardSide2Text = translitValue;
  } else {
    bc.cardTranslit = translitValue;
  }
  bc.cardPosition = +getNodeValue(card.getElementsByTagName('list_position'));
  bc.cardComment = getNodeValue(card.getElementsByTagName('comment'));
  bc.cardGuid = getNodeValue(card.getElementsByTagName('guid'));
  bc.cardGuid = bc.cardGuid.replace(/^\{/g, '').replace(/\}$/g, '');
  bc.side1AltAnswers = parseAlternative(card.getElementsByTagName('side1_alt_answers'));
  bc.side2AltAnswers = parseAlternative(card.getElementsByTagName('side2_alt_answers'));
  bc.hid = card.hid || '';
  if (!bc.hid) {
    let s2 = bykiList.side2Lang;
    if (isTranslit && s2.substr(0, 2) !== 'T_') {
      s2 = 'T_' + s2;
    }
    bc.hid = createHid(bc.cardSide1Text, bc.cardSide2Text, bykiList.side1Lang, s2);
  }
  bc.prompt = getNodeValue(card.getElementsByTagName('prompt'));
  return bc;
}
function parseAlternative(nodes) {
  const res = [];
  const node = nodes.length > 0 ? nodes[0] : null;
  if (node) {
    const altNodes = node.getElementsByTagName('alt_answer');
    for (const altNode of altNodes) {
      if (altNode.childNodes && altNode.childNodes.length > 0) {
        const child = altNode.childNodes[0];
        const str = normalizeString(child.nodeValue || child.textContent);
        res.push(str);
      }
    }
  }
  return res.length > 0 ? res : null;
}

/**
 * Normalize which button pressed for mouse event
 */
function getWhich(evt) {
  const btn = evt.button;
  if (isNaN(evt['which']) || !evt['which']) {
    if (!isNaN(btn) && btn !== null) {
      if (btn & 1) {
        return 1;
      }
      if (btn & 2) {
        return 3;
      }
      if (btn & 4) {
        return 2;
      }
    }
    return 0;
  }
  return evt['which'];
}
function getCoordinates(evt) {
  const touches = evt.touches && evt.touches.length ? evt.touches : [evt];
  return evt.changedTouches && evt.changedTouches[0] || evt.originalEvent && evt.originalEvent.changedTouches && evt.originalEvent.changedTouches[0] || touches[0].originalEvent || touches[0];
}
/**
 * For shortcuts
 */
function createMouseEvent(type) {
  const event = document.createEvent('MouseEvent');
  event.initEvent(type, true, true);
  return event;
}
function preventEvent(evt) {
  if (!evt) {
    return;
  }
  safePreventDefault(evt);
  if (typeof evt.stopPropagation === 'function') {
    evt.stopPropagation();
  }
  if (typeof evt.stopImmediatePropagation === 'function') {
    evt.stopImmediatePropagation();
  }
  if (evt.hasOwnProperty('returnValue')) {
    evt.returnValue = false;
  }
}
function safePreventDefault(evt) {
  if (typeof evt.preventDefault === 'function') {
    if ('cancelable' in evt && (typeof evt.cancelable !== 'boolean' || evt.cancelable)) {
      evt.preventDefault();
    } else {
      /* try { // Ignored attempt to cancel a touchmove because scrolling is in progress
           evt.preventDefault();
       } catch (e) {
       }*/
    }
  }
}
let ActivityMode = /*#__PURE__*/(() => {
  class ActivityMode {
    /**
     * Activity running in reference mode doesn't display complete dialog.
     */
    static {
      this.REFERENCE_MODE = 'reference';
    }
    /**
     * Regular activity mode.
     */
    static {
      this.LEARNING_MODE = 'learning';
    }
  }
  return ActivityMode;
})();
class ActivityConfig {
  constructor() {
    this.alphabetRange = '';
    this.alphabetMode = '';
    this.mode = 'learning';
    /**
     * Enables auto Fill-In-The-Blank content parsing for activity
     */
    this.autoFITB = false;
    /**
     * Used for showing Done(Close) button on the activity view
     */
    this.showDoneButton = false;
    /**
     * Enables seekingGame mode for activity. Phrase Map only.
     */
    this.seekingGame = false;
    /**
     * Used for describing learning direction(known > learning or learning > known)
     */
    this.learnDirection = null;
    /**
     * Enable speechRecognition
     */
    this.speech = false;
    /**
     * Determines the score the user must earn for all items in order to complete the activity
     */
    this.maxScore = 2;
    /**
     * Previous score of the letter
     */
    this.learnedLetterScore = 0;
    /**
     * Maximum number of items per activity.
     */
    this.maxItems = 0;
    this.partsOfSpeech = true;
    this.referencedBy = true;
    /**
     * For an LG request, LEGHTML-2270, we need a flag in either the unit xml or activity xml to disable the translation pop up.
     */
    this.autoTranslate = false;
    /**
     * In Dictation remove single word functionality when beginnerMode is off
     */
    this.beginnerMode = false;
    this.isCustom = false;
    /**
     *
     * Flag for showing video subtitles
     */
    this.captionControl = false;
    /**
     * Used for showing Easy Type button on the activity view
     */
    this.easyType = false;
    /**
     * Used for detecting assignment activities
     */
    this.linkType = '';
    /**
     * Used for showing "fingerSpelling" mode
     * This mode prompts learners to produce the fingerSpelling of items
     * (i.e. sign each individual letter rather than the word/phrase as a whole).
     */
    this.fingerSpelling = false;
    /**
     * https://transparentlanguage.atlassian.net/browse/HTML-17014
     * It can be “combined character” mode or “individual character” mode
     * COMBINED_CHARACTER or INDIVIDUAL_CHARACTER
     */
    this.typingMode = '';
    /**
     * https://transparentlanguage.atlassian.net/browse/HTML-17014
     *  Disable keypad accent bar
     */
    this.disableAccentBar = false;
    /**
     * https://transparentlanguage.atlassian.net/browse/HTML-17108
     *  Visualize sound on the wave form
     */
    this.soundVisualization = false;
  }
  /**
   *
   */
  static fromJson(json) {
    const activityConfig = new ActivityConfig();
    const mode = json._mode;
    if (mode === ActivityMode.LEARNING_MODE || mode === ActivityMode.REFERENCE_MODE) {
      activityConfig.mode = mode;
    }
    activityConfig.autoFITB = json._autoFITB === true;
    activityConfig.showDoneButton = json._hasDoneButton === true;
    activityConfig.seekingGame = json._seekGame === true;
    activityConfig.learnedLetterScore = json._learnedLetterScore;
    return activityConfig;
  }
}
let AlternativeAnswerVO = /*#__PURE__*/(() => {
  class AlternativeAnswerVO {
    constructor() {
      /**
       * Card ID.
       */
      this.id = 0;
    }
    /**
     * Know side alternative answer.
     */
    static {
      this.KNOW_IT = 'KNOW_IT';
    }
    /**
     * Own side alternative answer.
     */
    static {
      this.OWN_IT = 'OWN_IT';
    }
  }
  return AlternativeAnswerVO;
})();
class AssessmentAnswerItem {
  constructor(text, align, className) {
    this.text = text;
    this.align = align;
    this.className = className;
    this.fontSize = 0;
    this.direction = 'ltr';
  }
}
class ConfigurationVO {
  constructor() {
    /**
     * Alphabet URL for In-Activity Alphabet Explosion.
     */
    this.alphabetUrl = null;
    this.arabicFont = 'Arabic';
    /**
     * easyType switch
     */
    this.easyType = false;
    /**
     * Skill which is learned by activity
     */
    this.activitySkill = null;
    /**
     * Path to Sound server
     */
    this.soundServer = null;
    /**
     * Property isRefreshMode indicates that if is activity running in MLI refresh mode
     */
    this.isRefreshMode = false;
    this.isSoundServerAvailable = false;
    /**
     * Property name of current user if it is available
     * This property is not null if there wrapper can get user name.
     * We can retrieve it in scrom but not in standalone mode
     */
    this.userName = null;
    /**
     *  User uuid retrieves from Mon-E
     */
    this.userUUID = '';
    /**
     * activity uuid
     */
    this.activityUUID = '';
    /**
     * activity background image url
     */
    this.activityBackground = null;
    /**
     * Name of activity defined in unit xml, if empty set to default activity name form resource
     */
    this.activityName = null;
    /**
     * Name of activity defined in unit xml, if empty set to default activity name form en_US resource
     */
    this.activityNameForReport = '';
    /**
     * Embedded font family name used for transliterated content
     */
    this.translitFontFamily = null;
    /**
     * Embedded font family name used for user interface elements
     */
    this.uiFontFamily = null;
    /**
     * Embedded font family name used for displaying known font content
     */
    this.knownFontFamily = null;
    /**
     * Returns whether the language is right-to-left
     */
    this.languageIsRtl = false;
    /**
     * Embedded font family name used for displaying learning font content
     */
    this.learningFontFamily = null;
    /**
     * Text Direction for known text, "ltr" or "rtl"
     */
    this.knownDirection = null;
    /**
     * Text Direction for learning text, "ltr" or "rtl"
     */
    this.learningDirection = null;
    /**
     * Text Direction for ui text, "ltr" or "rtl"
     */
    this.uiDirection = null;
    /**
     * TL language code for UI
     */
    this.uiLanguageCode = null;
    /**
     * Name of ui langauge
     */
    this.uiLanguage = null;
    /**
     * Used for mark learned data as transliterated
     */
    this.isTransliterated = null;
    /**
     * Sound volume, values from 0..1
     */
    this.volume = 0.75;
    /**
     * Slow Sound volume, values from
     *  0..1 - slower
     *  1 - normal
     *  1..  - faster
     */
    this.soundSpeed = 0;
    /**
     * Used for ignoring English Capitals/Punctuation
     */
    this.ignore = null;
    /**
     * Used for Diacritics ignoring for RTL languages
     */
    this.ignoreDiacritics = null;
    /**
     * Activity data.
     */
    this.data = null;
    /**
     * Current position
     */
    this.position = 0;
    /**
     * Correct answer count
     */
    this.correct = 0;
    /**
     * Total count
     */
    this.total = 0;
    /**
     * The list of url that specified for Activity.
     *
     * <p><b>Note</b>= Support of the multimple data sources is a
     * requirements of <i>feature request</i> IXT-6494.</p>
     *
     * see http=//jira.transparent.com=8081/browse/IXT-6494 IXT-6494 Feature Request
     */
    this.dataURLs = [];
    /**
     * Activity mode. (activity specific)
     */
    this.mode = null;
    this.locale = null;
    /**
     *
     */
    this.showHints = false;
    /**
     *
     */
    this.minScore = 0;
    /**
     *
     */
    this.minItems = 0;
    /**
     *
     */
    this.maxItems = 0;
    /**
     * Number of items needed for learning or assessment.
     */
    this.items = 0;
    this.numPoints = 0;
    /**
     *
     */
    this.muted = false;
    /**
     *
     */
    this.knownLanguage = null;
    /**
     *
     */
    this.learningLanguage = null;
    this.captionControl = false;
    this.showIndicationPattern = false;
    /**
     *
     */
    this.knownLanguageCode = null;
    /**
     *
     */
    this.learningLanguageCode = null;
    /**
     *
     */
    this.totalAssessmentActivities = 0;
    this.totalActivities = 0;
    this.totalCompleted = 0;
    /**
     *
     */
    this.tempoEnabled = false;
    /**
     *
     */
    this.isAssessment = false;
    /**
     *
     */
    this.isServerMode = false;
    /**
     * Number of progress before current session.
     */
    this.assessmentTotal = 0;
    /**
     * Number of progress after current session.
     */
    this.progressBefore = 0;
    /**
     * Contains activty config
     */
    this.activityConfig = null;
    /**
     *
     */
    this.hasScriptAssistant = false;
    /**
     *
     */
    this.soundEffectsEnabled = true;
    this.url = null;
    this.rootDataPath = '';
    this.activityStatus = null;
    /**
     * Custom description for activity
     */
    this.activityDescription = null;
    /**
     * Show challenge timer popup
     */
    this.showChallengeTimer = true;
    /**
     * Show start screen of activity. Default true
     */
    this.showStartScreen = true;
    /**
     * URL of Language Data Service
     */
    this.LDSUrl = '//lds.transparent.com/';
    /**
     * Flag indication if activity is a reference activity
     */
    this.isReference = false;
    /**
     * Short name of learning language
     */
    this.learningShortName = null;
    /**
     * Short name of known language
     */
    this.knownShortName = null;
    /**
     * Flag to show or hide keyboard on start
     */
    this.isKeyboardVisible = false;
    /**
     * Flag for show state of IME popup
     */
    this.wasIMEPopupShown = false;
    /**
     * Flag for which ime to use
     */
    this.useSystemIme = false;
    /**
     * Font sizes
     */
    this.knownFontSize = 18;
    /**
     *
     */
    this.learningFontSize = 18;
    /**
     *
     */
    this.translitFontSize = 18;
    /**
     * isMone
     */
    this.isMone = false;
    this.learningLanguageIsLatin = false;
    this.knownLanguageIsLatin = false;
    this.isHardModeEnabled = false;
    /**
     * Auto speech recognition
     */
    this.asr = false;
    this.knownEasyType = false;
    this.isDailyRefresher = false;
    this.rememberIt = 'none';
    this.isGameMode = false;
    this.skipHearingActivities = false;
    this.hearingState = null;
    this.useLetterWriter = false;
    this.disableRightClick = true;
    this.copyrightString = '';
    this.isAssignmentPlayer = false;
    this.disableSingleCharsHotKey = false;
    this.showTimer = false;
    this.challengesTime = ''; // "04:00,03:30,02:00,05:00"
  }
}

class LanguagePairVO {
  label() {
    return this.learnLabel + ' for ' + this.knownLabel + ' Speakers';
  }
  toString() {
    return ' Known Code: ' + this.knownCode + ', Learning Code: ' + this.learnCode;
  }
}
class ScoreVO {
  constructor() {
    this.data = [];
    this.position = 0;
    this.correct = 0;
    this.currentPoint = 0;
    this.incorrect = 0;
    /**
     * Current answers is correct or not for game
     */
    this.isCorrect = false;
    this.userAnswers = [];
    this.total = 0;
    this.totalPoints = 0;
  }
  toString() {
    if (this.totalPoints > 0) {
      return 'correct=' + this.correct + ',totalPoints=' + this.totalPoints + ',currentPoint=' + this.currentPoint;
    }
    return 'correct=' + this.correct + ',total=' + this.total + ',position=' + this.position;
  }
}
class TrackAnalyticsVO {
  constructor() {
    /**
     * Event or Timing
     */
    this.type = 'event';
    /**
     * Category
     */
    this.category = 'action';
    this.timingVar = null;
    this.timingValue = 0;
    /**
     * A string that is uniquely paired with each
     * category, and commonly used to define the
     * type of user interaction for the web object.
     */
    this.action = null;
    /**
     * An optional string to provide additional
     * dimensions to the event data.
     */
    this.label = null;
    /**
     * An integer that you can use to provide
     * numerical data about the user event.
     */
    this.value = 0;
  }
}
class UserAnswerVO {
  constructor(promptItem, answerItem, userItem, isCorrect, answersMap = null) {
    this.promptItem = promptItem;
    this.answerItem = answerItem;
    this.userItem = userItem;
    this.isCorrect = isCorrect;
    this.answersMap = answersMap;
  }
}

/**
 * Finds intersecting item from list of items
 */
function findDropTarget(dropItems, rect, byX = false, byY = false) {
  return dropItems.filter(item => intersectRect(item.bounds, rect, byX, byY))[0];
}
/**
 * Animates given element to given position
 */
function animateItem(element, duration, x, y) {
  return new Observable(observer => {
    const x2 = element.offsetLeft;
    const y2 = element.offsetTop;
    const left = x - x2;
    const right = y - y2;
    // calculate the speed of animation so the duration not to be more than given
    const width = window.innerWidth;
    const height = window.innerHeight;
    const maxAnimationDistance = Math.sqrt(Math.pow(width, 2) + Math.pow(height, 2));
    const pixelsPerSecond = Math.ceil(maxAnimationDistance / duration);
    const distance = Math.ceil(Math.sqrt(Math.pow(left, 2) + Math.pow(right, 2)));
    const minDuration = 150;
    const animationDuration = Math.max(Math.ceil(distance / pixelsPerSecond), minDuration);
    const ana = element['animate']([{
      transform: 'translate(0px,0px)'
    }, {
      transform: 'translate(' + left + 'px,' + right + 'px)'
    }], animationDuration);
    ana.onfinish = () => {
      ana.onfinish = null;
      observer.next(ana);
      observer.complete();
    };
    return () => {
      if (ana.pending) {
        ana.cancel();
        if (typeof ana.onfinish === 'function') {
          ana.onfinish(null);
        }
      }
    };
  });
}
/**
 * Checks two rectangles on intersection
 */
function intersectRect(r1, r2, byX = false, byY = false) {
  const firstWidth = r1.right - r1.left;
  const secondWidth = r2.right - r2.left;
  if (firstWidth > secondWidth) {
    r2.rigth = r2.right + (firstWidth - secondWidth);
  } else if (firstWidth < secondWidth) {
    r1.rigth = r1.right + (secondWidth - firstWidth);
  }
  const overlapsX = byX ? isXOverlap(r1, r2) : true;
  const overlapsY = byY ? isYOverlap(r1, r2) : true;
  return !(r2.left > r1.right || r2.right < r1.left || r2.top > r1.bottom || r2.bottom < r1.top) && overlapsX && overlapsY;
}
/**
 * Checks rects horizontal overlapping by half
 */
function isXOverlap(rect1, rect2) {
  const rect2half = rect2.right - (rect2.right - rect2.left) / 2;
  const cond1 = rect1.left < rect2half && rect1.left > rect2.left;
  const cond2 = rect1.right > rect2half && rect1.right < rect2.right;
  return cond1 ? !cond2 : cond2;
}
/**
 * Checks rects vertical overlapping by half
 */
function isYOverlap(rect1, rect2) {
  const rect2half = rect2.bottom - (rect2.bottom - rect2.top) / 2;
  const cond1 = rect1.top < rect2half && rect1.top > rect2.top;
  const cond2 = rect1.bottom > rect2half && rect1.bottom < rect2.bottom;
  return cond1 ? !cond2 : cond2;
}

/**
 * Normalize absolute url
 */
function getFullUrl(baseURL, dataUrl) {
  baseURL = baseURL || '';
  let pat = /^\.\.\//ig;
  if (pat.test(dataUrl)) {
    dataUrl = dataUrl.replace(pat, '');
    baseURL = baseURL.slice(0, -1);
    baseURL = baseURL.substring(0, baseURL.lastIndexOf('/') + 1);
  }
  pat = /^(https?|file)?(:)?\/\//;
  if (pat.test(dataUrl) || dataUrl.indexOf(baseURL) !== -1) {
    baseURL = '';
  }
  if (/alphabet\/$/.test(baseURL) && /^alphabet\//.test(dataUrl)) {
    baseURL = baseURL.slice(0, -1);
    baseURL = baseURL.substring(0, baseURL.lastIndexOf('/') + 1);
  }
  return dataUrl[0] === '/' && dataUrl[1] !== '/' ? dataUrl.substring(1) : baseURL + dataUrl;
}
/**
 * Unescape htm entities
 */
function unEscapeEntity(str) {
  return (str || '').replace(/&apos;/g, '\'').replace(/&quot;/g, '"').replace(/&gt;/g, '>').replace(/&lt;/g, '<').replace(/&amp;/g, '&');
}
/**
 *  Appends a slash at the end if it does not exists;
 */
function appendLastSlash(path) {
  return path.slice(-1) !== '/' ? path + '/' : path;
}
function isAbsoluteURL(url) {
  const pat = /^(http|https|file)?(:)?\/\//;
  return pat.test(url);
}
/**
 * Computes and return base url
 */
function getBaseUrl() {
  const pathName = window.location.pathname;
  const arr = pathName.split('/');
  if (arr.length === 2) {
    return window.location.href.replace(pathName, '') + '/';
  } else {
    const lp = pathName.substring(0, pathName.lastIndexOf('/') + 1);
    return (window.location.href.split(lp)[0] || '') + lp;
  }
}
/**
 * Computes and return base url
 */
function getCWBaseUrl() {
  const theBase = window.document.getElementsByTagName('base')[0];
  let href = theBase && theBase.href ? theBase.href : '';
  if (href) {
    const p = /\.html?/;
    if (p.test(href)) {
      href = href.split(p)[0];
      href = href.substring(0, href.lastIndexOf('/') + 1);
    }
    return appendLastSlash(href);
  } else {
    const pathName = window.location.pathname;
    const arr = pathName.split('/');
    href = window.location.href.replace(window.location.hash, '');
    if (arr.length === 2) {
      return appendLastSlash(href.replace(pathName, ''));
    } else {
      const lp = pathName.substring(0, pathName.lastIndexOf('/') + 1);
      return appendLastSlash((window.location.href.split(lp)[0] || '') + lp);
    }
  }
}
function getFullUrlOld(url, baseUrl) {
  const crossPat = /^\.\.\//g;
  if (isAbsoluteURL(url)) {
    return url;
  } else if (crossPat.test(url)) {
    url = url.replace(crossPat, '');
    const base = getModuleBaseUrl(baseUrl);
    return base + url;
  } else {
    return baseUrl + url;
  }
}
function getMediaBase(url, baseUrl) {
  const crossPat = /^\.\.\//g;
  if (isAbsoluteURL(url)) {
    return '';
  } else if (crossPat.test(url)) {
    url = url.replace(crossPat, '');
    const base = getModuleBaseUrl(baseUrl);
    return base + url.substring(0, url.indexOf('/') + 1);
  } else {
    return baseUrl;
  }
}
/**
 * Computes and return base url
 */
function getModuleBaseUrl(base) {
  base = base.slice(0, -2);
  return base.substring(0, base.lastIndexOf('/') + 1);
}
class ArrayUtil {
  static randomize(array) {
    const arr = array.concat();
    const res = [];
    while (arr.length > 0) {
      const rnd = Math.floor(Math.random() * arr.length);
      res.push(arr[rnd]);
      arr.splice(rnd, 1);
    }
    return res;
  }
}
/**
 * Shuffles array items
 */
function shuffleArray(arr) {
  for (let i = arr.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    const temp = arr[i];
    arr[i] = arr[j];
    arr[j] = temp;
  }
}
class CJKUtil {
  /**
   * Test for CJK Languages.
   */
  static isCJK(languageCode = '') {
    languageCode = languageCode.toUpperCase();
    return ['JAPANESE', 'JAPANESE_KANJI', 'T_JAPANESE', 'KOREAN', 'T_KOREAN', 'CHINESE', 'CHINESE PINYIN', 'CHINESE_PINYIN', 'T_CHINESE', 'MANDARIN', 'MANDARIN_TRADITIONAL', 'T_MANDARIN'].indexOf(languageCode) !== -1;
  }
  /**
   * Test for Chinese Japanese but not Korean languages.
   */
  static isCJnotK(languageCode = '') {
    languageCode = languageCode.toUpperCase();
    return ['JAPANESE', 'JAPANESE_KANJI', 'T_JAPANESE', 'CHINESE', 'CHINESE PINYIN', 'CHINESE_PINYIN', 'T_CHINESE', 'MANDARIN', 'MANDARIN_TRADITIONAL', 'T_MANDARIN'].indexOf(languageCode) !== -1;
  }
  /**
   * Test for Chinese and Korean languages.
   */
  static isCK(languageCode = '') {
    languageCode = languageCode.toUpperCase();
    return ['CHINESE', 'CHINESE PINYIN', 'CHINESE_PINYIN', 'MANDARIN', 'MANDARIN_TRADITIONAL', 'KOREAN'].indexOf(languageCode) !== -1;
  }
  /**
   * Test for Chinese and Korean languages.
   */
  static isChinese(languageCode = '') {
    languageCode = languageCode.toUpperCase();
    return ['CHINESE', 'CHINESE PINYIN', 'CHINESE_PINYIN', 'MANDARIN', 'MANDARIN_TRADITIONAL'].indexOf(languageCode) !== -1;
  }
  /**
   * Test for Japanese language.
   */
  static isJapanese(languageCode = '') {
    languageCode = languageCode.toUpperCase();
    return ['JAPANESE', 'JAPANESE_KANJI'].indexOf(languageCode) !== -1;
  }
  /**
   * Test for CJK Languages.
   */
  static isCJKFont(fontName = '') {
    const pat = /Chinese|Japanese|Korean/g;
    return pat.test(fontName);
  }
  /**
   * While in a script learning language, the display of transliterated text will be removed
   */
  static showTransliterated(learningLanguageCode, isTransliterated) {
    return CJKUtil.isCJK(learningLanguageCode) || isTransliterated;
  }
}

/**
 * Gets SCORM API
 */
function getAPI() {
  let API;
  try {
    API = scanParentsForApi(window);
    if (API === null && window.parent !== null && window.parent !== window) {
      API = scanParentsForApi(window.parent);
    }
    if (API === null && window.top.opener !== null) {
      API = scanParentsForApi(window.top.opener);
    }
    if (API === null && window.opener !== null) {
      API = scanParentsForApi(window.opener);
    }
  } catch (e) {
    API = null;
  }
  return API;
}
/**
 * Searches parent window for SCORM API
 */
function scanParentsForApi(win) {
  let nParentsSearched = 0,
    API = null;
  try {
    while (win.API_1484_11 === null && win.API == null && win.parent !== null && win.parent !== win && nParentsSearched <= MAX_PARENTS_TO_SEARCH) {
      nParentsSearched++;
      win = win.parent;
    }
    if (typeof win.API_1484_11 !== 'undefined' && win.API_1484_11 !== null) {
      API = win.API_1484_11;
    } else if (typeof win.API !== 'function' && typeof win.API !== 'undefined' && win.API !== null) {
      API = win.API;
    }
  } catch (e) {
    API = null;
  }
  return API;
}
const win = window;
const doc = document;
const OS = [{
  name: 'Windows Phone',
  value: 'Windows Phone',
  version: 'OS'
}, {
  name: 'Windows',
  value: 'Win',
  version: 'NT'
}, {
  name: 'iOS',
  value: 'iPhone',
  version: 'OS'
}, {
  name: 'iOS',
  value: 'iPad',
  version: 'OS'
}, {
  name: 'Kindle',
  value: 'Silk',
  version: 'Silk'
}, {
  name: 'Android',
  value: 'Android',
  version: 'Android'
}, {
  name: 'PlayBook',
  value: 'PlayBook',
  version: 'OS'
}, {
  name: 'BlackBerry',
  value: 'BlackBerry',
  version: '/'
}, {
  name: 'Mac',
  value: 'Mac',
  version: 'OS X'
}, {
  name: 'Linux',
  value: 'Linux',
  version: 'rv'
}, {
  name: 'Palm',
  value: 'Palm',
  version: 'PalmOS'
}, {
  name: 'Chrome OS',
  value: 'CrOS',
  version: 'x86_64'
}];
const BROWSERS = [{
  name: 'Chrome',
  value: 'Chrome',
  version: 'Chrome'
}, {
  name: 'Firefox',
  value: 'Firefox',
  version: 'Firefox'
}, {
  name: 'Safari',
  value: 'Safari',
  version: 'Version'
}, {
  name: 'Internet Explorer',
  value: 'MSIE',
  version: 'MSIE'
}, {
  name: 'Opera',
  value: 'Opera',
  version: 'Opera'
}, {
  name: 'BlackBerry',
  value: 'CLDC',
  version: 'CLDC'
}, {
  name: 'Mozilla',
  value: 'Mozilla',
  version: 'Mozilla'
}];
/* eslint-disable */
class CWDetection {
  static {
    this.iosPat = new RegExp('(iPhone|iPod|iPad).*AppleWebKit.*(?!.*Safari)/', 'i');
  }
  static {
    this.isPhone = window.innerWidth <= 768;
  }
  static {
    this.ua = window.navigator.userAgent.toLowerCase();
  }
  static {
    this.isWindows = window.navigator.platform.toUpperCase().includes('WIN32');
  }
  static {
    this.isAndroid = CWDetection.ua.includes('android');
  }
  static {
    this.isEdge = CWDetection.ua.includes('edge');
  }
  static {
    this.oculusPat = new RegExp('Pacific.+OculusBrowser.+SamsungBrowser.+VR', 'i');
  }
  static {
    this.isOculus = CWDetection.oculusPat.test(window.navigator.userAgent);
  }
  static {
    this.isChrome = !!win.chrome || CWDetection.ua.includes('chrome') || CWDetection.ua.includes('crios');
  }
  static {
    this.isIOS13 = CWDetection.ua.includes('mac') && navigator.maxTouchPoints > 1;
  } // workaround for detect iOS in iPad
  static {
    this.isIOS = CWDetection.iosPat.test(CWDetection.ua) || CWDetection.isIOS13;
  }
  static {
    this.isMac = !CWDetection.isIOS && window.navigator.platform.toUpperCase().includes('MAC');
  }
  static {
    this.isMobile = CWDetection.isAndroid || CWDetection.isIOS;
  }
  static {
    this.isIPad = CWDetection.isIOS && CWDetection.ua.includes('ipad');
  }
  static {
    this.isSafari = CWDetection.ua.includes('safari') && (CWDetection.isWindows ? CWDetection.isIOS : !CWDetection.isChrome);
  }
  static {
    this.isOpera = !win.opera || CWDetection.ua.includes('opera');
  }
  static {
    this.isFirefox = 'InstallTrigger' in window || CWDetection.ua.includes('firefox');
  }
  static {
    this.isIE = typeof doc.documentMode !== 'undefined';
  }
  static {
    this.isIE9 = !isNaN(doc.documentMode) && doc.documentMode <= 9;
  }
  /**
   * Utility method for finding mobile webview recorder
   */
  static getIsNative(wind) {
    if (wind.upAudioPlayer || wind.upSoundRecorder) {
      return true;
    }
    if (CWDetection.isWebApp) {
      const api = getAPI();
      if (api && typeof api.getExtension === 'function') {
        wind.upSoundRecorder = api.getExtension(SOUND_RECORDER); // Hybrid app only
        return !!(wind.upAudioPlayer || wind.upSoundRecorder);
      } else if (win.CWAPI?.soundRecorder) {
        wind.upSoundRecorder = win.CWAPI.soundRecorder; // Hybrid app only
        return !!(wind.upAudioPlayer || wind.upSoundRecorder);
      }
    }
    return false;
  }
  static getOS() {
    return CWDetection.matchItemsOnUserAgent(OS).name;
  }
  static getOSVersion() {
    return CWDetection.matchItemsOnUserAgent(OS).version;
  }
  static getBrowser() {
    return CWDetection.matchItemsOnUserAgent(BROWSERS).name;
  }
  static getBrowserVersion() {
    return CWDetection.matchItemsOnUserAgent(BROWSERS).version;
  }
  static safariVersion() {
    const ua = window.navigator.userAgent;
    const arr = ua.match(/version\/\d+/ig) || [CWDetection.isIOS && CWDetection.isSafari ? 'Version/16.5' : ''];
    return +arr[0].replace(/version\//i, '');
  }
  static iosVersion() {
    if (!CWDetection.iosPat.test(CWDetection.ua) && CWDetection.isIOS13) {
      return CWDetection.safariVersion();
    }
    const matchArr = window.navigator.userAgent.match(/OS (\d+)/);
    return +(matchArr || ['0', '0'])[1];
  }
  static {
    this.webAppPat = new RegExp('WebApp *(CL-150|TL)', 'i');
  }
  static {
    this.isWebApp = CWDetection.webAppPat.test(CWDetection.ua);
  }
  static {
    this.isNative = CWDetection.getIsNative(window);
  }
  static {
    this.isModernSafari = CWDetection.isSafari && CWDetection.safariVersion() >= 11;
  }
  static {
    this.isModernIOS = CWDetection.isIOS && CWDetection.iosVersion() >= 11;
  }
  static {
    this.IOSVersion = CWDetection.iosVersion();
  }
  static {
    this.isTouchScreen = 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator['msMaxTouchPoints'] > 0;
  }
  static {
    this.isForcedResponsive = false;
  } // must be set from upConfig on startup
  static matchItemsOnUserAgent(arr) {
    const uAgent = navigator.platform + ' ' + navigator.userAgent;
    let i = 0,
      j = 0,
      regex,
      regexv,
      match,
      matches,
      version;
    for (i = 0; i < arr.length; i += 1) {
      regex = new RegExp(arr[i].value, 'i');
      match = regex.test(uAgent);
      if (match) {
        regexv = new RegExp(arr[i].version + '[- /:;]([\\d._]+)', 'i');
        matches = uAgent.match(regexv);
        version = '';
        if (matches) {
          if (matches[1]) {
            matches = matches[1];
          }
        }
        if (matches) {
          matches = matches.split(/[._]+/);
          for (j = 0; j < matches.length; j += 1) {
            if (j !== matches.length - 1) {
              version += matches[j] + '.';
            } else {
              version += matches[j];
            }
          }
        } else {
          version = '0';
        }
        return {
          name: arr[i].name,
          version: version
        };
      }
    }
    return {
      name: 'unknown',
      version: '0'
    };
  }
}
class ElementUnderPoint {
  static getElementUnderPoint(el, x, y, className) {
    const arr = el.getElementsByClassName(className);
    for (let i = 0; i < arr.length; i++) {
      const item = arr[i];
      const top = +item.style.top;
      const left = +item.style.left;
      const width = item.clientWidth + left;
      const height = item.clientHeight + top;
      if (y >= top && y <= height && x >= left && x <= width) {
        return item;
      }
    }
    return null;
  }
}
let FontSizeConstants = /*#__PURE__*/(() => {
  class FontSizeConstants {
    /**
     * Array object of Languages.
     */
    static {
      this.getForLanguage = {
        Amharic: {
          min: 12,
          default: 18,
          defaultVR: 16,
          max: 72
        },
        Arabic: {
          min: 18,
          default: 24,
          defaultVR: 22,
          max: 72
        },
        Armenian: {
          min: 16,
          default: 20,
          defaultVR: 16,
          max: 72
        },
        Baluchi: {
          min: 18,
          default: 24,
          defaultVR: 22,
          max: 72
        },
        Bambara: {
          min: 12,
          default: 18,
          defaultVR: 14,
          max: 72
        },
        Bengali: {
          min: 24,
          default: 30,
          defaultVR: 18,
          max: 72
        },
        Chinese: {
          min: 20,
          default: 26,
          defaultVR: 18,
          max: 72
        },
        SimHei: {
          min: 20,
          default: 26,
          defaultVR: 18,
          max: 72
        },
        Georgian: {
          min: 16,
          default: 22,
          defaultVR: 18,
          max: 72
        },
        Hebrew: {
          min: 18,
          default: 24,
          defaultVR: 22,
          max: 72
        },
        Hindi: {
          min: 18,
          default: 24,
          defaultVR: 18,
          max: 72
        },
        Japanese: {
          min: 16,
          default: 28,
          defaultVR: 20,
          max: 72
        },
        Korean: {
          min: 22,
          default: 28,
          defaultVR: 20,
          max: 72
        },
        Latin: {
          min: 12,
          default: 18,
          defaultVR: 14,
          max: 72
        },
        Pashto: {
          min: 18,
          default: 24,
          defaultVR: 22,
          max: 72
        },
        Persian: {
          min: 18,
          default: 24,
          defaultVR: 22,
          max: 72
        },
        Punjabi: {
          min: 18,
          default: 24,
          defaultVR: 22,
          max: 72
        },
        Telugu: {
          min: 16,
          default: 22,
          defaultVR: 22,
          max: 72
        },
        Thai: {
          min: 16,
          default: 22,
          defaultVR: 18,
          max: 72
        },
        Tibetian: {
          min: 16,
          default: 22,
          defaultVR: 22,
          max: 72
        },
        Urdu: {
          min: 18,
          default: 24,
          defaultVR: 22,
          max: 72
        }
      };
    }
    /**
     * Calculates rate for each platform.
     */
    static getRate() {
      const str = window.navigator.platform.toUpperCase();
      const isWin32 = str.indexOf('WIN32') !== -1 || str.indexOf('WIN64') !== -1;
      return isWin32 ? 96 / 72 : 1;
    }
    /**
     * Get minimum font size for selected language.
     */
    static getMin(font) {
      if (FontSizeConstants.getForLanguage[font]) {
        return FontSizeConstants.getRate() * FontSizeConstants.getForLanguage[font].min;
      } else {
        return FontSizeConstants.getRate() * 12;
      }
    }
    /**
     * Get minimum font size for selected language without rate
     */
    static getMinWithoutRate(font) {
      return FontSizeConstants.getForLanguage[font] ? FontSizeConstants.getForLanguage[font].min : 12;
    }
    /**
     * Get Maximum font size for selected language.
     */
    static getMax(font) {
      if (FontSizeConstants.getForLanguage[font]) {
        return FontSizeConstants.getRate() * FontSizeConstants.getForLanguage[font].max;
      } else {
        return FontSizeConstants.getRate() * 72;
      }
    }
    /**
     * Get default font size for selected Language
     */
    static getDefault(font) {
      if (FontSizeConstants.getForLanguage[font]) {
        return (/*FontSizeConstants.getRate() * */FontSizeConstants.getForLanguage[font].default
        );
      } else {
        return 18;
      }
    }
    /**
     * Get default font size for selected Language
     */
    static getDefaultForVR(font) {
      if (FontSizeConstants.getForLanguage[font]) {
        return FontSizeConstants.getForLanguage[font].defaultVR;
      } else {
        return 14;
      }
    }
  }
  return FontSizeConstants;
})();
/**
 * Gets the base  href from head base href attribute
 */
function getBaseHref() {
  const theBase = window.document.getElementsByTagName('base')[0];
  return theBase ? theBase.href || '' : '';
}
/**
 *  Appends a slash at the end if it does not exists;
 */
function normalizePath(path) {
  return path?.slice(-1) !== '/' ? path + '/' : path;
}
const japanesePat = /japanese/i;
/**
 * Gets easy type mode
 */
function getEasyMode(language, easyType, url, list, activity) {
  const alphabetMode = getAlphabetMode(url, list),
    cName = activity + 'EasyMode',
    isPhoneLayout = isMobileScaled() || window.screen.height > window.screen.width && window.screen.width < 768;
  let easyMode;
  if (alphabetMode || isPhoneLayout) {
    easyMode = isPhoneLayout;
  } else if (Cookie.get(cName)) {
    easyMode = Cookie.get(cName) === 'true';
  }
  if ((easyType || japanesePat.test(language) || CWDetection.isMobile) && typeof easyMode === 'undefined') {
    Cookie.set(cName, 'true');
    return [true, alphabetMode];
  }
  return [easyMode, alphabetMode];
}
function getAlphabetMode(url, list) {
  if (url && url.endsWith('.xml') && url.includes('alphabet')) {
    return true;
  } else if (list && list.name.includes('Alphabet')) {
    return true;
  }
  return false;
}
/**
 * Saves easy mode to cookie
 */
function saveEasyMode(value, activity) {
  const cName = activity + 'EasyMode';
  Cookie.set(cName, value + '');
}
/**
 * detect phone in landscape with text set to 200%
 */
function isMobileScaled() {
  return window.matchMedia('(orientation: landscape) and (max-height: 450px)').matches;
}
const DAY = 1000 * 86400;
function getFromLocalStorage(key) {
  if (window.localStorage) {
    const str = localStorage.getItem(key);
    if (str) {
      const obj = JSON.parse(str);
      if (new Date().getTime() - parseInt(obj.time, 10) > DAY) {
        localStorage.removeItem(key);
        return null;
      } else {
        return obj.data;
      }
    }
  }
  return null;
}
function setToLocalStorage(key, data) {
  if (window.localStorage) {
    const obj = {
      time: new Date().getTime(),
      data
    };
    try {
      localStorage.setItem(key, JSON.stringify(obj));
    } catch (e) {}
  }
}
function getJunction(win) {
  let junction;
  try {
    const parent = win.parent;
    junction = parent && parent.Junction ? parent.Junction : win.Junction;
  } catch (e) {}
  return junction;
}
let platform;
function openMobileLink(url, _target) {
  const win = window;
  if (typeof win.CWAPI?.platform?.openUrl === 'function') {
    win.CWAPI.platform.openUrl(url);
  } else {
    const api = getAPI();
    if (!platform && api && typeof api.getExtension === 'function') {
      platform = api.getExtension(PLATFORM) || {};
    }
    if (platform && typeof platform.openUrl === 'function') {
      platform.openUrl(url);
    } else {
      win.open(url, _target);
    }
  }
}

/**
 * Latin based languages
 */
const latinLanguages = ['AFRIKAANS', 'ALBANIAN', 'ASTURIAN', 'AYMARA', 'AZERBAIJANI', 'BAMBARA', 'BEMBA', 'BLACKFOOT', 'BOSNIAN', 'CEBUANO', 'CHAMORRO', 'CORNISH', 'CROATIAN', 'CZECH', 'DANISH', 'DUTCH', 'ENGLISH', 'ENGLISH_BRITISH', 'ESTONIAN', 'ECUADORIAN_QUECHUA', 'FAROESE', 'FINNISH', 'FRENCH', 'FRENCH_MOROCCAN', 'FRISIAN', 'GERMAN', 'HAITIAN_CREOLE', 'HUNGARIAN', 'ICELANDIC', 'INDONESIAN', 'INUKTITUT', 'IRISH', 'ITALIAN', 'ILOCANO', 'KONGO', 'LATIN', 'LATVIAN', 'LITHUANIAN', 'LUXEMBOURGISH', 'MALAY', 'MAORI', 'MAYA', 'MIRANDESE', 'NAHUATL', 'NORWEGIAN', 'NORTH_AFRICAN_FRENCH', 'PAPAGO', 'POLISH', 'PORTUGUESE_EUROPEAN', 'PORTUGUESE_BRAZILIAN', 'PROVENCAL', 'ROMANIAN', 'ROMANSCH', 'ROMANY', 'RUANDA', 'SAMOAN', 'SCOTTISH_GAELIC', 'SEPEDI', 'SHONA', 'SLOVAK', 'SICILIAN', 'SOMALI', 'SORBIAN', 'SPANISH', 'SPANISH_CASTILIAN', 'SPANISH_COLOMBIAN', 'SWAHILI', 'SWAZI', 'SWEDISH', 'TAGALOG', 'TAUSUG', 'TONGAN', 'TURKISH', 'TURKMEN', 'UZBEK_LATIN', 'WELSH', 'WOLOF', 'ZULU'];
class LanguageUtil {
  /**
   * Pass Language code or name to get isLatin boolean
   */
  static isLatin(language) {
    language = language.replace(',', '');
    return latinLanguages.indexOf(language) !== -1 || /TRANSLITERATED/.test(language);
  }
}
const CJ_FONT = 'SimHei';
/**
 * Replaces legacy  font name with new one
 */
function normalizeFontName(fontName) {
  switch (fontName) {
    case 'Bambara':
    case 'Cyrillic':
    case 'Greek':
    case 'English':
    case 'French':
    case 'German':
    case 'Italian':
    case 'Mongolian':
    case 'Polish':
    case 'Portuguese':
    case 'Romanian':
    case 'Russian':
    case 'Spanish':
    case 'Turkish':
      return 'Latin';
    case 'Punjabi':
      return 'Urdu';
    case 'Japanese':
    case 'Chinese':
      return CJ_FONT;
    // Chinese and Japanese
    default:
      return fontName;
  }
}
function normalizeFontNameForPdf(fontName, langCode) {
  fontName = normalizeFontName(fontName);
  if (CJ_FONT === fontName) {
    return getCJTtf(langCode);
  }
  return fontName;
}
/**
 * Font by code
 */
function getCJTtf(code) {
  switch (code) {
    case 'AMHARIC':
    case 'T_AMHARIC':
      return 'Amharic';
    case 'KOREAN':
    case 'T_KOREAN':
      return 'Korean';
    case 'JAPANESE':
    case 'JAPANESE_KANJI':
    case 'T_JAPANESE':
      return 'Japanese';
    case 'CHINESE':
    case 'CHINESE PINYIN':
    case 'CHINESE_PINYIN':
    case 'T_CHINESE':
    case 'MANDARIN':
    case 'MANDARIN_TRADITIONAL':
    case 'T_MANDARIN':
    case 'CANTONESE':
    default:
      return 'Chinese';
  }
}
/**
 * gel language code
 */
function getLanguageCode(font, config) {
  let code;
  if (font !== config.learningFontFamily && font !== config.knownFontFamily && font !== config.uiFontFamily) {
    font = config.learningFontFamily;
    code = config.learningLanguageCode;
  } else {
    code = config.learningFontFamily === font ? config.learningLanguageCode : config.knownFontFamily === font ? config.knownLanguageCode : config.uiLanguageCode;
  }
  return {
    code,
    font
  };
}

/**
 * Scrolls container by given amount of pixels while drag if element becomes closer to it
 */
function scrollContainer(element, container, step = 0, sensitivity = 10) {
  const elemBounds = element.getBoundingClientRect();
  const contBounds = container.getBoundingClientRect();
  const elementInContainer = intersectRect(elemBounds, contBounds) || step === 0;
  let scrolled = false;
  if (elementInContainer) {
    const contStyle = getComputedStyle(container, null);
    const contPadTop = getStyleValue(contStyle, 'paddingTop');
    if (elemBounds.top < contBounds.top + sensitivity) {
      container.scrollTop -= step === 0 ? contBounds.top - elemBounds.top + contPadTop : step;
      scrolled = true;
    }
    if (elemBounds.bottom > contBounds.bottom - sensitivity) {
      let offsetTop = element.offsetTop;
      if (element.nodeName === 'TD') {
        offsetTop = getOffsetTop(element);
      }
      const elementBottom = offsetTop + element.offsetHeight;
      const containerBottom = container.scrollTop + container.clientHeight;
      const elemStyle = getComputedStyle(element, null);
      const elemBorderTop = getStyleValue(elemStyle, 'borderTopWidth');
      const elemBorderBottom = getStyleValue(elemStyle, 'borderBottomWidth');
      container.scrollTop += step === 0 ? elementBottom - containerBottom + contPadTop + elemBorderTop + elemBorderBottom : step;
      scrolled = true;
    }
    if (elemBounds.left < contBounds.left + sensitivity) {
      container.scrollLeft += step === 0 ? elemBounds.left - contBounds.left : -step;
      scrolled = true;
    }
    if (elemBounds.right > contBounds.right - sensitivity) {
      container.scrollLeft += step === 0 ? elemBounds.left : step;
      scrolled = true;
    }
  }
  return scrolled;
}
function getStyleValue(styles, styleName) {
  return parseInt(styles[styleName], 10) || 0;
}
/**
 * get offset top
 */
function getOffsetTop(elem) {
  let y = elem.offsetTop;
  elem = elem.offsetParent;
  while (elem) {
    y += elem.offsetTop;
    elem = elem.offsetParent;
  }
  return y;
}
class Hmac {
  constructor(hasher, key, optBlockSize) {
    /**
     * The underlying hasher to calculate hash.
     */
    this.hasher = hasher;
    this.blockSize = optBlockSize || hasher.blockSize || 16;
    /**
     * The outer padding array of hmac
     */
    this.keyO = new Array(this.blockSize);
    /**
     * The inner padding array of hmac
     */
    this.keyI = new Array(this.blockSize);
    /**
     * Outer padding byte of HMAC algorithm, per http://en.wikipedia.org/wiki/HMAC
     */
    this.OPAD = 0x5c;
    /**
     * Inner padding byte of HMAC algorithm, per http://en.wikipedia.org/wiki/HMAC
     */
    this.IPAD = 0x36;
    this.initialize(key);
  }
  /**
   *
   */
  reset() {
    this.hasher.reset();
    this.hasher.update(this.keyI);
  }
  /**
   *
   */
  update(bytes, opt_length) {
    this.hasher.update(bytes, opt_length);
  }
  /**
   *
   */
  digest() {
    const temp = this.hasher.digest();
    this.hasher.reset();
    this.hasher.update(this.keyO);
    this.hasher.update(temp);
    return this.hasher.digest();
  }
  /**
   * Calculates an HMAC for a given message.
   */
  getHmac(message) {
    this.reset();
    this.update(message);
    return this.digest();
  }
  /**
   * Initializes Hmac by precalculating the inner and outer paddings.
   */
  initialize(key) {
    if (key.length > this.blockSize) {
      this.hasher.update(key);
      key = this.hasher.digest();
      this.hasher.reset();
    }
    // Precalculate padded and xor'd keys.
    let keyByte;
    for (let i = 0; i < this.blockSize; i++) {
      if (i < key.length) {
        keyByte = key[i];
      } else {
        keyByte = 0;
      }
      this.keyO[i] = keyByte ^ this.OPAD;
      this.keyI[i] = keyByte ^ this.IPAD;
    }
    // Be ready for an immediate update.
    this.hasher.update(this.keyI);
  }
}
class SCSUtil {
  static {
    this.stripTags = new RegExp('<\\/?[^>]+(>|$)', 'igm');
  }
  static {
    this.key = [0x2F, 0x11, 0xE4, 0x16, 0x0D, 0x59, 0x2F, 0x56, 0x2E, 0xC5, 0x81, 0x04, 0x64, 0x7B, 0xA8, 0xAB, 0x03, 0xC7, 0x26, 0xA1, 0x05, 0x9A, 0xE0, 0x1A, 0xF0, 0x3E, 0x83, 0xBD, 0x5D, 0x7E, 0xF0, 0x84, 0x92, 0x00, 0x40, 0x46, 0x5E, 0xDC, 0x04, 0x7E, 0x61, 0x1F, 0xEF, 0x82, 0xE1, 0x0A, 0xED, 0xE4, 0x4F, 0x67, 0xA3, 0x37, 0xB1, 0xD3, 0x70, 0x8E, 0xCB, 0x0F, 0x14, 0x55, 0x76, 0x77, 0x89, 0x23];
  }
  static computeHashInternal(side1, side2, hint1, hint2, l1, l2, modeDirection) {
    side1 = side1 || '';
    side2 = side2 || '';
    hint1 = hint1 || '';
    hint2 = hint2 || '';
    const workString = side1 + side2 + hint1 + hint2 + l1 + l2 + modeDirection;
    const sha1 = new Sha1();
    const ba = SCSUtil.toUtf8(workString); // flash compliance
    sha1.update(ba);
    const result = sha1.digest();
    return SCSUtil.byteArrayToString(result);
  }
  /**
   * replace text to Utf8
   */
  static toUtf8(str) {
    str = (str || '').replace(SCSUtil.stripTags, '');
    return encodeURIComponent(str);
  }
  /**
   * get Unix time
   */
  static getUNIXTime() {
    return Date.now() / 1000;
  }
  /**
   * create authentication ticket
   */
  static createAuthenticationTicket(resource, serverTimeOffset) {
    const utfBytes = resource.split('').map(item => {
      return item.charCodeAt(0);
    });
    const timestamp = SCSUtil.getUNIXTime() + serverTimeOffset; // 1392902575 test value
    const timeBytes = [];
    let c = timestamp;
    for (let i = 0; i < 4; i++) {
      const b = c & 0xff;
      timeBytes.unshift(b);
      c >>= 8;
    }
    const hmac = new Hmac(new Sha1(), SCSUtil.key);
    const ba = utfBytes.concat(timeBytes);
    const result = hmac.getHmac(ba);
    const total = utfBytes.concat(timeBytes).concat(result);
    return SCSUtil.byteArrayToString(total);
  }
  /**
   * Converts array of bytes to hex string
   */
  static byteArrayToString(ba) {
    let stringResult = '';
    let temp;
    // @ts-ignore
    for (const item of ba) {
      temp = item.toString(16);
      stringResult += temp.length === 1 ? '0' + temp : temp;
    }
    return stringResult;
  }
}
let ActivityStatus = /*#__PURE__*/(() => {
  class ActivityStatus {
    /**
     * PASSED: Necessary number of objectives in the SCO were mastered,
     * or the necessary score was achieved.
     * Student is considered to have completed the SCO and passed.
     */
    static {
      this.PASSED = 'passed';
    }
    /**
     * INCOMPLETE: The SCO was begun but not finished
     */
    static {
      this.INCOMPLETE = 'incomplete';
    }
    /**
     * COMPLETED: The SCO may or may note be passed, but all the elements in the SCO were experienced
     * by the student. The student is considered to have completed the SCO. For instance, passing may
     * depend on a certain score known to the LMS system. The SCO knows the raw score, but not whether
     * that raw score was high enough to pass.
     */
    static {
      this.COMPLETED = 'completed';
    }
    /**
     * FAILED: The SCO was not passed. All the SCO elements may or may not have been completed
     * by the student. The student is considered to have completed the SCO and failed.
     */
    static {
      this.FAILED = 'failed';
    }
    /**
     * BROWSED: The student launched the SCO with a LMS mode of "browse" on the initial attempt.
     */
    static {
      this.BROWSED = 'browsed';
    }
    /**
     * NOT_ATTEMPTED: Incomplete implies that the student made an attempt to perform the SCO, but
     * for some reason was unable to finish it. Not attempted means that the student
     * did not even begin the SCO. Maybe they just read the table of contents, or SCO abstract
     * and decided they were not ready. Any algorithm within the SCO may be used to determine
     * when the SCO moves from "not attempted" to "incomplete".
     */
    static {
      this.NOT_ATTEMPTED = 'not attempted';
    }
    /**
     *
     */
    static {
      this.NOT_STARTED = 'Not Started';
    }
    /**
     *
     */
    static {
      this.IN_PROGRESS = 'In Progress';
    }
  }
  return ActivityStatus;
})();
class StatusUtil {
  /**
   * Converts a status tring to an int value
   */
  static statusToInt(status) {
    // default is not attemted -4
    let intStat = 4;
    switch (status) {
      case ActivityStatus.BROWSED:
        intStat = 0;
        break;
      case ActivityStatus.COMPLETED:
        intStat = 1;
        break;
      case ActivityStatus.FAILED:
        intStat = 2;
        break;
      case ActivityStatus.INCOMPLETE:
        intStat = 3;
        break;
      case ActivityStatus.NOT_ATTEMPTED:
        intStat = 4;
        break;
      case ActivityStatus.PASSED:
        intStat = 5;
        break;
    }
    return intStat;
  }
  /**
   * Converts an int status value to its string representation
   */
  static intToStatus(intStat) {
    let strState = ActivityStatus.NOT_ATTEMPTED;
    switch (intStat) {
      case 0:
        strState = ActivityStatus.BROWSED;
        break;
      case 1:
        strState = ActivityStatus.COMPLETED;
        break;
      case 2:
        strState = ActivityStatus.FAILED;
        break;
      case 3:
        strState = ActivityStatus.INCOMPLETE;
        break;
      case 4:
        strState = ActivityStatus.NOT_ATTEMPTED;
        break;
      case 5:
        strState = ActivityStatus.PASSED;
        break;
    }
    return strState;
  }
}
class StringUtil {
  /* eslint-disable max-len */
  static {
    this.PUNCT_PAT = new RegExp('[\u0022\u002D\u005D\u005B\u005C\u0021\u0023\u0024\u0025\u0026\u0028\u0029\u002A\u002B\u002C\u002E\u003A\u003B\u003C\u003D\u003E\u003F\u0040\u005E\u005F\u0060\u007E\u007C\u007B\u007D\u002F\u2026\u2013\u2014\u2015\u2000\u00A0\u02C6\u02C7\u02C9\u02D8\u02D9\u02DA\u02DB\u02DC\u02DD\u060C\u061B\u061F\u061E]+.', 'gm');
  }
  /**
   * Returns a string consisting of a specified string concatenated with itself a specified number of times.
   */
  static repeat(value, n) {
    let s = '';
    let stat = true;
    while (stat) {
      s = n & 1 ? s + value : s;
      n >>= 1;
      n ? value += value : stat = false;
    }
    return s;
  }
  /**
   * Helper function for adding prepend to spesial diacritic arabic symbols.
   */
  static prependTatweel(value) {
    const pat = /^[\u064B\u064C\u064D\u064E\u064F\u0650\u0651\u0659\u0652\u0670\u0640]/g;
    return pat.test(value) && value.length === 1 ? '\u0640' + value : value;
  }
}
let XMLUtil = /*#__PURE__*/(() => {
  class XMLUtil {
    /**
     * Supported xml attributes
     * position: string, paddingLeft: string, paddingTop: string, paddingRight: string, paddingBottom: string,
     * color: string, style: string}}
     */
    static {
      this.supported = {
        align: 'text-align',
        color: 'color',
        direction: 'direction',
        dir: 'direction',
        float: 'float',
        fontfamily: 'font-family',
        fontsize: 'font-size',
        fontstyle: 'font-style',
        fontweight: 'font-weight',
        height: 'height',
        paddingbottom: 'padding-bottom',
        paddingleft: 'padding-left',
        paddingright: 'padding-right',
        paddingtop: 'padding-top',
        position: 'float',
        style: 'style',
        textalign: 'text-align',
        textdecoration: 'text-decoration',
        allowfullscreen: 'allowfullscreen',
        webkitallowfullscreen: 'webkitallowfullscreen',
        mozallowfullscreen: 'mozallowfullscreen',
        width: 'width'
      };
    }
    static {
      this.fullscreen = ['allowfullscreen', 'webkitallowfullscreen', 'mozallowfullscreen'];
    }
    /**
     * Decode html entities
     */
    static decodeHTML(str = '') {
      const pat = new RegExp('&apos;|&quot;|&gt;|&lt;|&amp;', 'g');
      return str.replace(pat, c => {
        switch (c) {
          case '&apos;':
            return '\'';
          case '&quot;':
            return '"';
          case '&gt;':
            return '>';
          case '&lt;':
            return '<';
          case '&amp;':
            return '&';
          default:
            return '';
        }
      });
    }
    /**
     * Check XML on Malformed tags
     */
    static hasError(element) {
      if (!element || element.nodeName === 'parsererror') {
        return true;
      }
      let i = 0;
      const childNodes = element.childNodes,
        len = childNodes.length;
      for (; i < len; i++) {
        const child = childNodes[i];
        if (child.nodeName === 'parsererror') {
          return true;
        } else if (child.nodeType === 1 && child.childNodes.length > 0) {
          return XMLUtil.hasError(element.childNodes[i]);
        }
      }
      return false;
    }
    /**
     * Convert xml string to xml object
     */
    static parseFromString(str) {
      str = str || '';
      str = str.replace(/<\/?br\/?>/gm, '<br/>');
      let error = null;
      let xml;
      const xmlnsPat = /xmlns="http:\/\/ns\.adobe\.com\/textLayout\/2008"/igm;
      str = str.replace(xmlnsPat, '');
      try {
        if (DOMParser) {
          const parser = new DOMParser();
          parser['validateOnParse'] = true;
          xml = parser.parseFromString(removeEmptyFormattingTags(str), 'application/xml');
        }
      } catch (e) {
        xml = null;
        error = e.message;
      }
      if (xml && XMLUtil.hasError(xml.documentElement)) {
        xml = null;
        error = 'XML parser error: ';
      }
      return {
        xml,
        error
      };
    }
    /**
     * Method for Converting XMl to correct HTML String
     */
    static convertToHTML(xml, rootDataPath, learningFont) {
      XMLUtil.removeAllAttributes(xml, rootDataPath, learningFont);
      return xml.outerHTML || new XMLSerializer().serializeToString(xml);
    }
    /**
     * Removes all attributes from all child nodes
     */
    static removeAllAttributes(xml, rootDataPath, learningFont) {
      rootDataPath = rootDataPath || '';
      XMLUtil.removeAttributes(xml, rootDataPath);
      const CONTAINERS = ['ol', 'ul', 'table', 'thead', 'tbody', 'dl'];
      const list = xml.childNodes;
      if (CONTAINERS.includes(xml.nodeName.toLowerCase())) {
        list.forEach(childNode => {
          if (childNode.nodeType === Node.TEXT_NODE && !childNode.textContent.trim()) {
            childNode.parentNode.removeChild(childNode);
          }
        });
      }
      const len = list.length;
      for (let i = 0; i < len; i++) {
        const item = list[i];
        if (item.nodeType === Node.TEXT_NODE) {
          continue;
        }
        XMLUtil.removeAttributes(item, rootDataPath, learningFont);
        if (item.childNodes.length > 0) {
          XMLUtil.convertToHTML(item, rootDataPath, learningFont);
        }
      }
      return xml;
    }
    /**
     * Method for removing unsupported attributes.
     */
    static removeAttributes(item, rootDataPath, learningFont) {
      rootDataPath = rootDataPath || '';
      let style = '';
      let hasStyle = false;
      const attrs = Array.from(item.attributes || []);
      if (attrs.find(attr => /\.mp3$/.test(attr.value))) {
        item.removeAttribute('target');
      }
      const urlPat = /^(http|https|file)?(:)?\/\//,
        suffixPat = /\.(\w).+/,
        sourcePat = /(source|src)/i,
        skippingAttrs = ['controls', 'type', 'target', 'autoplay', 'loop'];
      for (const attr of attrs) {
        const attrName = attr.name;
        let attrValue = attr.value;
        const supportedAttr = XMLUtil.supported[attrName.toLowerCase()];
        if (supportedAttr === 'style') {
          hasStyle = true;
          const styleObj = {
            ...styleToObject$1(style),
            ...styleToObject$1(attrValue)
          };
          style = '';
          Object.keys(styleObj).forEach(key => {
            style += key + ':' + styleObj[key] + ';';
          });
          continue;
        }
        if (suffixPat.test(attrValue) && !urlPat.test(attrValue)) {
          attrValue = getFullUrl(rootDataPath, attrValue);
        }
        if (XMLUtil.fullscreen.indexOf(supportedAttr) !== -1) {
          item.setAttribute(attrName, 'true');
          continue;
        }
        if (attrName === 'href') {
          const soundPat = /\.mp3$/;
          if (soundPat.test(attrValue)) {
            item.setAttribute(attrName, '');
            item.setAttribute('data-url', attrValue);
          } else {
            const value = attr.value !== '#' ? attrValue : attr.value;
            item.setAttribute(attrName, XMLUtil.decodeHTML(value));
          }
          continue;
        }
        if (sourcePat.test(attrName)) {
          item.removeAttribute(attrName);
          item.setAttribute('src', attrValue);
          continue;
        }
        if (supportedAttr) {
          hasStyle = true;
          let val = isNaN(+attrValue) ? attrValue : +attrValue + 'px';
          if (attrName.toLowerCase() === 'fontfamily') {
            val = normalizeFontName(val);
          }
          if (style.indexOf(supportedAttr) === -1) {
            style += supportedAttr + ':' + val + ';';
          }
        }
        if (!skippingAttrs.includes(attrName) && !attrName.includes('-')) {
          item.removeAttribute(attrName);
        }
      }
      if (hasStyle) {
        style = style.replace(/^style:/, '');
        if (learningFont && style.indexOf('direction:rtl') !== -1 && style.indexOf('font-family') === -1) {
          style = style + 'font-family:' + learningFont + ';';
        }
        style = style.replace(/^style:/, '').replace(/;+/g, ';');
        item.setAttribute('style', style);
      }
      return style;
    }
  }
  return XMLUtil;
})();
/**
 * Convert style string to key value pair object
 */
function styleToObject$1(styleStr) {
  const res = {};
  const arr = styleStr.split(';');
  for (const item of arr) {
    const [key, value] = item.split(':');
    if (key && value) {
      res[key.trim()] = value.trim();
    }
  }
  return res;
}
function removeEmptyFormattingTags(htmlStr) {
  htmlStr = htmlStr || '';
  const pat = /<\s*(b|i|strong|font|em|mark|u|tt|strike|sup|sub|del|ins|big|small)\b((?:[^>"']|"[^"]*"|'[^']*')*)>[^\S]*<\s*\/\s*(b|i|strong|font|em|mark|u|tt|strike|sup|sub|del|ins|big|small)\b\s*>/gmi;
  while (pat.test(htmlStr)) {
    pat.lastIndex = 0;
    htmlStr = htmlStr.replace(pat, '');
  }
  return htmlStr;
}
function escape(text) {
  return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
}
const brPat = /br/i;
const spanPat = /span/i;
const NON_SELECTABLE_CHARACTERS = '\u002C\u003A\u003B\u0021\u0040\u0023\u0024\u0025\u005E\u0026\u002B\u003D\u007C\u007B' + '\u007D\u005B\u005D\u0028\u0029\u003F\u002B\u002A\u002E\u002D\u0020\uFF0C\u3002' + '\u300A\u300B\u200B\uFF1F\u3001\u3002\u2028\u060C\u061B\u061F\u00A0';
const NON_SELECTABLE_REG_EXP = new RegExp('[' + escape(NON_SELECTABLE_CHARACTERS) + ']', 'g');
/**
 * Utility method for getting span out of range start and end containers
 */
function getSpan(node) {
  if (node instanceof HTMLSpanElement) {
    return node;
  }
  if (node.parentNode instanceof HTMLSpanElement) {
    return node.parentNode;
  }
  return null;
}
/**
 *  Gets previous sibling of a node, in our case it always should be span,
 */
function getPreviousSpanNode(node) {
  if (node.previousSibling.nodeType === Node.COMMENT_NODE) {
    node = node.previousSibling;
  }
  if (node.previousSibling instanceof HTMLSpanElement) {
    return node.previousSibling;
  }
  return null;
}
/**
 *  Gets next sibling of a node, in our case it always should be span,
 */
function getNextSpanNode(node) {
  if (!node.nextSibling) {
    return null;
  }
  if (node.nextSibling.nodeType === Node.COMMENT_NODE) {
    node = node.nextSibling;
  }
  if (node.nextSibling instanceof HTMLSpanElement) {
    return node.nextSibling;
  }
  return null;
}
/**
 * Utility method for finding coloring action
 */
function allHaveColor(nodes, color) {
  for (const node of nodes) {
    if (getClassName(node).indexOf(color) === -1) {
      return false;
    }
  }
  return true;
}
const SINGLES = [
// [0x1100, 0x11FF],  // korean
[0x0E00, 0x0E7F], [0x2E80, 0x3DFF], [0x4E00, 0x9FCC]];
/**
 * Gets if character is from non-space separator script
 */
function isSingle(char) {
  const code = char.charCodeAt(0);
  for (const item of SINGLES) {
    if (code >= item[0] && code <= item[1]) {
      return true;
    }
  }
  return false;
}
function parseFromString(text) {
  return XMLUtil.parseFromString(text);
}
function splitPlainText(text) {
  const chars = text.split('');
  let clickableText = '';
  let intermediateText = '';
  const result = [];
  for (const char of chars) {
    if (NON_SELECTABLE_CHARACTERS.indexOf(char) === -1) {
      // Regular text
      if (clickableText.length > 0 && isSingle(char)) {
        // Flush previous buffer
        result.push(clickableText);
        clickableText = '';
      }
      clickableText += char;
      if (intermediateText.length > 0) {
        result.push(intermediateText);
        intermediateText = '';
      }
      // Flush cjk
      if (isSingle(char)) {
        result.push(clickableText);
        clickableText = '';
      }
    } else {
      // Non-clickable text
      intermediateText += char;
      if (clickableText.length > 0) {
        result.push(clickableText);
        clickableText = '';
      }
    }
  }
  if (intermediateText.length > 0) {
    result.push(intermediateText);
  }
  if (clickableText.length > 0) {
    result.push(clickableText);
  }
  return result;
}
/**
 * Split text to single words
 */
function splitToWords(text) {
  // Process text
  const parsedText = parseFromString('<div>' + text + '</div>');
  const walker = document.createTreeWalker(parsedText.xml, NodeFilter.SHOW_ALL, null);
  let node = walker.nextNode();
  const replacementNodes = [];
  while (node) {
    if (node.nodeType === Node.ELEMENT_NODE) {
      if (brPat.test(node.nodeName)) {
        replacementNodes.push({
          text: '\n',
          className: '',
          styles: '',
          isNewLine: true
        });
      }
      node = walker.nextNode();
      continue;
    }
    if (node.nodeType === Node.TEXT_NODE) {
      let className = '';
      let styles = '';
      const parentNode = node.parentNode;
      if (parentNode && spanPat.test(parentNode.nodeName)) {
        className = getClassName(parentNode);
        styles = parentNode.getAttribute('style') || '';
      }
      for (const txt of splitPlainText(node.textContent)) {
        replacementNodes.push({
          text: txt,
          className,
          styles
        });
      }
    }
    node = walker.nextNode();
  }
  return replacementNodes;
}
function getNextNode(node, endNode, nextNode) {
  if (endNode === node) {
    return null;
  }
  return nextNode;
}
/**
 * Gets class attribute value of a node
 */
function getClassName(node) {
  const element = node;
  if (!element) {
    return '';
  }
  return element.className || element.getAttribute && element.getAttribute('class') || '';
}
let TextHighlightUtil = /*#__PURE__*/(() => {
  class TextHighlightUtil {
    static {
      this.HIDE = 'hide-words';
    }
    static {
      this.SHOW = 'show-words';
    }
    static splitToWords(text) {
      return splitToWords(text);
    }
    constructor(container, markerClass, markerColor) {
      this.container = container;
      this.markerClass = markerClass;
      this.markerColor = markerColor;
      this._isColorHidden = {};
    }
    set selectedAction(value) {
      this._selectedAction = value;
    }
    clearHighlight() {
      const walker = document.createTreeWalker(this.container, NodeFilter.SHOW_ELEMENT, () => NodeFilter.FILTER_ACCEPT);
      let node = walker.nextNode();
      while (node) {
        if (node.nodeName.toLowerCase() === 'span') {
          const span = node;
          const className = getClassName(span);
          if (className) {
            if (this.markerClass && className.indexOf(this.markerClass) >= 0) {
              span.setAttribute('class', this.markerClass + ' ' + this.markerColor);
            } else {
              span.setAttribute('class', '');
            }
          }
        }
        node = walker.nextNode();
      }
    }
    /**
     * Processes currently selected text to highlight words with current color
     */
    processDocumentSelection() {
      const nodes = [];
      const selection = window.getSelection();
      if (!selection || selection.rangeCount === 0) {
        return;
      }
      for (let i = 0; i < selection.rangeCount; i++) {
        const range = selection.getRangeAt(i);
        if (range) {
          const firstNode = getSpan(range.startContainer);
          const endNode = getSpan(range.endContainer);
          if (!firstNode || !endNode) {
            break;
          }
          let node = firstNode;
          do {
            nodes.push(node);
          } while (node = getNextNode(node, endNode, node.nextSibling));
        }
      }
      selection.collapseToEnd();
      const filtered = nodes.filter(span => !NON_SELECTABLE_REG_EXP.test(span.textContent));
      if (filtered.length) {
        this.updateNodes(nodes);
      }
    }
    isColorHidden(color) {
      return !!this._isColorHidden[color];
    }
    notifyVisibilityChanged(color, isHidden) {
      this._isColorHidden[color] = isHidden;
      this.updateVisibility(color);
    }
    updateNodes(nodes) {
      if (this._selectedAction === TextHighlightUtil.SHOW || this._selectedAction === TextHighlightUtil.HIDE) {
        this.showOrHide(nodes, this._selectedAction === TextHighlightUtil.SHOW);
        return;
      }
      if (allHaveColor(nodes, this._selectedAction)) {
        this.setColor(nodes, '');
      } else {
        this.setColor(nodes, this._selectedAction);
      }
    }
    setColor(nodes, color = '') {
      nodes.forEach(span => this.setSingleNodeColor(span, color));
      this.setBoundaryColor(nodes[0], color, getPreviousSpanNode);
      this.setBoundaryColor(nodes[nodes.length - 1], color, getNextSpanNode);
    }
    showOrHide(nodes, show) {
      nodes.forEach(n => {
        if (show) {
          n.classList.remove('hidden');
        } else {
          n.classList.add('hidden');
        }
      });
    }
    setSingleNodeColor(span, color = '') {
      let marker = '';
      const className = getClassName(span);
      if (this.markerClass && className && className.indexOf(this.markerClass) >= 0) {
        marker = this.markerClass;
      }
      color = color.trim();
      span.setAttribute('class', marker + (color ? ' ' + color : '') + (this._isColorHidden[color] ? ' hidden' : ''));
    }
    setBoundaryColor(span, color, getSibling) {
      let next = getSibling(span);
      const inBetween = [];
      while (next && NON_SELECTABLE_REG_EXP.test(next.textContent)) {
        inBetween.push(next);
        next = getSibling(next);
      }
      const className = getClassName(next);
      if (className && className.indexOf(color) >= 0) {
        inBetween.forEach(item => this.setSingleNodeColor(item, color));
        return;
      }
      if (!NON_SELECTABLE_REG_EXP.test(span.textContent)) {
        span = getSibling(span);
      }
      while (span && (/\s+/.test(span.textContent) || NON_SELECTABLE_REG_EXP.test(span.textContent))) {
        this.setSingleNodeColor(span);
        span = getSibling(span);
      }
    }
    updateVisibility(color) {
      const spans = Array.prototype.concat.call(this.container.querySelectorAll('.' + color))[0];
      spans.forEach(span => this.setSingleNodeColor(span, color));
    }
  }
  return TextHighlightUtil;
})();
const ALPHA_CHAR_CODES = [48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 65, 66, 67, 68, 69, 70];
class UIDUtil {
  /**
   *  Generates a UID (unique identifier) based on JavaScript's
   *  pseudo-random number generator and the current time.
   *
   *  <p>The UID has the form
   *  <code>"XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX"</code>
   *  where X is a hexadecimal digit (0-9, A-F).</p>
   *
   *  <p>This UID will not be truly globally unique; but it is the best
   *  we can do without player support for UID generation.</p>
   */
  static createUID() {
    const uid = new Array(36);
    let index = 0;
    for (let i = 0; i < 8; i++) {
      uid[index++] = ALPHA_CHAR_CODES[Math.floor(Math.random() * 16)];
    }
    for (let i = 0; i < 3; i++) {
      uid[index++] = 45; // charCode for "-"
      for (let j = 0; j < 4; j++) {
        uid[index++] = ALPHA_CHAR_CODES[Math.floor(Math.random() * 16)];
      }
    }
    uid[index++] = 45;
    const time = new Date().getTime();
    // Note: time is the number of milliseconds since 1970,
    // which is currently more than one trillion.
    // We use the low 8 hex digits of this number in the UID.
    // Just in case the system clock has been reset to
    // Jan 1-4, 1970 (in which case this number could have only
    // 1-7 hex digits), we pad on the left with 7 zeros
    // before taking the low digits.
    const timeString = ('00000000' + time.toString(16).toUpperCase()).substr(-8);
    for (let i = 0; i < 8; i++) {
      uid[index++] = timeString.charCodeAt(i);
    }
    for (let i = 0; i < 4; i++) {
      uid[index++] = ALPHA_CHAR_CODES[Math.floor(Math.random() * 16)];
    }
    return String.fromCharCode.apply(null, uid);
  }
}
class RectangleUtil {
  /**
   * Determines if two rectangles intersect
   */
  static intersect(a, b) {
    return a.left < b.right && a.right > b.left && a.top < b.bottom && a.bottom > b.top;
  }
  /**
   * Determines if two rectangles intersect
   */
  static compare(a, b) {
    const area1 = RectangleUtil.area(a);
    const area2 = RectangleUtil.area(b);
    const res = area1 - area2;
    if (res < 0) {
      return -1;
    } else if (res > 0) {
      return 1;
    }
    return 0;
  }
  /**
   * Calculates the intersection rectangle of two rectangles.
   * Rectangles have to intersect to work!
   */
  static intersection(a, b) {
    return {
      left: Math.max(a.left, b.left),
      top: Math.max(a.top, b.top),
      right: Math.min(a.right, b.right),
      bottom: Math.min(a.bottom, b.bottom)
    };
  }
  /**
   * Normalizes a rectangle to ensure left < right and top < bottom
   */
  static normalize(a) {
    return {
      left: Math.min(a.left, a.right),
      top: Math.min(a.top, a.bottom),
      right: Math.max(a.left, a.right),
      bottom: Math.max(a.top, a.bottom)
    };
  }
  /**
   * Calculates the area of a rectangle
   */
  static area(a) {
    return Math.abs(a.right - a.left) * Math.abs(a.bottom - a.top);
  }
  /**
   * Calculates the height of a rectangle
   */
  static height(a) {
    return Math.abs(a.bottom - a.top);
  }
  /**
   * Calculates the width of a rectangle
   */
  static width(a) {
    return Math.abs(a.right - a.left);
  }
  /**
   * Calculates the perimeter of a rectangle
   *
   */
  static perimeter(a) {
    return 2 * (Math.abs(a.right - a.left) + Math.abs(a.bottom - a.top));
  }
  /**
   * Calculates the center point of a rectangle
   */
  static center(a) {
    return {
      x: (a.right - a.left) / 2,
      y: (a.bottom - a.top) / 2
    };
  }
  /**
   * Calculates the center point of a rectangle Coordinate
   */
  static viewportCenter(a) {
    return {
      x: a.right - (a.right - a.left) / 2,
      y: a.bottom - (a.bottom - a.top) / 2
    };
  }
  /**
   * Resizes the rectangle by a given value on the center
   */
  static insetBy(a, w) {
    return {
      left: a.left + w,
      top: a.top + w,
      right: a.right - w - w,
      bottom: a.bottom - w - w
    };
  }
}
const hasNumeralsRe = /[\d\u06f0-\u06f9]/;
const isRequiredLtrRe = /^http:\/\/.*/;
const wordSeparatorRe = /\s+/;
class TLF {
  // eslint-disable-next-line
  static {
    this.ltrChars = 'A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02B8\u0300-\u0590\u0800-\u1FFF\u200E\u2C00-\uFB1C\uFE00-\uFE6F\uFEFD-\uFFFF';
  }
  // eslint-disable-next-line
  /* eslint-disable max-len */
  static {
    this.latinChars = '\u002F\u06D4\u0027\u0041-\u005A\u0061-\u007A\u00C0-\u00D6\u00D8-\u00DF\u00E0-\u00F6\u00F8-\u00FF\u0100-\u017F\u0180-\u024F\u0410-\u044F\u1E00-\u1EFF\u2C60-\u2C7F\uA720-\uA7FF\uFB00-\uFB0F';
  }
  static {
    this.rtlChars = '\u0591-\u06FF\u06FA-\u07FF\u200F\uFB1D-\uFDFF\uFE70-\uFEFC';
  }
  static {
    this.openPunctuations = '\u0020\u0022\u0027\u0028\u005B\u007B';
  }
  static {
    this.ltrCharReg = new RegExp('[' + TLF.ltrChars + ']');
  }
  static {
    this.rtlCharReg = new RegExp('[' + TLF.rtlChars + ']');
  }
  static {
    this.latinCharReg = new RegExp('([' + TLF.openPunctuations + ']*[' + TLF.latinChars + ']+[' + PUNCTUATIONS_UNICODE + SPACES_UNICODE + DASHES_UNICODE + '0-9]*)+', 'gm');
  }
  static {
    this.otherCharsPat = new RegExp('([' + TLF.openPunctuations + ']*[^' + TLF.latinChars + PUNCTUATIONS_UNICODE + SPACES_UNICODE.replace('\u200B', '') + DASHES_UNICODE + '0-9]+[' + PUNCTUATIONS_UNICODE + SPACES_UNICODE + DASHES_UNICODE + '0-9]*)+', 'gm');
  }
  static {
    this.rtlDirCheckRe = new RegExp('^[^' + TLF.ltrChars + ']*[' + TLF.rtlChars + ']');
  }
  static {
    this.rtlDetectionThreshold = 0.40;
  }
  /**
   * Estimates direction of the given string
   */
  static estimateDirection(str) {
    let rtlCount = 0;
    let totalCount = 0;
    let hasWeaklyLtr = false;
    const tokens = (str || '').split(wordSeparatorRe);
    for (let i = 0; i < tokens.length; i++) {
      const token = tokens[i];
      if (TLF.startsWithRtl(token)) {
        rtlCount++;
        totalCount++;
      } else if (isRequiredLtrRe.test(token)) {
        hasWeaklyLtr = true;
      } else if (TLF.hasAnyLtr(token)) {
        totalCount++;
      } else if (hasNumeralsRe.test(token)) {
        hasWeaklyLtr = true;
      }
    }
    return totalCount === 0 ? 'ltr' : rtlCount / totalCount > TLF.rtlDetectionThreshold ? 'rtl' : 'ltr';
  }
  /**
   * Checks if string contains any ltr character
   */
  static hasAnyLtr(str) {
    TLF.ltrCharReg.lastIndex = 0;
    return TLF.ltrCharReg.test(str);
  }
  /**
   *
   * Checks if string starts with rtl
   */
  static startsWithRtl(str) {
    TLF.rtlDirCheckRe.lastIndex = 0;
    return TLF.rtlDirCheckRe.test(str);
  }
  /**
   * Utility method for getting font faces
   */
  static isArabicScript(languageCode, config) {
    const fontName = languageCode === config.learningLanguageCode ? config.learningFontFamily : config.knownFontFamily;
    switch (fontName) {
      case 'Arabic':
      case 'Baluchi':
      case 'Pashto':
      case 'Persian':
      case 'Urdu':
      case 'Kurdish':
      case 'Uyghur':
        return true;
      default:
        return false;
    }
  }
}

/* eslint-disable max-len */
const SPACES = /[\u0020\u00A0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u200B\u202F\u205F\u3000]/g;
const COMBINING_DIACRITICAL_MARKS = /[\u0300-\u036f]/gm;
const DIGIT = /[\u0030-\u0039]/gm;
const PUNCTUATION = /[\u0021-\u002F\u003A-\u0040\u005F-\u0060\u007E\u00A1-\u00BF\u00D7\u00F7\u2000-\u206F\u301c\u2011]/gm;
const ARABIC = /[\u0600-\u06FF\u0750-\u077F\uFB50-\uFDFF\uFE70-\uFEFF]/gm;
const BENGALI = /[\u0980-\u09FF]/gm;
const GUJARATI = /[\u0A80-\u0AFF]/gm;
const GEORGIAN = /[\u10A0-\u10FF\u2D00-\u2D2F]/gm;
const HEBREW = /[\u0590-\u05FF\uFB00-\uFB4F]/gm;
const AMHARIC = /[\u1200-\u137F\u1380-\u139F\u2D80-\u2DDF\uAB00-\uAB2F]/gm;
const HINDI = /[\u0900-\u097F\uA8E0-\uA8FF\u0A00-\u0A7F\u0D00-\u0D7F\u0B00-\u0B7F\uAA60-\uAA7F]/gm;
const BURMESE = /[\u1000-\u109F]/gm;
const KHMER = /[\u1780-\u17FF\u19E0-\u19FF]/gm;
const KOREAN = /[\u1100-\u11FF\u2190-\u2199\u2500-\u254B\u21d2-\u21d4\u3130-\u318F\uA960-\uA97F\uAC00-\uD7A3\uD7B0-\uD7FF]/gm;
const LAO = /[\u0E80-\u0EFF]/gm;
const LATIN = /[\u0041-\u005A\u0061-\u007A\u00C0-\u00D6\u00D8-\u00DF\u00E0-\u00F6\u00F8-\u00FF\u0100-\u017F\u0180-\u024F\u0410-\u044F\u1E00-\u1EFF\u2C60-\u2C7F\uA720-\uA7FF\uFB00-\uFB0F\u0400-\u04FF\u0500-\u052F\u2DE0-\u2DFF\uA640-\uA69F\u0370-\u03FF\u1F00-\u1FFF\u1800-\u18AF]/gm;
const CJ = /[\u2190-\u2199\u2500-\u2574\u3001-\u303F\u3040-\u309F\u30A0-\u30FF\u31F0-\u31FF\u3100-\u312F\u3400-\u4DBF\u4E00-\u9FFF\uF900-\uFAFF]|[\uD840-\uD868\uD86A-\uD86C][\uDC00-\uDFFF]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF3F]|\uD87E[\uDC00-\uDE1F]|[\uFF00-\uFFEF]/gm;
const SINHALESE = /[\u0D80-\u0DFF]/gm;
const TAMIL = /[\u0B80-\u0BFF]/gm;
const TELUGU = /[\u0C00-\u0C7F]/gm;
const THAI = /[\u0E00-\u0E7F]/gm;
const TIBETAN = /[\u0F00-\u0FFF]/gm;
const ARMENIAN = /[\u0530-\u058F]/gm;
const CANADIAN_ABORIGINAL_SYLLABICS = /[\u1400-\u167F]/gm;
const CONTAINERS = ['div', 'p', 'ol', 'ul', 'li', 'table', 'thead', 'tbody', 'th', 'tr', 'td', 'dt', 'dl', 'dd', 'attention', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'];
const OPEN_PUNCTUATIONS = '\\\u0028\\\u005B\\\u007B';
const CLOSE_PUNCTUATIONS = '\\\u0029\\\u005D\\\u007D';
const CLOSE_PUNCTUATIONS_PAT = new RegExp('[' + CLOSE_PUNCTUATIONS + ']', 'gm');
const BRACKETS_WITH_TEXT_PAT = new RegExp('[' + OPEN_PUNCTUATIONS + ']+[^' + CLOSE_PUNCTUATIONS + ']+[' + CLOSE_PUNCTUATIONS + ']+', 'gm');
let cssArabicFont = '';
/**
 * Method to delete limited text and set selection
 */
function limitToMax(numToDelete) {
  const sel = window.getSelection();
  const orRange = sel.rangeCount > 0 ? sel.getRangeAt(0) : null;
  const node = sel.focusNode;
  const str = node ? node.textContent : '';
  if (sel && node && node.nodeType === 3) {
    const end = orRange.endOffset;
    let start = orRange.startOffset;
    start -= numToDelete;
    const range = orRange.cloneRange();
    range.deleteContents();
    node.textContent = str.substring(0, start) + str.substring(end);
    range.setStart(node, start);
    range.setEnd(node, start);
    sel.removeAllRanges();
    sel.addRange(range);
  }
}
/**
 * Create html markup from string
 */
function createHtmlMarkup(str, tag = 'div', wrapIntoDiv = true, convertPxToRem = true) {
  str = str || '';
  if (!str) {
    return document.createElement(tag);
  }
  str = str.replace(/([\u200E\u200F])/g, ''); // Remove LRT and RTL MARKS.
  const div = normalizeHtml(str, tag, true, convertPxToRem);
  if (div.children.length === 0 && wrapIntoDiv) {
    const res = document.createElement('div');
    res.innerHTML = div.outerHTML;
    return res;
  }
  return div;
}
function parseStr(str) {
  const res = [];
  BRACKETS_WITH_TEXT_PAT.lastIndex = 0;
  const posArr = [];
  let m;
  while ((m = BRACKETS_WITH_TEXT_PAT.exec(str)) !== null) {
    posArr.push({
      start: m.index,
      end: BRACKETS_WITH_TEXT_PAT.lastIndex
    });
    BRACKETS_WITH_TEXT_PAT.lastIndex++;
  }
  let lastPos = -1;
  for (let i = 0; i < posArr.length; i++) {
    const pos = posArr[i];
    if (i === 0 && pos.start > 0) {
      res.push({
        str: str.substring(0, pos.start)
      });
    }
    if (lastPos !== -1 && lastPos < pos.start) {
      res.push({
        str: str.substring(lastPos, pos.start)
      });
    }
    res.push({
      str: str.substring(pos.start, pos.end),
      insideBrackets: true
    });
    lastPos = pos.end;
    if (i === posArr.length - 1 && pos.end < str.length) {
      res.push({
        str: str.substring(pos.end)
      });
    }
  }
  return res.length ? res : [{
    str
  }];
}
/**
 * Creates html markup from input string
 */
function createMarkup(str, tag = 'div', convertPxToRem = true) {
  if (!str) {
    return document.createElement(tag);
  }
  let prevMarkupFont = '';
  const res = [];
  const chunks = parseStr(str);
  const isCWPlayer = !!window['playerName'];
  for (let k = 0; k < chunks.length; k++) {
    const chunk = chunks[k];
    const arr = unEscapeEntity(isCWPlayer ? replaceHyphenBetweenWords(chunk.str) : chunk.str).replace(/&nbsp;/gm, String.fromCharCode(0x00A0)).split('');
    let prevFont = '';
    let prevPuncFont = '';
    let cur = '';
    for (let i = 0; i < arr.length; i++) {
      const char = arr[i];
      let currentFont = isNeutral(char) || isSpace(char) ? prevFont : getFontFamily(char, '');
      if (chunk.insideBrackets) {
        if (!prevPuncFont && currentFont) {
          prevPuncFont = currentFont;
        }
        CLOSE_PUNCTUATIONS_PAT.lastIndex = 0;
        if (CLOSE_PUNCTUATIONS_PAT.test(char) && currentFont !== prevPuncFont) {
          res.push(toMarkupString(cur, prevFont));
          prevMarkupFont = prevFont;
          prevFont = prevPuncFont;
          cur = char;
          prevPuncFont = '';
          continue;
        }
      }
      if (isSpace(char)) {
        let j = i + 1;
        while (j < arr.length && isNeutral(arr[j])) {
          j++;
        }
        // all remaining chars are neutral
        if (j >= arr.length) {
          cur += arr.slice(i, j).join('');
          i = j;
          continue;
        }
        const nextFont = getFontFamily(arr[j], currentFont);
        if (!currentFont) {
          currentFont = nextFont;
        }
        if (nextFont !== currentFont) {
          res.push(toMarkupString(cur + char, prevFont));
          prevMarkupFont = prevFont;
          prevFont = nextFont;
          cur = arr.slice(i + 1, j + 1).join('');
          i = j;
          continue;
        }
      }
      if (isNeutral(char)) {
        cur += char;
        continue;
      }
      if (cur && currentFont !== prevFont && prevFont !== '') {
        res.push(toMarkupString(cur, prevFont));
        prevMarkupFont = prevFont;
        cur = '';
      }
      cur += char;
      prevFont = currentFont;
    }
    if (cur) {
      res.push(toMarkupString(cur, prevFont || prevMarkupFont || 'Latin'));
      prevMarkupFont = prevFont;
    }
  }
  const div = document.createElement(tag);
  div.innerHTML = res.join('');
  if (convertPxToRem && CWDetection.isIOS) {
    return normalizeFontSizeForIOS(div);
  }
  return div;
}
/**
 * Detects font family
 */
function detectFontFamily(sel, range, span, pastedData, root) {
  if (!hasText(pastedData) && !hasText(span.textContent)) {
    return;
  }
  let start = range.startOffset;
  const end = range.endOffset;
  if (pastedData === '') {
    const txt = span.textContent;
    start--;
    pastedData = txt[start];
    span.textContent = txt.substring(0, start) + txt.substring(range.endOffset);
  }
  const div = createMarkup(pastedData, 'div', false);
  if (div.childNodes.length > 0) {
    let nextNode = span.nextSibling;
    let lastNode = null;
    if (span.nodeType === 3 && hasText(span.textContent)) {
      const txt = span.textContent;
      if (/span/i.test(span.parentNode.nodeName)) {
        let tmp = span.parentNode.cloneNode(false);
        span.textContent = txt.substring(0, start);
        tmp.textContent = txt.substring(end);
        if (!tmp.textContent) {
          nextNode = span.nextSibling;
        } else {
          tmp = span.parentNode.parentNode.insertBefore(tmp, span.parentNode.nextSibling);
          nextNode = tmp;
        }
        span = span.parentNode;
      } else {
        const first = createMarkup(txt.substring(0, start), 'div', false).firstChild;
        const second = createMarkup(txt.substring(end), 'div', false).firstChild;
        span.parentNode.replaceChild(first, span);
        if (!second || !second.textContent) {
          nextNode = first.nextSibling;
        } else {
          first.parentNode.insertBefore(second, first.nextSibling);
          nextNode = second;
        }
        span = first;
      }
    }
    while (div.childNodes.length > 0) {
      if (nextNode) {
        lastNode = span.parentNode.insertBefore(div.firstChild, nextNode);
      } else {
        span.parentNode.appendChild(div.firstChild);
        lastNode = span.parentNode.lastChild;
      }
    }
    if (!hasText(span.textContent)) {
      span.parentNode.removeChild(span);
    }
    if (lastNode) {
      const isSingleNode = root.childNodes.length === 1;
      const elmStyle = window.getComputedStyle(root);
      const isCentered = elmStyle.getPropertyValue('text-align') === 'center';
      if (isSingleNode) {
        root.style.direction = lastNode.style.direction;
        if (!isCentered) {
          root.style.textAlign = lastNode.style.direction === 'rtl' ? 'right' : 'left';
        }
      }
      lastNode = lastNode.lastChild || lastNode;
      range.setStart(lastNode, lastNode.length);
      range.setEnd(lastNode, lastNode.length);
      sel.removeAllRanges();
      sel.addRange(range);
    }
  }
}
/**
 * Detect font family from str
 */
function getFontFamily(str, currentFont = '') {
  ARABIC.lastIndex = 0;
  if (ARABIC.test(str)) {
    return getArabicFont();
  }
  AMHARIC.lastIndex = 0;
  if (AMHARIC.test(str)) {
    return 'Amharic';
  }
  BENGALI.lastIndex = 0;
  if (BENGALI.test(str)) {
    return 'Bengali';
  }
  BURMESE.lastIndex = 0;
  if (BURMESE.test(str)) {
    return 'Burmese';
  }
  GEORGIAN.lastIndex = 0;
  if (GEORGIAN.test(str)) {
    return 'Georgian';
  }
  GUJARATI.lastIndex = 0;
  if (GUJARATI.test(str)) {
    return 'Gujarati';
  }
  HEBREW.lastIndex = 0;
  if (HEBREW.test(str)) {
    return 'Hebrew';
  }
  HINDI.lastIndex = 0;
  if (HINDI.test(str)) {
    return 'Hindi';
  }
  KHMER.lastIndex = 0;
  if (KHMER.test(str)) {
    return 'Khmer';
  }
  KOREAN.lastIndex = 0;
  if (KOREAN.test(str)) {
    return 'Korean';
  }
  LAO.lastIndex = 0;
  if (LAO.test(str)) {
    return 'Lao';
  }
  LATIN.lastIndex = 0;
  if (LATIN.test(str)) {
    return 'Latin';
  }
  CJ.lastIndex = 0;
  if (CJ.test(str)) {
    return 'SimHei';
  }
  SINHALESE.lastIndex = 0;
  if (SINHALESE.test(str)) {
    return 'Sinhala';
  }
  TAMIL.lastIndex = 0;
  if (TAMIL.test(str)) {
    return 'Tamil';
  }
  TELUGU.lastIndex = 0;
  if (TELUGU.test(str)) {
    return 'Telugu';
  }
  THAI.lastIndex = 0;
  if (THAI.test(str)) {
    return 'Thai';
  }
  TIBETAN.lastIndex = 0;
  if (TIBETAN.test(str)) {
    return 'Tibetan';
  }
  ARMENIAN.lastIndex = 0;
  if (ARMENIAN.test(str)) {
    return 'Armenian';
  }
  CANADIAN_ABORIGINAL_SYLLABICS.lastIndex = 0;
  if (CANADIAN_ABORIGINAL_SYLLABICS.test(str)) {
    return 'Bjcrus';
  }
  if (str.length === 1 && (isNeutral(str) || isSpace(str))) {
    return currentFont || 'Latin';
  }
  return getLearningFontFromDocument() || 'Latin';
}
/**
 * Get direction of text from in str
 */
function getDirection(str) {
  HEBREW.lastIndex = 0;
  ARABIC.lastIndex = 0;
  return HEBREW.test(str) || ARABIC.test(str) ? 'rtl' : 'ltr';
}
/**
 * Detect if input string is neutral or not
 */
function isNeutral(str) {
  DIGIT.lastIndex = 0;
  PUNCTUATION.lastIndex = 0;
  COMBINING_DIACRITICAL_MARKS.lastIndex = 0;
  return DIGIT.test(str) || PUNCTUATION.test(str) || /[\u0028\u0029\u005B-\u005E\u007B\u007D]/.test(str) || COMBINING_DIACRITICAL_MARKS.test(str);
}
/**
 * Detect if input string is space or not
 */
function isSpace(str) {
  SPACES.lastIndex = 0;
  return SPACES.test(str);
}
/**
 * Detect if input string is neutral or space or something else
 */
function isNeutralOrIsSpace(str) {
  return isNeutral(str) || isSpace(str);
}
/**
 * Detect if input string contains any text character or not
 */
function hasText(str) {
  return (str || '').replace(/\uFEFF/gm, '').length > 0;
}
/**
 * Converts text to html string with styles
 */
function toMarkupString(text, font) {
  const fontSize = FontSizeConstants.getDefault(font);
  return `<span style="font-family:${font};font-size:${fontSize}px;direction:${TLF.estimateDirection(text)}">${text}</span>`;
}
/**
 * Gets previous direction
 */
function getPreviousDirection(str, currentDirection) {
  for (let i = str.length - 1; i >= 0; i--) {
    if (!(isNeutral(str[i]) || isSpace(str[i]))) {
      return getDirection(str[i]);
    }
  }
  return currentDirection;
}
/**
 * Calculates Neutral Or Space counts
 */
function getNeutralOrSpaceLen(str) {
  let len = 0;
  for (let i = str.length - 1; i >= 0; i--) {
    if (isNeutralOrIsSpace(str[i])) {
      len++;
    }
  }
  return len;
}
/**
 *
 */
function getDirectionFromMarkup(htmlMarkup, defaultDir) {
  const div = document.createElement('div');
  div.innerHTML = htmlMarkup || '';
  const elem = div.children.length === 1 ? div.firstElementChild : div;
  return elem.dir || elem.style.direction || defaultDir || TLF.estimateDirection(elem.textContent || elem.innerText);
}
/**
 * Creates safe html object from input string
 */
function createSafeHtmlMarkup(str, sanitizer, direction, textAlign, convertPxToRem = true) {
  if (!str) {
    return null;
  }
  const div = createHtmlMarkup(str, 'div', !(direction || window['playerName']), convertPxToRem);
  direction = direction || div.style.direction || div.dir || TLF.estimateDirection(div.innerText || div.textContent);
  div.dir = div.style.direction = direction;
  textAlign = textAlign || div.style.textAlign || (direction === 'rtl' ? 'right' : 'left');
  div.style.textAlign = textAlign;
  const safeHtml = sanitizer.bypassSecurityTrustHtml(div.outerHTML);
  safeHtml.html = div.outerHTML;
  safeHtml.dir = direction;
  safeHtml.textAlign = textAlign;
  return safeHtml;
}
/**
 * Set current arabic font for session
 */
function getArabicFont() {
  if (!cssArabicFont) {
    cssArabicFont = getArabicFontFromDocument();
  }
  return cssArabicFont;
}
/**
 * Get name of arabic font loaded in document
 */
function getArabicFontFromDocument() {
  const arr = ['knownFont', 'translitFont', 'learningFont', 'uiFont'];
  const dirPat = /direction:(\s*)(rtl)/;
  for (const value of arr) {
    const sheet = document.getElementById(value);
    if (sheet && sheet.textContent && dirPat.test(sheet.textContent)) {
      const pat = /font-family:(\s*)(\w+)/;
      const matches = sheet.textContent.match(pat);
      const arabicScripts = ['Arabic', 'Baluchi', 'Pashto', 'Persian', 'Urdu', 'Kurdish', 'Uyghur'];
      if (matches.length > 2 && arabicScripts.includes(matches[2])) {
        return matches[2];
      }
    }
  }
  return '';
}
/**
 * Get name of learning font loaded in document
 */
function getLearningFontFromDocument() {
  const sheet = document.getElementById('learningFont');
  if (sheet && sheet.textContent) {
    const pat = /font-family:(\s*)(\w+)/;
    const matches = sheet.textContent.match(pat);
    if (matches.length > 2) {
      return matches[2];
    }
  }
  return '';
}
function normalizeHtml(str, tag = 'div', addFont = false, convertPxToRem = true) {
  const div = document.createElement(tag);
  if (!str) {
    return div;
  }
  div.innerHTML = str.replace(/\n+/g, '').replace(/\r+/g, '');
  let normalized,
    overrideChildFontSize = false;
  while (div.childNodes.length === 1) {
    let firstChild = div.firstElementChild;
    if (firstChild) {
      firstChild = replaceFontTagAndColor(firstChild);
      if (firstChild.nodeName.toLowerCase() === 'a') {
        if (addFont) {
          if (firstChild.parentElement && firstChild.parentElement.nodeName.toLowerCase() === 'li') {
            firstChild.style.textIndent = 'initial';
          }
          addHrefMarkup(firstChild);
          overrideChildFontSize = true;
        }
        break;
      } else if (firstChild.nodeName.toLowerCase() === 'attention') {
        if (addFont) {
          addMarkup(firstChild);
          overrideChildFontSize = true;
          break;
        }
      }
      if (shouldSkip(firstChild) || firstChild.classList.contains('media-container') && firstChild.querySelectorAll('audio, video').length) {
        break;
      }
      if (/^(ul|ol|table|tbody|thead|attention|li)$/i.test(firstChild.nodeName)) {
        normalized = normalizeHtml(firstChild.innerHTML, firstChild.tagName, addFont, convertPxToRem);
        firstChild.innerHTML = normalized.innerHTML;
        normalizeListAndItems(firstChild);
        break;
      }
      if (isStyleTag(firstChild)) {
        normalized = normalizeHtml(firstChild.innerHTML, firstChild.tagName, addFont, convertPxToRem);
        if (!isStyleTag(firstChild.parentElement)) {
          setMergedStyleToChild(firstChild.parentElement, normalized, false);
        }
        div.innerHTML = normalized.outerHTML;
        break;
      }
      const dir = firstChild.getAttribute('dir');
      if (dir) {
        div.setAttribute('dir', dir);
      }
      const classes = firstChild.getAttribute('class');
      if (classes) {
        div.setAttribute('class', classes);
      }
      if (tag.toLowerCase() === 'li') {
        if (addFont) {
          addMarkup(replaceFontTagAndColor(firstChild));
          overrideChildFontSize = true;
        }
        break;
      } else {
        div.innerHTML = firstChild.innerHTML;
        setMergedStyleToParent(div, firstChild);
      }
    } else if (addFont) {
      addMarkup(replaceFontTagAndColor(div));
      overrideChildFontSize = true;
      break;
    } else {
      break;
    }
  }
  if (div.childNodes.length > 1) {
    const arr = Array.from(div.childNodes);
    for (const child of arr) {
      let temp;
      if (child.nodeType === Node.TEXT_NODE) {
        temp = document.createElement('span');
        temp.innerHTML = child.nodeValue;
        div.replaceChild(temp, child);
      } else if (child.nodeType === Node.COMMENT_NODE) {
        continue;
      } else {
        temp = replaceFontTagAndColor(child);
      }
      const cssStyle = mergeStyles(div, temp, false, overrideChildFontSize);
      if (cssStyle) {
        temp.setAttribute('style', cssStyle);
      }
      if (temp.children.length === 1 && (shouldSkip(temp.firstChild) || temp.classList.contains('media-container') && temp.querySelectorAll('audio, video').length)) {
        continue;
      }
      if (temp.children.length === 0 && temp.classList.contains('pp-answer-box')) {
        continue;
      }
      if (temp.classList.contains('pp-word-boundary')) {
        addHrefMarkup(temp);
        overrideChildFontSize = true;
        continue;
      }
      normalized = normalizeHtml(temp.innerHTML, temp.tagName, addFont, convertPxToRem);
      if (temp.tagName.toLowerCase() === 'a') {
        temp.innerHTML = normalized.innerHTML;
        setMergedStyleToParent(temp, normalized);
      } else if (normalized.children.length === 0) {
        temp.innerHTML = normalized.innerHTML;
        setMergedStyleToParent(temp, normalized);
      } else {
        if (CONTAINERS.includes(temp.nodeName.toLowerCase())) {
          temp.innerHTML = normalized.innerHTML;
          const style = styleToObject(temp);
          if (style['font-size']) {
            Array.from(temp.children).forEach(child => {
              const span = child;
              const fontSize = FontSizeConstants.getDefault(span.style['font-family']);
              if (parseInt(span.style.fontSize, 10) === fontSize) {
                span.style.fontSize = style['font-size'];
              }
            });
          }
          setMergedStyleToParent(temp, normalized);
          normalizeListAndItems(temp);
        } else {
          while (normalized.children.length > 0) {
            const item = normalized.firstElementChild;
            const childStyle = styleToObject(item);
            let overrideFontSize = true;
            if (parseInt(childStyle['font-size'], 10) && !childStyle['font-family']) {
              overrideFontSize = false;
            }
            setMergedStyleToChild(temp, item, true, overrideFontSize);
            if (overrideFontSize && item.tagName.toLowerCase() === 'a') {
              for (let i = 0; i < item.children.length; i++) {
                setMergedStyleToChild(item, item.children[i], false);
              }
            }
            temp.parentNode.insertBefore(item, temp);
          }
          temp.parentNode.removeChild(temp);
        }
      }
    }
  }
  if (convertPxToRem && CWDetection.isIOS) {
    return normalizeFontSizeForIOS(div);
  }
  return div;
}
function normalizeListAndItems(elem) {
  if (elem) {
    if (elem.tagName.toLowerCase() === 'li') {
      Array.from(elem.children).forEach(itm => {
        const child = itm;
        setMergedStyleToChild(elem, child);
        if ((child.textContent || '').trim()) {
          if (!elem.style.fontSize && child.style.fontSize) {
            elem.style.fontSize = child.style.fontSize;
          }
          if (!elem.style.color && child.style.color) {
            elem.style.color = child.style.color;
          }
        }
      });
      elem.style.textIndent = '-1.3em';
      elem.style.marginLeft = '1em';
      Array.from(elem.getElementsByTagName('a')).forEach(itm => {
        itm.style.textIndent = 'initial';
        itm.style.marginLeft = 'unset';
      });
    }
    if (/^(ul|ol)$/i.test(elem.nodeName)) {
      elem.style.listStylePosition = 'inside';
      if (!elem.style.textAlign) {
        const elmStyle = window.getComputedStyle(elem.parentElement);
        const isCentered = elmStyle.getPropertyValue('text-align') === 'center';
        const elmDirStyle = elmStyle.getPropertyValue('direction');
        if (!isCentered && elmDirStyle) {
          elem.style.textAlign = elmDirStyle === 'rtl' ? 'right' : 'left';
        }
      }
      if (!elem.style.direction && !elem.getAttribute('dir')) {
        const liItem = Array.from(elem.children).find(liElem => !!(liElem.getAttribute('dir') || liElem.style.direction));
        if (liItem) {
          elem.style.direction = liItem.style.direction || liItem.getAttribute('dir');
        }
      }
      Array.from(elem.getElementsByTagName('li')).forEach(li => {
        if (!(li.textContent || '').trim()) {
          const prevElem = li.previousElementSibling;
          if (prevElem) {
            if (prevElem.style.fontSize) {
              li.style.fontSize = prevElem.style.fontSize;
            }
            if (!li.style.color && prevElem.style.color) {
              li.style.color = prevElem.style.color;
            }
          }
        }
      });
    }
  }
  return elem;
}
function replaceFontTagAndColor(tag) {
  if (!tag) {
    return tag;
  }
  const color = tag.getAttribute('color');
  if (tag.nodeName.toLowerCase() === 'font') {
    const span = document.createElement('span');
    span.innerHTML = tag.innerHTML;
    tag.parentNode.replaceChild(span, tag);
    tag = span;
  }
  if (color) {
    tag.style.color = color;
  }
  return tag;
}
function shouldSkip(node) {
  return /^(br)|(img)|(audio)|(video)|(iframe)$/i.test(node.nodeName) ||
  // do not remove empty p tags
  (/^(p)$/i.test(node.nodeName) || node.classList && node.classList.contains('pp-answer-box')) && node.children.length === 0 && node.textContent === '';
}
function isStyleTag(node) {
  return ['strong', 'em', 'b', 'i', 'mark', 'del', 'ins', 'sup', 'sub'].includes((node.nodeName || '').toLowerCase());
}
function addMarkup(element) {
  if (element.children && element.children.length) {
    addHrefMarkup(element);
  } else {
    let markup = createMarkup(element.innerHTML, 'span', false);
    if (element.tagName.toLowerCase() !== 'li') {
      if (markup.children.length === 1) {
        markup = markup.firstChild;
      }
      setMergedStyleToParent(element, markup);
    }
    element.innerHTML = markup.innerHTML;
  }
}
function addHrefMarkup(element) {
  const parentStyle = styleToObject(element);
  element.parentNode.replaceChild(toMarkupRecursively(element, parentStyle['font-size']), element);
}
function toMarkupRecursively(element, fontSize) {
  const arr = Array.from(element.childNodes);
  const res = [];
  for (const item of arr) {
    if (item.nodeType === Node.TEXT_NODE) {
      const temp = createMarkup(item.nodeValue, 'span', false);
      for (let i = 0; i < temp.children.length; i++) {
        const child = temp.children[i];
        setMergedStyleToChild(element, child);
        if (fontSize) {
          child.style.fontSize = fontSize;
        }
      }
      res.push(...Array.from(temp.children));
    } else if (item.nodeType === Node.ELEMENT_NODE) {
      const el = item;
      if (shouldSkip(el)) {
        res.push(el);
      } else {
        const parentStyle = styleToObject(element);
        const markup = toMarkupRecursively(el, parentStyle['font-size'] || fontSize);
        if (el.classList && el.classList.contains('pp-answer-box')) {
          el.innerHTML = markup.children.length ? markup.innerHTML : markup.outerHTML;
          res.push(el);
        } else {
          setMergedStyleToChild(element, markup);
          const isATag = markup.nodeName.toLowerCase() === 'a';
          for (let i = 0; i < markup.children.length; i++) {
            const child = markup.children[i];
            setMergedStyleToChild(item, child);
            if (!isATag) {
              res.push(child);
            }
          }
          if (isATag) {
            res.push(markup);
          }
        }
      }
    }
  }
  const result = element.cloneNode(false);
  for (const item of res) {
    result.appendChild(item);
  }
  result.style.direction = element.dir || 'ltr';
  return result;
}
function setMergedStyleToParent(parent, child) {
  const str = mergeStyles(parent, child, true, true);
  if (str) {
    parent.setAttribute('style', str);
  }
}
function setMergedStyleToChild(parent, child, overrideChildDir = true, overrideChildFontSize = true) {
  const str = mergeStyles(parent, child, overrideChildDir, overrideChildFontSize);
  if (str) {
    child.setAttribute('style', str);
  }
}
/**
 * Merge parent and child style but do not override existing styles of the child
 */
function mergeStyles(parent, child, overrideChildDir = false, overrideChildFontSize = false) {
  const parentStyle = styleToObject(parent);
  const childStyle = styleToObject(child);
  const style = {
    ...parentStyle,
    ...childStyle
  };
  if (overrideChildFontSize && parseInt(parentStyle['font-size'], 10)) {
    style['font-size'] = parentStyle['font-size'];
  }
  if (overrideChildDir && parentStyle['direction'] && childStyle['direction']) {
    style['direction'] = parentStyle['direction'];
  }
  if (parent.nodeName.toLowerCase() === 'span') {
    delete style['text-align'];
  }
  if (parent.nodeName.toLowerCase() === 'a') {
    delete style['display'];
  }
  const res = [];
  const keys = Object.keys(style);
  for (const key of keys) {
    res.push(key + ':' + style[key]);
  }
  return res.length > 0 ? res.join(';') : '';
}
/**
 * LG uses this method to set current arabic font
 * because in LG user can change language several times in one session
 * this should be calls when changing languages
 */
function updateCSSArabicFont() {
  cssArabicFont = getArabicFontFromDocument();
}
/**
 * Convert style string to key value pair object
 */
function styleToObject(element) {
  const res = {};
  if (element && typeof element.getAttribute === 'function') {
    const str = element.getAttribute('style') || '';
    const arr = str.split(';');
    for (const item of arr) {
      const [key, value] = item.split(':');
      if (key && value) {
        res[key.trim()] = value.trim();
      }
    }
  }
  return res;
}
function replaceCRLF(htmlStr) {
  const div = document.createElement('div');
  div.innerHTML = htmlStr || '';
  const walk = document.createTreeWalker(div, NodeFilter.SHOW_TEXT, null);
  let node;
  while (node = walk.nextNode()) {
    node.textContent = node.textContent.replace(/\r?\n|\r/gm, ' ');
  }
  return div.innerHTML;
}
/**
 * replace float punctuations
 */
function replaceFloatComma(str) {
  return (str || '').replace(/\d+([\u002C\u002E])\d+/gm, match => {
    return match.replace(/[\u002C\u002E]/gm, '');
  });
}
function normalizeArabicText(str) {
  if (str.length > 1) {
    return str.replace(/[ﺀﺁﺂﺃﺄﺅﺆﺇﺈﺉﺊﺋﺌﺍﺎ]/gmi, 'ا').replace(/[ﺏﺐﺑﺒ]/gmi, 'ب').replace(/[ﺓﺔ]/gmi, 'ه').replace(/[ﺕﺖﺗﺘ]/gmi, 'ت').replace(/[ﺙﺚﺛﺜ]/gmi, 'ث').replace(/[ﺝﺞﺟﺠ]/gmi, 'ج').replace(/[ﺡﺢﺣﺤ]/gmi, 'ح').replace(/[ﺥﺦﺧﺨ]/gmi, 'خ').replace(/[ﺩﺪ]/gmi, 'د').replace(/[ﺫﺬ]/gmi, 'ذ').replace(/[ﺭﺮ]/gmi, 'ر').replace(/[ﺯﺰ]/gmi, 'ز').replace(/[ﺱﺲﺳﺴ]/gmi, 'س').replace(/[ﺵﺶﺷﺸ]/gmi, 'ش').replace(/[ﺹﺺﺻﺼ]/gmi, 'ص').replace(/[ﺽﺾﺿﻀ]/gmi, 'ض').replace(/[ﻁﻂﻃﻄ]/gmi, 'ط').replace(/[ﻅﻆﻇﻈ]/gmi, 'ظ').replace(/[ﻉﻊﻋﻌ]/gmi, 'ع').replace(/[ﻍﻎﻏﻐ]/gmi, 'غ').replace(/[ﻑﻒﻓﻔ]/gmi, 'ف').replace(/[ﻕﻖﻗﻘ]/gmi, 'ق').replace(/[ﻙﻚﻛﻜ]/gmi, 'ك').replace(/[ﻝﻞﻟﻠ]/gmi, 'ل').replace(/[ﻡﻢﻣﻤ]/gmi, 'م').replace(/[ﻥﻦﻧﻨ]/gmi, 'ن').replace(/[ﻩﻪﻫﻬ]/gmi, 'ه').replace(/[ﻭﻮ]/gmi, 'و').replace(/[ﻯﻰﻱﻲﻳﻴ]/gmi, 'ي').replace(/[ﻵﻶﻷﻸﻹﻺﻻﻼ]/gmi, 'لا');
  } else if (str.length === 1) {
    return str.replace(/[ﺎ]/, '\u200Dا').replace(/[ﺒ]/, '\u200Dب\u200D').replace(/[ﺔ]/, '\u200Dه\u200D').replace(/[ﺘ]/, '\u200Dت\u200D').replace(/[ﺜ]/, '\u200Dث\u200D').replace(/[ﺠ]/, '\u200Dج\u200D').replace(/[ﺤ]/, '\u200Dح\u200D').replace(/[ﺨ]/, '\u200Dخ\u200D').replace(/[ﺪ]/, '\u200Dد\u200D').replace(/[ﺬ]/, '\u200Dذ\u200D').replace(/[ﺮ]/, '\u200Dر\u200D').replace(/[ﺰ]/, '\u200Dز\u200D').replace(/[ﺴ]/, '\u200Dس\u200D').replace(/[ﺸ]/, '\u200Dش\u200D').replace(/[ﺼ]/, '\u200Dص\u200D').replace(/[ﻀ]/, '\u200Dض\u200D').replace(/[ﻄ]/, '\u200Dط\u200D').replace(/[ﻈ]/, '\u200Dظ\u200D').replace(/[ﻌ]/, '\u200Dع\u200D').replace(/[ﻐ]/, '\u200Dغ\u200D').replace(/[ﻔ]/, '\u200Dف\u200D').replace(/[ﻘ]/, '\u200Dق\u200D').replace(/[ﻜ]/, '\u200Dك\u200D').replace(/[ﻠ]/, '\u200Dل\u200D').replace(/[ﻤ]/, '\u200Dم\u200D').replace(/[ﻨ]/, '\u200Dن\u200D').replace(/[ﻬ]/, '\u200Dه\u200D').replace(/[ﻮ]/, '\u200Dو\u200D').replace(/[ﻴ]/, '\u200Dي\u200D').replace(/[ﻼ]/, '\u200Dلا\u200D').replace(/[ﺍ]/, 'ا\u200D').replace(/[ﺑ]/, 'ب\u200D').replace(/[ﺓ]/, 'ه\u200D').replace(/[ﺗ]/, 'ت\u200D').replace(/[ﺛ]/, 'ث\u200D').replace(/[ﺟ]/, 'ج\u200D').replace(/[ﺣ]/, 'ح\u200D').replace(/[ﺧ]/, 'خ\u200D').replace(/[ﺩ]/, 'د\u200D').replace(/[ﺫ]/, 'ذ\u200D').replace(/[ﺭ]/, 'ر\u200D').replace(/[ﺯ]/, 'ز\u200D').replace(/[ﺳ]/, 'س\u200D').replace(/[ﺷ]/, 'ش\u200D').replace(/[ﺻ]/, 'ص\u200D').replace(/[ﺿ]/, 'ض\u200D').replace(/[ﻃ]/, 'ط\u200D').replace(/[ﻇ]/, 'ظ\u200D').replace(/[ﻋ]/, 'ع\u200D').replace(/[ﻏ]/, 'غ\u200D').replace(/[ﻓ]/, 'ف\u200D').replace(/[ﻗ]/, 'ق\u200D').replace(/[ﻛ]/, 'ك\u200D').replace(/[ﻟ]/, 'ل\u200D').replace(/[ﻣ]/, 'م\u200D').replace(/[ﻧ]/, 'ن\u200D').replace(/[ﻫ]/, 'ه\u200D').replace(/[ﻭ]/, 'و\u200D').replace(/[ﻳ]/, 'ي\u200D').replace(/[ﻻ]/, 'ل\u200Dا').replace(/[ﺌ]/, '\u200Dا').replace(/[ﺐ]/, '\u200Dب').replace(/[ﺖ]/, '\u200Dت').replace(/[ﺚ]/, '\u200Dث').replace(/[ﺞ]/, '\u200Dج').replace(/[ﺢ]/, '\u200Dح').replace(/[ﺦ]/, '\u200Dخ').replace(/[ﺲ]/, '\u200Dس').replace(/[ﺶ]/, '\u200Dش').replace(/[ﺺ]/, '\u200Dص').replace(/[ﺾ]/, '\u200Dض').replace(/[ﻂ]/, '\u200Dط').replace(/[ﻆ]/, '\u200Dظ').replace(/[ﻊ]/, '\u200Dع').replace(/[ﻎ]/, '\u200Dغ').replace(/[ﻒ]/, '\u200Dف').replace(/[ﻖ]/, '\u200Dق').replace(/[ﻚ]/, '\u200Dك').replace(/[ﻞ]/, '\u200Dل').replace(/[ﻢ]/, '\u200Dم').replace(/[ﻦ]/, '\u200Dن').replace(/[ﻪ]/, '\u200Dه').replace(/[ﻲ]/, '\u200Dي').replace(/[ﻺ]/, '\u200Dلا');
  } else {
    return str;
  }
}
/**
 *remove spaces before punctuations
 */
function replaceSpacesBeforePunctuations(txt) {
  const oneSpaceBeforePunctuationReg = new RegExp('([' + SPACES_UNICODE + ']){1}([' + PUNCTUATIONS_UNICODE + '])$', 'g');
  const clearReg = new RegExp('[' + SPACES_UNICODE.replace('\u00A0', '') + ']([' + PUNCTUATIONS_UNICODE + '])$', 'g');
  return txt.replace(oneSpaceBeforePunctuationReg, (match, p1, p2) => {
    return String.fromCharCode(0x00A0) + p2;
  }).replace(clearReg, '$1');
}
function pixelToRem(pixel) {
  return 0.0625 * pixel;
}
function pixelStrToRemStr(fontSizeStr) {
  if (fontSizeStr.includes('px')) {
    fontSizeStr = pixelToRem(parseInt(fontSizeStr, 10)) + 'rem';
  }
  return fontSizeStr;
}
function normalizeFontSizeForIOS(elem) {
  if (elem) {
    Array.from(elem.getElementsByTagName("*")).concat([elem]).forEach(el => {
      if (el.style?.fontSize) {
        el.style.fontSize = pixelStrToRemStr(el.style.fontSize);
      }
    });
  }
  return elem;
}
function getNodeItems(elem, items, config) {
  if (!elem.firstElementChild) {
    items.push(getNodeItem(elem, config));
  } else {
    const arr = Array.from(elem.childNodes);
    for (const item of arr) {
      if (item.nodeType === Node.TEXT_NODE) {
        getNodeItems(createHtmlMarkup(item.textContent || item.nodeValue), items, config);
      } else {
        getNodeItems(item, items, config);
      }
    }
  }
}
function getNodeItem(elem, config) {
  const font = elem.style.fontFamily;
  const direction = elem.style.direction || elem.getAttribute('dir') || 'ltr';
  return {
    font,
    text: elem.textContent || elem.innerText,
    direction,
    color: elem.style.color,
    code: getCodeFromFontName(font, config),
    fontSize: getFontSize(direction)
  };
}
function getCodeFromFontName(fontName, config) {
  return fontName === config.knownFontFamily ? config.knownLanguageCode : fontName === config.learningFontFamily ? config.learningLanguageCode : config.uiLanguageCode;
}
function getFontSize(direction) {
  return direction === 'ltr' ? 12 : 14;
}

/**
 * hide or show question titles
 */
function groupByQuestionType(questions) {
  if (!questions || !questions.length) {
    return [];
  }
  let hasAnswers = false;
  for (let i = 0; i < questions.length; i++) {
    if (i === 0) {
      hasAnswers = questions[i].answers.length > 0;
      questions[i].isShowElement = true;
    } else if (questions[i].answers.length && !hasAnswers || !questions[i].answers.length && hasAnswers) {
      questions[i - 1].hideBottom = false;
      hasAnswers = !hasAnswers;
      questions[i].isShowElement = true;
    } else {
      questions[i].hideTop = true;
      if (hasAnswers && !questions[i].isShowElement) {
        questions[i - 1].hideBottom = true;
      }
    }
    if (i !== questions.length - 1) {
      questions[i].hideBottom = true;
    }
  }
  return questions;
}
class AlphabetCard extends BykiCard {
  clone() {
    const dest = super.clone();
    dest.examples = this.examples ? this.examples.slice(0).map(example => example.clone()) : this.examples;
    return dest;
  }
}
const zipPat = /\.zip|\.b4x/g;
let B4xLoaderService = /*#__PURE__*/(() => {
  class B4xLoaderService {
    constructor(http) {
      this.http = http;
      this.b4xMap = {};
    }
    ngOnDestroy() {
      this.b4xMap = null;
    }
    removeUrlFromMemory(url) {
      if (url && url.includes('blob:')) {
        URL.revokeObjectURL(url);
      }
    }
    getUrlFromZip(url, readAsDataUri = false) {
      if (!url || !this.isZipFile(url)) {
        return of(url);
      }
      const pos = (url.includes('.zip') ? url.indexOf('.zip') : url.indexOf('.b4x')) + 4;
      const key = url.substr(0, pos);
      zipPat.lastIndex = 0;
      url = url.substr(pos + 1);
      const urlWithFolder = getB4xFolderName(key).replace(zipPat, '') + '/' + url;
      const zip = this.b4xMap[key] || this.b4xMap[key.replace(/^(file:|http:|https:)/g, '')];
      if (!zip) {
        return of(url);
      }
      return from((zip.files[url] || zip.files[urlWithFolder]).async(readAsDataUri ? 'base64' : 'blob')).pipe(map$1(b => {
        // It seems like WebKit would easily allow you to convert a Blob into a Data URL using FileReader.readAsDataURL().
        if (typeof b === 'string') {
          url = `data:${getMimeTypeFromUrl(url)};base64,${b}`;
        } else {
          url = URL.createObjectURL(new Blob([b], {
            type: getMimeTypeFromUrl(url)
          }));
        }
        return url;
      }));
    }
    /**
     * Better method for loading all data
     */
    loadData(urls, config) {
      if (!urls || !urls.length) {
        return of([]);
      }
      const requests = [];
      for (let url of urls) {
        url = url.trim();
        zipPat.lastIndex = 0;
        if (zipPat.test(url)) {
          requests.push(this.http.get(url, {
            responseType: 'arraybuffer',
            observe: 'response'
          }).pipe(mergeMap(resp => {
            const zip = new JSZip();
            return from(zip.loadAsync(resp.body));
          }), mergeMap(zip => {
            this.b4xMap[url] = zip;
            zipPat.lastIndex = 0;
            const folderName = getB4xFolderName(url).replace(zipPat, '');
            let xmlUrl = '';
            const pat = new RegExp(`${folderName}\\.xml|list\\.xml`, 'g');
            for (const key in zip.files) {
              if (zip.files[key]) {
                pat.lastIndex = 0;
                if (pat.test(key)) {
                  xmlUrl = key;
                  break;
                }
              }
            }
            return from(zip.files[xmlUrl].async('text'));
          })));
        }
      }
      return forkJoin(requests).pipe(map$1(results => {
        const loadedData = [];
        const errorStr = [];
        let isError = false;
        const len = results.length;
        let list;
        for (let i = 0; i < len; i++) {
          const url = urls[i];
          const result = XMLUtil.parseFromString(results[i]);
          if (result.error) {
            errorStr.push(url);
            isError = true;
            break;
          } else {
            const xml = result.xml.firstChild ? result.xml.firstChild : new Element();
            if (xml.tagName === 'list') {
              list = createBykiListFromXmlList(xml, url || '', config.isTransliterated);
              list.url = url;
              loadedData.push(list);
            }
          }
        }
        return loadedData;
      }));
    }
    isZipFile(url) {
      zipPat.lastIndex = 0;
      return zipPat.test(url || '');
    }
    static {
      this.ɵfac = function B4xLoaderService_Factory(t) {
        return new (t || B4xLoaderService)(i0.ɵɵinject(i1.HttpClient));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: B4xLoaderService,
        factory: B4xLoaderService.ɵfac
      });
    }
  }
  return B4xLoaderService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function getMimeTypeFromUrl(url) {
  url = url || '';
  let mimeType = '';
  const ext = url.substring(url.lastIndexOf('.'));
  switch (ext) {
    case '.gif':
      mimeType = 'image/gif';
      break;
    case '.jpg':
    case '.jpeg':
      mimeType = 'image/jpeg';
      break;
    case '.png':
      mimeType = 'image/png';
      break;
    case '.svg':
      mimeType = 'image/svg+xml';
      break;
    case '.webp':
      mimeType = 'image/webp';
      break;
    case '.ogg':
      mimeType = 'audio/ogg';
      break;
    case '.mp3':
      mimeType = 'audio/mpeg';
      break;
    case '.mp4':
      mimeType = 'video/mp4';
      break;
    default:
      mimeType = '';
      break;
  }
  return mimeType;
}
let DataLoaderService = /*#__PURE__*/(() => {
  class DataLoaderService {
    /**
     * Convert json alphabet object to BykiList
     */
    static bykiListFromAlphabet(alphabet, config, url) {
      const alphabetElement = alphabet.alphabet || alphabet;
      const bykiList = new BykiList();
      const cardList = [];
      bykiList.side1Lang = config.knownLanguageCode;
      bykiList.side2Lang = alphabetElement.getAttribute('key') || 'ENGLISH';
      const langName = bykiList.side2Lang === config.learningLanguageCode ? config.learningLanguage : config.knownLanguage;
      bykiList.name = ('Alphabet ' + langName || '').trim();
      let baseURL = url.substring(0, url.lastIndexOf('alphabet'));
      baseURL += alphabetElement.getAttribute('mediaUrl');
      const list = alphabetElement.getElementsByTagName('letter');
      const len = list.length;
      for (let i = 0; i < len; i++) {
        const item = list[i];
        const card = new AlphabetCard();
        const letterSound = item.getAttribute('namesound');
        const letterImage = item.getAttribute('image');
        card.cardSide1Text = item.getAttribute('name') || '';
        card.cardSide2Text = DataLoaderService.stringFromCharCode(item.getAttribute('charcode'));
        card.cardSide2Text = card.cardSide2Text.replace(/\u005F/ig, ''); // fixes thai underscores
        card.cardTranslit = item.getAttribute('translation') || '';
        card.cardSide2Hint = item.getAttribute('hint') || '';
        if (letterSound) {
          card.soundSide2 = baseURL + letterSound;
        }
        if (letterImage) {
          card.picture = baseURL + letterImage;
        }
        if (card.cardSide1Text && card.cardSide2Text) {
          card.hid = createHid(card.cardSide1Text, card.cardSide2Text, bykiList.side1Lang, bykiList.side2Lang);
        }
        card.examples = parseExamples(item, baseURL);
        cardList.push(card);
      }
      bykiList.cards = cardList;
      bykiList.url = url;
      return bykiList;
    }
    /**
     * Converts hex string to string
     */
    static stringFromCharCode(value = '') {
      const chars = value ? value.split(',') : [];
      const len = chars.length;
      for (let i = 0; i < len; i++) {
        chars[i] = String.fromCharCode(+chars[i]);
      }
      return chars.join('');
    }
    /**
     * Utility method for finding byki List for module
     */
    static findModuleList(lists, urls) {
      lists = lists || [];
      const resLists = [];
      for (const url of urls) {
        for (const list of lists) {
          if (list && list.url === url) {
            resLists.push(list);
          }
        }
      }
      if (resLists.length !== urls.length) {
        return null;
      }
      return DataLoaderService.mergeLists(resLists);
    }
    /**
     * Creates new BykiList based on configuration data
     */
    static createPartialList(list, config) {
      const partialList = list.clone();
      partialList.url += config.activityConfig.alphabetRange; // rename list
      const len = partialList.cards.length;
      let start = 0;
      let end = len;
      const ranges = config.activityConfig.alphabetRange.split('-');
      if (ranges.length === 2) {
        start = parseInt(ranges[0], 10);
        start = start - 1;
        start = Math.max(0, start);
        end = parseInt(ranges[1], 10);
        if (end > len) {
          end = len;
        }
      }
      partialList.cards = partialList.cards.slice(start, end);
      return partialList;
    }
    /**
     * Joins  all cards and returns single list
     */
    static mergeLists(lists = []) {
      let cards = [];
      for (const list of lists) {
        cards = cards.concat(list.cards);
      }
      if (cards.length > 0) {
        const resList = lists[0].clone();
        resList.cards = cards;
        return resList;
      }
      return null;
    }
    constructor(http, b4xLoader) {
      this.http = http;
      this.b4xLoader = b4xLoader;
    }
    /**
     * Better method for loading all data
     */
    loadData(urls, config, parseAlphabet = true) {
      const requests = [];
      const b4xUrls = urls.filter(str => /\.zip|\.b4x/g.test(str));
      urls = urls.filter(str => !/\.zip|\.b4x/g.test(str));
      let obs = of([]);
      if (urls.length) {
        for (let url of urls) {
          url = url.trim();
          requests.push(this.http.get(createFullUrl(url), {
            responseType: 'text',
            observe: 'response'
          }));
        }
        obs = forkJoin(requests).pipe(map$1(results => {
          const loadedData = [];
          const errorStr = [];
          let isError = false;
          const len = results.length;
          let list;
          for (let i = 0; i < len; i++) {
            const resp = results[i];
            const url = urls[i];
            const result = XMLUtil.parseFromString(resp.body);
            if (result.error) {
              errorStr.push(resp.url);
              isError = true;
              break;
            } else {
              const xml = result.xml.firstChild ? result.xml.firstChild : new Element();
              if (xml.tagName === 'list') {
                list = createBykiListFromXmlList(xml, url || '', config.isTransliterated);
                list.url = url;
                loadedData.push(list);
              } else if (xml.tagName === 'alphabet') {
                if (parseAlphabet) {
                  list = DataLoaderService.bykiListFromAlphabet(xml, config, url);
                  loadedData.push(list);
                } else {
                  loadedData.push(xml);
                }
              } else {
                loadedData.push(xml);
              }
            }
          }
          return loadedData;
        }));
      }
      return forkJoin([obs, this.b4xLoader.loadData(b4xUrls, config)]).pipe(map$1(arr => arr.reduce((acc, cur) => acc.concat(cur), [])));
    }
    static {
      this.ɵfac = function DataLoaderService_Factory(t) {
        return new (t || DataLoaderService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(B4xLoaderService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: DataLoaderService,
        factory: DataLoaderService.ɵfac
      });
    }
  }
  return DataLoaderService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function parseExamples(elem, baseURL) {
  const res = [];
  const list = Array.from(elem.getElementsByTagName('example'));
  for (const item of list) {
    const card = new BykiCard();
    const letterSound = item.getAttribute('sound');
    const letterImage = item.getAttribute('image');
    card.cardSide1Text = item.getAttribute('name') || '';
    card.cardSide2Text = item.textContent || item.nodeValue || '';
    card.cardSide2Text = card.cardSide2Text.replace(/\u005F/ig, ''); // fixes thai underscores
    card.cardTranslit = item.getAttribute('translation') || '';
    if (letterSound) {
      card.soundSide2 = baseURL + letterSound;
    }
    if (letterImage) {
      card.picture = baseURL + letterImage;
    }
    res.push(card);
  }
  return res;
}
const ACTIVE_HAND_BEGIN = 8; // Const A CONST_A
const ACTIVE_HAND_MAX = 1; // M CONST_M
const ACTIVE_HAND_MIN = 2; // N CONST_N
const CONST_T = 2; // Const T CONST_T
const CONST_K = 6; // K CONST_K  % of correct answers
const CONST_J = 4; // J CONST_J  % of incorrect
const INACTIVE_HAND_CHUNK = 2; // Const G CONST_G no of cards moved into [AH] from [IAH]
const INACTIVE_HAND_CHUNK_LOW = 2; // CONST_P move from inactive when activeHand size less than ACTIVE_HAND_MIN
// const LEARNED_PILE_CHUNK = 2;      // Const V CONST_V no of cards moved into [AH] from [LP]
const CONST_H = 1; // move from activeHand to inActiveHand
const CONST_V = 1; // learnedPile to ActiveHand
const CONST_D = 1; // # of flips after which a decision is made
const BABA_SIZE = 2;
/**
 * Generates a list of random indices
 */
function generateRandomIndices(num) {
  const res = [];
  for (let i = 0; i < num; i++) {
    res.push(i);
  }
  for (let i = 0; i < num * 2; i++) {
    res.splice(num * Math.random() | 0, 0, res.splice(num * Math.random() | 0, 1)[0]);
  }
  return res;
}
let BpahService = /*#__PURE__*/(() => {
  class BpahService {
    constructor() {
      /**
       * Correct sequence size
       */
      this.correctSequenceSize = 0;
      /**
       * Current item index
       */
      this.itemIndex = 0; // change it any time item changes
      /**
       * Completion state
       */
      this.isCompleted = false;
      this.progress = 0;
      this.activeCounter = 0;
      this.activeHandSize = 0;
      this.correctAnswersCount = 0;
      this.endScore = 1;
      this.ghostScore = 1;
      this.incorrectAnswersCount = 0;
      this.learnedCounter = 0;
      this.learningHistory = [];
      this.nextItemIndex = 0;
      this.numCompleted = 0;
      this.numItems = 0;
      this.scores = [];
      this.showedHand = [];
      this.startScore = 0;
      this.urgentCounter = 0;
      this.isOrderByListPosition = false;
      this.isRefreshSession = false;
    }
    static {
      this.PREVIEW = {
        min: 0,
        max: 1
      };
    }
    static {
      this.SRRECOGNIZE = {
        min: 1,
        max: 4
      };
    }
    static {
      this.SRPRODUCE = {
        min: 5,
        max: 7
      };
    }
    static {
      this.WRECOGNIZE = {
        min: 4,
        max: 5
      };
    }
    static {
      this.WPRODUCE = {
        min: 7,
        max: 8
      };
    }
    static {
      this.MC = {
        min: 0,
        max: 2
      };
    }
    static {
      this.DICTATION = {
        min: 1,
        max: 2
      };
    }
    /**
     * No need for this
     * Accept user answer and update presentation
     */
    accept(isCorrect) {
      isCorrect = !!isCorrect;
      const oldIndex = this.itemIndex;
      if (oldIndex < this.numItems && oldIndex >= 0) {
        this.scores[oldIndex] = isCorrect ? this.endScore : this.startScore;
      }
      this.numCompleted = this.getCompletedCards();
      this.progress = Math.ceil(this.numCompleted * 100 / this.numItems);
      this.isCompleted = this.numCompleted === this.numItems;
      return this.updateItemIndex(isCorrect, true, isCorrect);
    }
    clean() {
      this.correctSequenceSize = 0;
      this.itemIndex = 0; // change it any time item changes
      this.nextItemIndex = 0;
      this.isCompleted = false;
      this.isOrderByListPosition = false;
      this.isRefreshSession = false;
      this.progress = 0;
      this.activeCounter = 0;
      this.activeHandSize = 0;
      this.activeStack = null;
      this.correctAnswersCount = 0;
      this.currentItem = null;
      this.endScore = 1;
      this.ghostScore = 1;
      this.incorrectAnswersCount = 0;
      this.learnedCounter = 0;
      this.learningHistory = [];
      this.numCompleted = 0;
      this.numItems = 0;
      this.queue = null;
      this.scores = [];
      this.scoreHash = null;
      this.showedHand = [];
      this.startScore = 0;
      this.urgentCounter = 0;
    }
    /**
     * Returns object containing score
     */
    getScoreByHid(hid) {
      return this.scoreHash ? this.scoreHash[hid] : null;
    }
    /**
     * Returns number of completed cards
     */
    getCompletedCards() {
      let num = 0;
      for (const scope of this.scores) {
        if (!scope) {
          continue;
        }
        if (scope >= this.endScore) {
          num++;
        }
      }
      return num;
    }
    /**
     * get index by hid
     */
    getItemIndexByHid(hid) {
      const item = this.getScoreByHid(hid);
      if (item) {
        this.itemIndex = item.index;
      }
      return this.itemIndex;
    }
    /**
     * Initialize presentation
     */
    initPresentation(cards, min, max, ghost = 1, currentItemIndex = -1, orderByListPosition = false, isRefreshSession = false) {
      if (!cards || cards.length === 0) {
        this.itemIndex = -1;
        return this.itemIndex;
      }
      this.clean();
      const isCompleted = this.calculateCompletion(cards, max);
      this.isOrderByListPosition = orderByListPosition && cards.every(card => typeof card.cardPosition !== 'undefined');
      if (this.isOrderByListPosition) {
        cards = cards.sort((a, b) => a.cardPosition - b.cardPosition);
      }
      this.isRefreshSession = isRefreshSession;
      this.ghostScore = ghost;
      this.queue = [];
      this.showedHand = [];
      this.activeStack = [];
      this.learningHistory = [];
      this.startScore = min;
      this.endScore = max;
      this.scoreHash = this.createHidMap(cards);
      this.numItems = cards.length;
      this.scores = [];
      for (let i = 0; i < this.numItems; i++) {
        this.scores[i] = isCompleted ? this.endScore : Math.max(cards[i].score, this.startScore);
      }
      this.numCompleted = this.getCompletedCards();
      this.correctAnswersCount = this.numCompleted;
      this.incorrectAnswersCount = 0;
      this.correctSequenceSize = 0;
      const indices = this.isOrderByListPosition ? cards.map((card, idx) => idx) : generateRandomIndices(this.scores.length);
      for (let i = 0; i < this.numItems; i++) {
        const index = indices[i];
        const card = cards[index];
        if (card) {
          card.hid = card.hid || index + '';
          card.score = card.score || 0;
          this.scoreHash[card.hid].index = index;
          this.insertItemIntoQueue({
            index,
            inLearning: card.score >= this.startScore,
            isLearned: card.score >= this.endScore,
            hid: card.hid
          }, this.isOrderByListPosition);
        }
      }
      this.activeHandSize = Math.min(this.queue.length, ACTIVE_HAND_BEGIN);
      if (currentItemIndex !== -1) {
        this.currentItem = this.getByIndex(currentItemIndex);
      } else {
        this.currentItem = this.getRandomIndex();
      }
      this.itemIndex = this.currentItem.index;
      this.progress = Math.ceil(this.numCompleted * 100 / this.numItems);
      this.isCompleted = this.numCompleted === this.numItems;
      return this.itemIndex;
    }
    /**
     * Changes itemIndex for Item Skip.
     */
    skip() {
      if (!this.currentItem) {
        return -1;
      }
      if (this.activeStack.length > 0) {
        if (this.activeStack.length < BABA_SIZE) {
          this.moveToShowed(this.currentItem);
        }
        this.currentItem = this.activeStack.pop();
        if (this.activeStack.length < BABA_SIZE) {
          this.removeItem(this.currentItem);
        }
      } else {
        this.moveToShowed(this.currentItem);
        this.currentItem = this.getRandomIndex();
      }
      this.itemIndex = this.currentItem.index;
      return this.itemIndex;
    }
    /**
     * replace card
     */
    replaceCard(hid, card) {
      this.scoreHash[card.hid] = {
        score: Math.max(card.score, this.startScore),
        hid: card.hid,
        isCorrect: false,
        numWrongAnswer: 0,
        index: this.scoreHash[hid].index
      };
      this.correctAnswersCount -= this.scoreHash[hid].score - this.startScore;
      this.correctSequenceSize -= this.scoreHash[hid].score - this.startScore;
      this.incorrectAnswersCount -= this.scoreHash[hid].numWrongAnswer;
      this.learningHistory = this.learningHistory.filter(idx => idx !== this.itemIndex);
      this.learningHistory.push(this.itemIndex);
      delete this.scoreHash[hid];
      this.scores[this.itemIndex] = Math.max(card.score, this.startScore);
      this.currentItem.isLearned = false;
      this.currentItem.inLearning = true;
      this.currentItem.hid = card.hid;
    }
    /**
     *  Updates core of given card
     */
    updateScore(card, isCorrect, similarHid) {
      if (!this.scoreHash || !card) {
        return null;
      }
      let similar;
      const curScore = this.scoreHash[card.hid];
      const numWrongAnswer = curScore.numWrongAnswer;
      const oldScore = curScore.score;
      let newScore = oldScore;
      if (isCorrect) {
        if (this.ghostScore === 2) {
          // for refresh we need show twice
          newScore = Math.min(this.endScore, Math.max(newScore + 1, this.startScore + 1));
        } else {
          if (!curScore.numWrongAnswer) {
            newScore = this.endScore;
          } else {
            newScore = Math.min(this.endScore, Math.max(newScore + 1, this.startScore + 1));
          }
        }
      } else {
        if (curScore.numWrongAnswer) {
          newScore = Math.max(this.startScore, newScore - 1);
        } else {
          curScore.numWrongAnswer++;
          newScore = Math.max(this.startScore, this.endScore - 2);
        }
        if (similarHid && this.scoreHash[similarHid]) {
          similar = this.scoreHash[similarHid];
          similar.score = Math.max(this.startScore, this.endScore - 2);
          similar.numWrongAnswer++;
          this.scores[similar.index] = similar.score;
        }
      }
      curScore.score = newScore;
      this.scores[this.itemIndex] = newScore;
      this.updateItemIndex(isCorrect, newScore >= this.startScore, newScore >= this.endScore, similarHid);
      if (!this.isRefreshSession && oldScore === newScore) {
        return null;
      } else if (this.isRefreshSession && oldScore === newScore && numWrongAnswer === curScore.numWrongAnswer) {
        return null;
      }
      this.numCompleted = this.getCompletedCards();
      this.progress = Math.ceil(this.numCompleted * 100 / this.numItems);
      this.isCompleted = this.numCompleted === this.numItems;
      const changedScore = this.cloneChangedScore(this.scoreHash[card.hid]);
      changedScore.isCorrect = isCorrect;
      changedScore.ancillaryScore = card.ancillaryScore || 0;
      return changedScore;
    }
    cloneChangedScore(changedScore) {
      if (!changedScore) {
        return null;
      }
      // changedScore = changedScore || {};
      return {
        index: changedScore.index,
        score: changedScore.score,
        hid: changedScore.hid,
        isCorrect: changedScore.isCorrect,
        ancillaryScore: changedScore.ancillaryScore,
        numWrongAnswer: changedScore.numWrongAnswer
      };
    }
    /**
     * Checks if cards already learned for give score;
     */
    calculateCompletion(cards, score) {
      const len = cards.length;
      let num = 0;
      for (let i = 0; i < len; i++) {
        if (cards[i].score >= score) {
          num++;
        }
      }
      return num === len;
    }
    /**
     * Creates hid key value map
     */
    createHidMap(cards) {
      let maxScore = 0;
      const map = {};
      const len = cards.length;
      for (let i = 0; i < len; i++) {
        const card = cards[i];
        card.hid = card.hid || i + '';
        maxScore = map[card.hid] ? Math.max(map[card.hid].score, card.score) : card.score || 0;
        map[card.hid] = {
          score: maxScore,
          hid: card.hid,
          isCorrect: false,
          numWrongAnswer: 0
        };
      }
      return map;
    }
    /**
     * Finds cards with same hid for BABA
     */
    findSimilarItem(hid, index) {
      if (!hid) {
        return null;
      }
      for (const card of this.queue) {
        if (card.hid === hid && card.index !== index) {
          return card;
        }
      }
      const len = this.showedHand.length;
      for (let i = 0; i < len; i++) {
        const card = this.showedHand[i];
        if (card && card.hid === hid && card.index !== index) {
          return card;
        }
        if (this.showedHand[i].hid === hid) {
          return this.showedHand[i];
        }
      }
      return null;
    }
    /**
     * Put next random item in learning history adn return its index
     */
    getRandomIndex() {
      let item;
      const newElementIndex = this.nextItemIndex || 0;
      if (this.queue.length > 0) {
        this.nextItemIndex = 0;
        item = this.removeItemFromQueue(newElementIndex);
      } else {
        item = this.showedHand.pop();
      }
      if (item) {
        this.learningHistory.push(item.index);
        return item;
      }
      return null;
    }
    /**
     * Find item by index and makes it current item
     */
    getByIndex(index) {
      let item;
      let newElementIndex;
      if (this.queue.length > 0) {
        newElementIndex = this.findItemIndexByIndex(this.queue, index);
        item = this.removeItemFromQueue(newElementIndex);
      } else {
        newElementIndex = this.findItemIndexByIndex(this.showedHand, index);
        item = this.showedHand[newElementIndex];
        this.showedHand.splice(newElementIndex, 1);
      }
      if (item) {
        this.learningHistory.push(item.index);
        return item;
      }
      return null;
    }
    findItemIndexByIndex(items, index) {
      for (let i = 0; i < items.length; i++) {
        if (items[i].index === index) {
          return i;
        }
      }
      return -1;
    }
    /**
     * Insert item into appropriate place into queue
     */
    insertItemIntoQueue(item, needPushToEnd = false) {
      let insertPosition;
      if (item.isLearned) {
        insertPosition = this.queue.length;
        // add to the end of queue
        this.queue.push(item);
        this.learnedCounter++;
      } else if (item.inLearning && !needPushToEnd) {
        insertPosition = this.urgentCounter;
        // insert at activeCounter+urgentCounter position
        this.queue.splice(this.urgentCounter, 0, item);
        this.activeCounter++;
      } else {
        // insert after urgentCounter position
        insertPosition = this.urgentCounter;
        this.queue.splice(insertPosition, 0, item);
        this.urgentCounter++;
      }
      return insertPosition;
    }
    /**
     * Put item to showed hand
     */
    moveToShowed(item) {
      this.showedHand.unshift(item); // add to showed
      if (this.showedHand.length > CONST_T) {
        item = this.showedHand.pop();
        const idx = this.insertItemIntoQueue(item);
        const score = this.getScoreByHid(item.hid);
        if (!item.isLearned && item.inLearning && (score && score.numWrongAnswer > 0 || this.isOrderByListPosition)) {
          this.nextItemIndex = idx;
        }
      }
    }
    /**
     * Remove item from queue
     */
    removeItemFromQueue(index) {
      const item = this.queue[index];
      this.queue.splice(index, 1); // remove item from queue
      this.updateForRemoved(item);
      return item;
    }
    /**
     * Find item in queue and remove it
     */
    removeItem(item) {
      for (let i = 0; i < this.queue.length; i++) {
        if (this.queue[i].index === item.index) {
          this.updateForRemoved(item);
          this.queue.splice(i, 1);
          return;
        }
      }
      for (let i = 0; i < this.showedHand.length; i++) {
        if (this.showedHand[i].index === item.index) {
          this.updateForRemoved(item);
          this.showedHand.splice(i, 1);
          return;
        }
      }
    }
    /**
     * Changes item index according to byki presentation mechanism.
     */
    updateItemIndex(correct, inLearning, learned, similarHid) {
      if (!this.currentItem) {
        return -1;
      }
      let item;
      const similarItem = this.findSimilarItem(similarHid, this.currentItem.index);
      // update answers counter
      if (correct) {
        this.correctAnswersCount++;
        this.correctSequenceSize++;
      } else {
        this.incorrectAnswersCount++;
        this.correctSequenceSize = 0;
      }
      if (correct && learned) {
        if (this.activeStack.length < BABA_SIZE) {
          item = this.currentItem;
          item.inLearning = inLearning;
          item.isLearned = learned;
          this.moveToShowed(item);
        }
      } else if (correct) {
        if (this.activeStack.length < BABA_SIZE) {
          item = this.currentItem;
          item.inLearning = inLearning;
          item.isLearned = learned;
          this.moveToShowed(item);
        }
      } else if (similarItem) {
        // return item into queue
        if (this.activeStack.length < BABA_SIZE) {
          this.insertItemIntoQueue(this.currentItem);
        }
        // create BAB sequence
        this.activeStack = [];
        this.activeStack.push(similarItem);
        this.activeStack.push(this.currentItem);
        this.activeStack.push(similarItem);
        this.activeStack.push(this.currentItem);
      } else {
        if (this.activeStack.length > BABA_SIZE) {
          this.removeItem(this.currentItem);
        }
        // Incorrect answer - repeat
        this.currentItem.inLearning = inLearning;
        this.currentItem.isLearned = learned;
        // Clear activeStack
        this.activeStack = [];
        this.itemIndex = this.currentItem.index;
        return this.itemIndex;
      }
      if (this.activeStack.length > 0) {
        this.currentItem = this.activeStack.pop();
        if (this.activeStack.length < BABA_SIZE) {
          this.removeItem(this.currentItem);
        }
        this.itemIndex = this.currentItem.index;
        return this.itemIndex;
      }
      // Adjust activeHand and inactiveHand
      if (this.activeHandSize < ACTIVE_HAND_MAX) {
        if (this.activeHandSize < this.activeCounter) {
          // change activeHand size
          const letQ = 100 * (this.correctAnswersCount / (this.correctAnswersCount + this.incorrectAnswersCount));
          const letW = 100 * (this.incorrectAnswersCount / (this.correctAnswersCount + this.incorrectAnswersCount));
          // all OK - activeHand increasing
          if (this.correctAnswersCount + this.incorrectAnswersCount >= CONST_D && (this.correctAnswersCount + this.incorrectAnswersCount) % CONST_D === 0 && letQ > CONST_K) {
            this.activeHandSize = this.activeHandSize + INACTIVE_HAND_CHUNK;
          }
          // too bad - activeHand decreasing
          if (letW >= CONST_J && this.activeHandSize - CONST_H > ACTIVE_HAND_MIN) {
            this.activeHandSize -= CONST_H;
          }
          // small activeHand size - move from inactiveHand
          if (this.activeHandSize <= ACTIVE_HAND_MIN) {
            this.activeHandSize = this.activeHandSize + INACTIVE_HAND_CHUNK_LOW;
          }
        } else {
          // small activeHand size - move from LearnedPile
          if (this.activeHandSize <= ACTIVE_HAND_MIN) {
            this.activeHandSize = this.activeHandSize + CONST_V;
          }
        }
      }
      this.currentItem = this.getRandomIndex();
      this.itemIndex = this.currentItem.index;
      return this.itemIndex;
    }
    /**
     * Update properties after removing an item
     */
    updateForRemoved(item) {
      if (item.isLearned && this.learnedCounter > 0) {
        this.learnedCounter--;
      } else if (item.inLearning && this.activeCounter > 0) {
        this.activeCounter--;
      } else if (this.urgentCounter > 0) {
        // baba sequense can change... urgentCounter
        this.urgentCounter--;
      }
    }
    static {
      this.ɵfac = function BpahService_Factory(t) {
        return new (t || BpahService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: BpahService,
        factory: BpahService.ɵfac
      });
    }
  }
  return BpahService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const baseUrl$1 = getCWBaseUrl();
const isGameMode = window.playerName === 'GamePlayer';
function interval(delay, useRxjs = true) {
  if (!isGameMode && useRxjs) {
    return rxjs.interval(delay);
  }
  return new rxjs.Observable(observer => {
    let worker = null;
    let intervalId;
    let messageHandler = evt => {
      if (evt.data.type === 'intervalTick') {
        observer.next(evt.data.data);
      }
    };
    try {
      worker = new Worker(baseUrl$1 + 'assets/worker.js');
      worker.addEventListener('message', messageHandler);
      worker.postMessage({
        type: 'startInterval',
        interval: delay
      });
    } catch (e) {
      let counter = 0;
      intervalId = setInterval(() => {
        messageHandler({
          data: {
            type: 'intervalTick',
            data: ++counter
          }
        });
      }, delay);
    }
    return () => {
      if (worker) {
        worker.postMessage({
          type: 'stopInterval'
        });
        worker.removeEventListener('message', messageHandler);
        worker.terminate();
        worker = null;
        messageHandler = null;
      }
      if (intervalId) {
        clearInterval(intervalId);
        intervalId = null;
      }
    };
  });
}
function timer(delay, useRxjs = true) {
  if (!isGameMode && useRxjs) {
    return rxjs.timer(delay);
  }
  return new rxjs.Observable(observer => {
    let worker;
    let timeoutId;
    let messageHandler = evt => {
      if (evt.data.type === 'timeoutTick') {
        observer.next(evt.data.data);
        observer.complete();
      }
    };
    try {
      worker = new Worker(baseUrl$1 + 'assets/worker.js');
      worker.addEventListener('message', messageHandler);
      worker.postMessage({
        type: 'startTimeout',
        timeout: delay
      });
    } catch (e) {
      timeoutId = setTimeout(() => {
        messageHandler({
          data: {
            type: 'timeoutTick',
            data: 1
          }
        });
      }, delay);
    }
    return () => {
      if (worker) {
        worker.postMessage({
          type: 'stopTimeout'
        });
        worker.removeEventListener('message', messageHandler);
        worker.terminate();
        worker = null;
        messageHandler = null;
      }
      if (timeoutId) {
        clearTimeout(timeoutId);
        timeoutId = null;
      }
    };
  });
}
function visibilityChange() {
  return new rxjs.Observable(observer => {
    let hidden = 'hidden',
      visibilityChangeEvt = 'visibilitychange',
      timerId,
      parentWin = window.parent;
    try {
      parentWin['dummyTestAccess'] = true;
    } catch (e) {
      parentWin = window;
    }
    const doc = document;
    let childFrame = doc.querySelector('iframe');
    const onchange = evt => {
      childFrame = childFrame || doc.querySelector('iframe');
      const v = 'visible',
        h = 'hidden',
        evtMap = {
          focus: v,
          focusin: v,
          pageshow: v,
          resume: v,
          blur: h,
          focusout: h,
          pagehide: h,
          freeze: h
        };
      evt = evt || window['event'];
      let visibility;
      if (childFrame && childFrame === doc.activeElement) {
        visibility = childFrame['visibilityState'] || (childFrame[hidden] ? 'hidden' : 'visible');
      } else if (evt.type in evtMap) {
        visibility = evtMap[evt.type];
      } else {
        visibility = doc['visibilityState'] || (doc[hidden] ? 'hidden' : 'visible');
      }
      observer.next(visibility);
    };
    const onFocus = evt => {
      if (timerId) {
        clearTimeout(timerId);
        timerId = null;
        onchange(evt);
      }
    };
    const onBlur = evt => {
      clearTimeout(timerId);
      timerId = setTimeout(() => onchange(evt), 100);
    };
    if ('hidden' in document) {
      hidden = 'hidden';
      visibilityChangeEvt = 'visibilitychange';
    } else if ('mozHidden' in document) {
      hidden = 'mozHidden';
      visibilityChangeEvt = 'mozvisibilitychange';
    } else if ('webkitHidden' in document) {
      hidden = 'webkitHidden';
      visibilityChangeEvt = 'webkitvisibilitychange';
    } else if ('msHidden' in document) {
      hidden = 'msHidden';
      visibilityChangeEvt = 'msvisibilitychange';
    }
    document.addEventListener(visibilityChangeEvt, onchange);
    if (window !== parentWin) {
      parentWin.addEventListener('focus', onFocus);
    }
    window.addEventListener('pageshow', onchange);
    window.addEventListener('pagehide', onchange);
    window.addEventListener('resume', onchange);
    window.addEventListener('freeze', onchange);
    window.addEventListener('focus', onFocus);
    window.addEventListener('blur', onBlur);
    // set the initial state (but only if browser supports the Page Visibility API)
    if (document[hidden] !== undefined) {
      onchange({
        type: document[hidden] ? 'blur' : 'focus'
      });
    } else {
      observer.next('visible');
    }
    return () => {
      clearTimeout(timerId);
      document.removeEventListener(visibilityChangeEvt, onchange);
      parentWin.removeEventListener('focus', onFocus);
      window.removeEventListener('pageshow', onchange);
      window.removeEventListener('pagehide', onchange);
      window.removeEventListener('resume', onchange);
      window.removeEventListener('freeze', onchange);
      window.removeEventListener('focus', onFocus);
      window.removeEventListener('blur', onBlur);
    };
  });
}
const Params12 = {
  studentId: 'cmi.core.student_id',
  studentName: 'cmi.core.student_name',
  lessonLocation: 'cmi.core.lesson_location',
  credit: 'cmi.core.credit',
  lessonStatus: 'cmi.core.lesson_status',
  successStatus: 'cmi.core.lesson_status',
  entryMode: 'cmi.core.entry',
  rawScore: 'cmi.core.score.raw',
  minScore: 'cmi.core.score.min',
  maxScore: 'cmi.core.score.max',
  totalTime: 'cmi.core.total_time',
  lessonMode: 'cmi.core.lesson_mode',
  exitMode: 'cmi.core.exit',
  sessionTime: 'cmi.core.session_time',
  suspendData: 'cmi.suspend_data',
  launchData: 'cmi.launch_data',
  learnerComments: 'cmi.comments',
  instructorComments: 'cmi.comments_from_lms',
  numObjectives: 'cmi.objectives._count',
  objectivePrefix: 'cmi.objectives.',
  objectiveId: '.score.id',
  objectiveRawScore: '.score.raw',
  objectiveMinScore: '.score.min',
  objectiveMaxScore: '.score.max',
  objectiveStatus: '.score.status',
  masteryScore: 'cmi.student_data.mastery_score',
  maxTimeAllowed: 'cmi.student_data.max_time_allowed',
  timeLimitAction: 'cmi.student_data.time_limit_action',
  audioPreference: 'cmi.student_preference.audio',
  languagePreference: 'cmi.student_preference.language',
  speedPreference: 'cmi.student_preference.speed',
  textPreference: 'cmi.student_preference.text',
  activityReport: 'cmi.activity_report',
  assessmentResults: 'cmi.assessment_results',
  completeItReport: 'completeItReport',
  mlnReport: 'mlnReport',
  screeningTestAnomaly: 'screening.test.anomaly'
};
const Params2004 = {
  studentId: 'cmi.learner_id',
  studentName: 'cmi.learner_name',
  lessonLocation: 'cmi.lesson_location',
  credit: 'cmi.credit',
  lessonStatus: 'cmi.completion_status',
  successStatus: 'cmi.success_status',
  entryMode: 'cmi.entry',
  rawScore: 'cmi.score.raw',
  minScore: 'cmi.score.min',
  maxScore: 'cmi.score.max',
  scoreScaled: 'cmi.score.scaled',
  totalTime: 'cmi.total_time',
  lessonMode: 'cmi.lesson_mode',
  exitMode: 'cmi.exit',
  sessionTime: 'cmi.session_time',
  suspendData: 'cmi.suspend_data',
  launchData: 'cmi.launch_data',
  learnerComments: 'cmi.comments',
  instructorComments: 'cmi.comments_from_lms',
  numObjectives: 'cmi.objectives._count',
  objectivePrefix: 'cmi.objectives.',
  objectiveId: '.score.id',
  objectiveMinScore: '.score.min',
  objectiveMaxScore: '.score.max',
  objectiveStatus: '.score.status',
  masteryScore: 'cmi.learner_data.mastery_score',
  maxTimeAllowed: 'cmi.learner_data.max_time_allowed',
  timeLimitAction: 'cmi.learner_data.time_limit_action',
  audioPreference: 'cmi.learner_preference.audio',
  languagePreference: 'cmi.learner_preference.language',
  speedPreference: 'cmi.learner_preference.speed',
  textPreference: 'cmi.learner_preference.text',
  userActivity: 'userActivity',
  activityReport: 'cmi.activity_report',
  assessmentResults: 'cmi.assessment_results',
  completeItReport: 'completeItReport',
  mlnReport: 'mlnReport',
  screeningTestAnomaly: 'screening.test.anomaly'
};
let ScormParamsConstants = /*#__PURE__*/(() => {
  class ScormParamsConstants {
    static {
      this.STUDENT_ID = 'studentId';
    }
    static {
      this.STUDENT_NAME = 'studentName';
    }
    static {
      this.LESSON_LOCATION = 'lessonLocation';
    }
    static {
      this.CREDIT = 'credit';
    }
    static {
      this.LESSON_STATUS = 'lessonStatus';
    }
    static {
      this.SUCCESS_STATUS = 'successStatus';
    }
    static {
      this.ENTRY_MODE = 'entryMode';
    }
    static {
      this.RAW_SCORE = 'rawScore';
    }
    static {
      this.MIN_SCORE = 'minScore';
    }
    static {
      this.MAX_SCORE = 'maxScore';
    }
    static {
      this.SCORE_SCALED = 'scoreScaled';
    }
    static {
      this.TOTAL_TIME = 'totalTime';
    }
    static {
      this.LESSON_MODE = 'lessonMode';
    }
    static {
      this.EXIT_MODE = 'exitMode';
    }
    static {
      this.SESION_TIME = 'sessionTime';
    }
    static {
      this.SUSPEND_DATA = 'suspendData';
    }
    static {
      this.LAUNCHED_DATA = 'launchData';
    }
    static {
      this.LEARNER_COMMENTS = 'learnerComments';
    }
    static {
      this.INSTRUCTIOR_COMMNETS = 'instructorComments';
    }
    static {
      this.NUM_OF_OBJECTIVES = 'numObjectives';
    }
    static {
      this.OBJECTIVE_PREFIX = 'objectivePrefix';
    }
    static {
      this.OBJECTIVE_ID = 'objectiveId';
    }
    static {
      this.OBJECTIVE_RAW_SCORE = 'objectiveRawScore';
    }
    static {
      this.OBJECTIVE_MIN_SCORE = 'objectiveMinScore';
    }
    static {
      this.OBJECTIVE_MAX_SCORE = 'objectiveMaxScore';
    }
    static {
      this.OBJECTIVE_STATUS = 'objectiveStatus';
    }
    static {
      this.MASTERY_SCORE = 'masteryScore';
    }
    static {
      this.MAX_TIME_ALLOWED = 'maxTimeAllowed';
    }
    static {
      this.TIME_LIMIT_ACTION = 'timeLimitAction';
    }
    static {
      this.AUDIO_PREFERENCE = 'audioPreference';
    }
    static {
      this.LANGUAGE_PREFERENCE = 'languagePreference';
    }
    static {
      this.SPEED_PREFERENCE = 'speedPreference';
    }
    static {
      this.TEXT_PREFERENCE = 'textPreference';
    }
    static {
      this.SCORM_2004 = '2004';
    }
    static {
      this.SCORM_1_2 = '1.2';
    }
    static {
      this.USER_ACTIVITY = 'userActivity';
    }
    static {
      this.ACTIVITY_REPORT = 'activityReport';
    }
    static {
      this.ASSESSMENT_RESULT = 'assessmentResults';
    }
    static {
      this.COMPLETE_IT_REPORT = 'completeItReport';
    }
    static {
      this.MLN_REPORT = 'mlnReport';
    }
    static {
      this.SCREENING_TEST_ANOMALY = 'screeningTestAnomaly';
    }
  }
  return ScormParamsConstants;
})();
let Scorm = /*#__PURE__*/(() => {
  class Scorm {
    static {
      this.lmsPrefix = '';
    }
    static callScormMethod(methodName, cmiPar = '', value = null) {
      const api = getAPI();
      let result;
      if (api) {
        methodName = Scorm.lmsPrefix + methodName;
        const params = Scorm.lmsPrefix ? Params12 : Params2004;
        const param = params[cmiPar] || '';
        try {
          switch (methodName) {
            case 'Initialize':
              result = api.Initialize('');
              break;
            case 'SetValue':
              result = api.SetValue(param, value);
              break;
            case 'GetValue':
              result = api.GetValue(param);
              break;
            case 'Commit':
              result = api.Commit('');
              break;
            case 'Finish':
              result = api.Finish('');
              break;
            case 'GetDiagnostic':
              result = api.GetDiagnostic('');
              break;
            case 'GetErrorString':
              result = api.GetErrorString('');
              break;
            case 'GetLastError':
              result = api.GetLastError();
              break;
            case 'GetVersion':
              result = api.GetVersion();
              break;
            default:
              if (api && typeof api[methodName] === 'function') {
                if (value) {
                  result = api[methodName](param, value);
                } else {
                  result = api[methodName](param);
                }
              }
              break;
          }
        } catch (e) {
          console.error(' MONE  Error. ' + e);
          return throwError(e);
        }
        if (result && result.hasOwnProperty('then') && typeof result.then === 'function') {
          return from(result);
        } else {
          return of(result);
        }
      }
      return of('false');
    }
  }
  return Scorm;
})();
const LANG_QUERY = 'languages/{0}/languages.json';
/**
 *  Service for loading and parsing localization file
 *  which are .properties files
 */
let LocaleService = /*#__PURE__*/(() => {
  class LocaleService {
    constructor(http) {
      this.http = http;
      /**
       * Language query map
       */
      this.props = {};
      this.ldsLanguages = {};
      this.lds = {};
      this.localeName = 'en_US';
    }
    get englishProps() {
      return this.enProps || this.props;
    }
    /**
     * Prepare for gb
     */
    clean() {
      this.enProps = null;
      this.props = null;
      this.ldsLanguages = null;
      this.lds = null;
    }
    /**
     *  get Code by font family
     */
    getCodeByFont(font) {
      let code = '';
      const keys = Object.keys(this.lds);
      for (const key of keys) {
        if (this.lds[key].font === font) {
          code = key;
          break;
        }
      }
      return code;
    }
    /**
     *  get language Info by localeCode
     */
    getLanguageByLocaleCode(localeCode) {
      if (localeCode === 'en_US') {
        return this.lds['ENGLISH'];
      }
      if (localeCode.length === 2) {
        localeCode = localeCode + '-XX';
      }
      localeCode = localeCode.replace('_', '-');
      const arr = this.lds ? Object.keys(this.lds) : [];
      for (const key of arr) {
        if (this.lds[key].locale === localeCode) {
          return this.lds[key];
        }
      }
      return null;
    }
    /**
     * Check if given language is latin
     */
    isLatin(languageCode) {
      let isLangLatin = false;
      if (/vietnamese/i.test(languageCode)) {
        isLangLatin = false;
      }
      if (/T_/.test(languageCode)) {
        isLangLatin = true;
      }
      const lang = this.lds[languageCode];
      if (lang) {
        isLangLatin = lang.script === 'Latn';
      }
      return isLangLatin;
    }
    /**
     * Check that both languages are latin and one of them is English
     */
    isEsl(knownCode, learnCode) {
      const engPat = /english/i;
      if (!this.isLatin(knownCode) || !this.isLatin(learnCode)) {
        return false;
      }
      return engPat.test(knownCode) || engPat.test(learnCode);
    }
    /**
     * Loads locale and maps its data to key value object
     */
    loadLocale(ldsUrl, localeName = 'en_US', fileName = 'up') {
      this.localeName = localeName;
      const arr = [this.getLocale(localeName, fileName), this.loadLanguages(ldsUrl, localeName)];
      if (localeName !== 'en_US') {
        arr.push(this.getLocale('en_US', fileName, true));
      }
      return forkJoin(arr).pipe(map$1(() => this.props));
    }
    /**
     * Loads language info from lds
     */
    loadLanguages(ldsUrl, locale) {
      const path = ldsUrl + LANG_QUERY.replace('{0}', locale);
      const localPath = '../lds/' + LANG_QUERY.replace('{0}', locale);
      const storageData = getFromLocalStorage(path);
      if (storageData) {
        this.parseLanguages(storageData);
        return of(this.lds);
      }
      if (ldsUrl) {
        return this.http.get(path).pipe(catchError(() => this.http.get(localPath)), map$1(res => {
          setToLocalStorage(path, res);
          this.parseLanguages(res);
          return this.lds;
        }));
      } else {
        return this.http.get(localPath).pipe(map$1(res => {
          setToLocalStorage(path, res);
          this.parseLanguages(res);
          return this.lds;
        }));
      }
    }
    /**
     * Load locale
     */
    getLocale(localeName = 'en_US', fileName = 'up', forActivityReport = false) {
      const path = 'locale/' + localeName + '/' + fileName + '.properties';
      const storageData = getFromLocalStorage(path);
      if (storageData) {
        this.parseLocale(storageData, forActivityReport);
        return of(this.props);
      }
      return this.http.get(path, {
        responseType: 'text'
      }).pipe(map$1(res => {
        setToLocalStorage(path, res);
        return this.parseLocale(res, forActivityReport);
      }));
    }
    /**
     * Parse properties files
     */
    parseLocale(str, forActivityReport = false) {
      let props = this.props;
      if (forActivityReport) {
        props = this.enProps = {};
      }
      str.split(/\n+/).filter(item => item[0] !== '#' && item.indexOf('=') !== -1).map(item => {
        const [key, value] = item.split('=');
        props[key.trim()] = value.trim();
      });
      return props;
    }
    /**
     * Parses lds languages
     */
    parseLanguages(langs) {
      langs.forEach(item => {
        this.ldsLanguages[item.code] = item.name;
        this.lds[item.code] = {
          asr: item.asr,
          code: item.code,
          font: normalizeFontName(item.font),
          name: item.name,
          short: item.short,
          easyType: item.easyType,
          locale: item.flashLocale,
          script: item.script,
          dir: item.rtl ? 'rtl' : 'ltr',
          shortName: item.shortName,
          hasScriptAssistant: item.hasScriptAssistant
        };
      });
    }
    static {
      this.ɵfac = function LocaleService_Factory(t) {
        return new (t || LocaleService)(i0.ɵɵinject(i1.HttpClient));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: LocaleService,
        factory: LocaleService.ɵfac
      });
    }
  }
  return LocaleService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let namesMap = {
  activity: 'getActivity',
  activityName: 'getActivityName',
  activityDisplayName: 'getActivityDisplayName',
  alphabetPath: 'getAlphabetPath',
  isAutoFitb: 'isAutoFitb',
  baseHelpUrl: 'getBaseHelpUrl',
  bykiList: 'getBykiList',
  courseCategory: 'getCourseCategory',
  captionControl: 'captionControl',
  celaCode: 'getCELACode',
  celaUrl: 'getCELAUrl',
  courseUuid: 'getCourseUuid',
  deploymentId: 'getDeploymentId',
  disableSkipHearingActivities: 'disableSkipHearingActivities',
  disableRightClick: 'disableRightClick',
  disableThirdPartyScripts: 'disableThirdPartyScripts',
  disableTestResultInstructorEmails: 'disableTestResultInstructorEmails',
  fontsUrl: 'getFontsUrl',
  gaAccount: 'getGAAccount',
  glossaryConfig: 'getGlossaryConfig',
  goMobileAvailable: 'goMobileAvailable',
  game: 'getGame',
  googleAPISettings: 'getGoogleAPISettings',
  isHardMode: 'isHardMode',
  hasShareableLink: 'hasShareableLink',
  helpPlaceholders: 'getHelpPlaceholders',
  hid: 'getHid',
  hideExportPdf: 'getHideExportPdf',
  isAssessment: 'getIsAssessment',
  isCtestOnlyNode: 'getIsCtestOnlyNode',
  instructors: 'instructors',
  instructorUUID: 'getInstructorUUID',
  isLessonGin: 'getIsLessonGin',
  isNative: 'getIsNative',
  isReference: 'isReference',
  isSpeech: 'isSpeech',
  isForcedResponsive: 'isForcedResponsive',
  everyVoiceEnabled: 'everyVoiceEnabled',
  enableBriefleLink: 'enableBriefleLink',
  isTestingOutEnabled: 'getEnabledTestingOut',
  languageSelector: 'getLanguageSelector',
  ldsUrl: 'getLDSUrl',
  letterUrl: 'getLetterUrl',
  lessonUuid: 'getLessonUuid',
  lessonIds: 'getLessonIds',
  listAaid: 'getListAaid',
  listIds: 'getListIds',
  locale: 'getLocale',
  loxy: 'getLoxy',
  mpgServer: 'getMpgServer',
  mlnSettings: 'getMlnSettings',
  mliHids: 'getMliHids',
  path: 'getPath',
  referenceResources: 'getReferenceResources',
  refreshMode: 'getRefreshMode',
  rememberIt: 'getRememberIt',
  rootDataPath: 'getRootDataPath',
  soundServer: 'getSoundServer',
  serverPath: 'getServerPath',
  sessionTimeout: 'getSessionTimeout',
  tloBaseUrl: 'getTLOBaseUrl',
  displayName: 'displayName',
  screenTestMode: 'getScreenTestMode',
  unitName: 'unitName',
  enableMarkingLearned: 'enableMarkingLearned',
  alphabetVersion: 'alphabetVersion',
  objectives: 'objectives',
  type: 'type'
};
const PLAYER_CONFIG = new InjectionToken('app.config');
function convertConfigToObject() {
  const config = getUpConfig();
  const playerConf = {};
  const keys = Object.keys(namesMap);
  for (const key of keys) {
    const fnName = namesMap[key];
    let value;
    if (typeof config[fnName] === 'function') {
      value = config[fnName].call();
    } else {
      value = config[key];
      if (typeof value === 'undefined') {
        value = null;
      }
    }
    if (value === 'true') {
      value = true;
    } else if (value === 'false') {
      value = false;
    }
    playerConf[key] = value;
  }
  if (playerConf.everyVoiceEnabled === 'undefined' || playerConf.everyVoiceEnabled === null) {
    playerConf.everyVoiceEnabled = true;
  }
  if (playerConf.displayName === 'undefined' || playerConf.displayName === null) {
    playerConf.displayName = '';
  }
  if (playerConf.disableRightClick === 'undefined' || playerConf.disableRightClick === null) {
    playerConf.disableRightClick = true;
  }
  if (playerConf.locale === 'undefined' || playerConf.locale === null || playerConf.locale === 'null') {
    playerConf.locale = 'en_US';
  }
  // TODO don't forget to remove
  return setDefaultValues(playerConf);
}
function getUpConfig() {
  let conf;
  const wind = window;
  try {
    if (wind.parent && wind.parent.upConfig) {
      conf = wind.parent.upConfig;
    }
  } catch (e) {
    conf = null;
  }
  if (!conf && wind.upConfig) {
    conf = wind.upConfig || {};
  }
  return conf || {};
}
function setDefaultValues(playerConf) {
  if (playerConf) {
    playerConf.lessonIds = playerConf.lessonIds || [];
    playerConf.listIds = playerConf.listIds || [];
    playerConf.mliHids = playerConf.mliHids || [];
  }
  return playerConf;
}

/**
 * Helper function to unsubscribe and clean Subscription
 */
function cleanSubscription(valSub) {
  if (valSub && !valSub.closed) {
    valSub.unsubscribe();
  }
  return null;
}
/**
 * Helper function to unsubscribe and clean a bunch of Subscriptions
 */
function cleanSubscriptions(arr) {
  while (arr && arr.length) {
    cleanSubscription(arr.pop());
  }
  return null;
}
function focusElementRef(elem) {
  if (elem && elem.nativeElement) {
    elem.nativeElement.focus();
  }
}
function blurElementRef(elem) {
  if (elem && elem.nativeElement) {
    elem.nativeElement.blur();
  }
  return null;
}
let CWGAService = /*#__PURE__*/(() => {
  class CWGAService {
    constructor(upConfig) {
      this.upConfig = upConfig;
      this.win = window;
      this.hasGA = false;
      this.hasGA = !upConfig.disableThirdPartyScripts && !isDevMode();
      if (this.hasGA) {
        const gaAccountID = upConfig.gaAccount || 'UA-43029260-8';
        this.initSub = this.loadAnalytics(gaAccountID).subscribe(status => {
          if (status) {
            let topWin = window.parent;
            try {
              topWin['dummyTestAccess'] = true;
            } catch (e) {
              topWin = window;
            }
            const vo = new TrackAnalyticsVO();
            vo.type = 'pageview';
            vo.category = decodeURIComponent(topWin.location.pathname + topWin.location.hash);
            vo.action = decodeURIComponent(topWin.location.href);
            vo.label = topWin.document.title;
            this.track(vo);
          }
        });
      }
    }
    ngOnDestroy() {
      this.initSub = cleanSubscription(this.initSub);
      this.win = null;
    }
    /**
     * Track event
     */
    track(analytics) {
      if (!this.hasGA) {
        return;
      }
      let params,
        eventName = analytics.type;
      if (this.win.cwga) {
        try {
          if (analytics.type === 'pageview') {
            params = [{
              page: analytics.category,
              title: analytics.label,
              location: analytics.action
            }];
          } else {
            params = [analytics.category, analytics.action, analytics.label];
          }
          this.win.cwga('send', eventName, ...params);
        } catch (e) {
          if (console) {
            console.log('Failed to call analytics service' + e);
          }
        }
      } else {
        if (analytics.type === 'pageview') {
          params = {
            page_path: analytics.category,
            page_title: analytics.label,
            page_location: analytics.action
          };
          eventName = 'page_view';
        } else {
          params = {
            event_category: analytics.category,
            event_label: analytics.label,
            event_action: analytics.action
          };
          eventName = 'courseware_event';
        }
        this.win.gtag('event', eventName, params);
      }
    }
    /**
     * Include Google analytics to page
     */
    loadAnalytics(gaAccountID) {
      return new Observable(observer => {
        const implScript = document.createElement('script');
        implScript.type = 'application/javascript';
        let file = '//www.google-analytics.com/analytics.js';
        if (gaAccountID.startsWith('G-')) {
          file = '//www.googletagmanager.com/gtag/js?id=' + gaAccountID;
          implScript.text = `window.dataLayer = window.dataLayer || [];
                    \n\tfunction gtag(){dataLayer.push(arguments);}
                    \n\tgtag('js', new Date());
                    \n\tgtag('config', '${gaAccountID}', {
                        send_page_view: false,
                        site_speed_sample_rate: 80,
                        cookie_flags: 'SameSite=None;Secure'
                    });`;
        } else {
          implScript.text = `const func = 'cwga';
                    \n\twindow.GoogleAnalyticsObject = func;
                    \n\twindow[func] = window[func] || (function(){(window[func].q = window[func].q || []).push(arguments)});
                    \n\twindow[func].l = new Date().getTime();
                    \n\tcwga('create', '${gaAccountID}', {
                        site_speed_sample_rate: 80,
                        cookie_flags: 'SameSite=None;Secure'
                    });`;
        }
        const protocol = this.win.location ? this.win.location.protocol || '' : '';
        if (protocol && protocol === 'file:' && !/^https?/.test(file)) {
          file = 'http:' + file;
        }
        const head = document.getElementsByTagName('head')[0];
        const script = document.createElement('script');
        script.async = true;
        script.src = file;
        script.onload = () => {
          observer.next('initialized');
          observer.complete();
        };
        script.onerror = err => {
          console.log(err);
          observer.error(err);
          observer.complete();
        };
        head.appendChild(script);
        head.appendChild(implScript);
        return () => {
          script.onload = null;
          script.onerror = null;
        };
      });
    }
    static {
      this.ɵfac = function CWGAService_Factory(t) {
        return new (t || CWGAService)(i0.ɵɵinject(PLAYER_CONFIG));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: CWGAService,
        factory: CWGAService.ɵfac
      });
    }
  }
  return CWGAService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MessageConstants = /*#__PURE__*/(() => {
  class MessageConstants {
    static {
      this.ALL = 'reload';
    }
    // We do not need this audio player has volume and volume is handled by unit Player
    static {
      this.SOUND_VOLUME = 'soundVolume';
    }
    static {
      this.RESTART_ACTIVITY = 'restartActivity';
    }
    static {
      this.PAUSE_ACTIVITY = 'pauseActivity';
    }
    static {
      this.RESUME_ACTIVITY = 'resumeActivity';
    }
    static {
      this.ACTIVITY_STARTED = 'activityStarted';
    }
    static {
      this.ACTIVITY_COMPLETED = 'activityCompleted';
    }
    static {
      this.ACTIVITY_DONE = 'activityDone';
    }
    static {
      this.ACTIVITY_INCOMPLETE = 'activityIncomplete';
    }
    static {
      this.MODULE_ERROR = 'moduleError';
    }
    static {
      this.HIDE_KEYPAD = 'hideKeypad';
    }
    /**
     *  The <code>MessageConstants.SEND_ALT_ANSWER</code> constant defines the value of the
     *  <code>contentType</code> property for activity message.
     *  A module uses this message to sendalternative answer defined by user to shell.
     */
    static {
      this.SEND_ALT_ANSWER = 'sendAltAnswer';
    }
    /**
     * The <code>MessageConstants.SHOW_ACTIVITY_HELP</code> constant
     * opens hlp file cor current activity via player
     * activity message.
     */
    static {
      this.SHOW_ACTIVITY_HELP = 'showActivityHelp';
    }
    /**
     * The <code>MessageConstants.SHOW_UNSUPPORTED_VIDEO_FILE_MAC_FF</code> used
     * notify that a video format that you want to play on FireFox on Mac machine not supported
     */
    static {
      this.SHOW_UNSUPPORTED_VIDEO_FILE_MAC_FF = 'showUnsupportedVideoFileMacFireFox';
    }
    /**
     * The <code>MessageConstants.HIDE_MODULE</code> used
     * no notify that an activity should be hidden from lesson
     */
    static {
      this.SKIP_MODULE = 'skipModule';
    }
    /**
     * The <code>MessageConstants.TRACK_ANALYTICS</code> used
     * no notify that an activity tracks Google Analytics event.
     */
    static {
      this.TRACK_ANALYTICS = 'trackAnalytics';
    }
    /**
     * Shows alphabet explosion
     */
    static {
      this.SHOW_AE = 'showAE';
    }
    /**
     * Hide alphabet explosion
     */
    static {
      this.CLOSE_AE = 'closeAE';
    }
    /**
     * Notify the player about user preference on displaying help overlays
     */
    static {
      this.ACTIVITY_OVERLAY_STATE = 'activityOverlayState';
    }
    /**
     * Notify the player about user preference on displaying captionControl
     */
    static {
      this.CAPTION_CONTROL_STATE = 'captionControlState';
    }
    /**
     * Notify the player about user preference on displaying indication patterns
     */
    static {
      this.INDICATION_PATTERN_STATE = 'indicationPatternState';
    }
    /**
     * Notify the player about user preference on play or skip audio activities
     */
    static {
      this.HEARING_STATE = 'hearingState';
    }
    /**
     * Notify the activity about user preference on displaying help overlays
     */
    static {
      this.PLAYER_OVERLAY_STATE = 'playerOverlayState';
    }
    /**
     * Shows error popup with concrete message
     */
    static {
      this.SHOW_ERROR_POPUP = 'showErrorPopup';
    }
    /**
     * Shows IME popup for current IME language
     */
    static {
      this.SHOW_IME_POPUP = 'showIMEPopup';
    }
    /**
     * Shows IME popup for current IME language
     */
    static {
      this.USE_SYSTEM_IME = 'useSystemIME';
    }
    static {
      this.SET_MODULE_HELP = 'setModuleHelp';
    }
    static {
      this.SOUND_EFFECTS_STATE = 'soundEffects';
    }
    static {
      this.DISABLE_SINGLE_CHARS_HOT_KEY_STATE = 'disableSingleCharsHotKey';
    }
    static {
      this.SOUND_ERROR_MESSAGE = 'soundError';
    }
    static {
      this.HAS_SCRIPT_ASSISTANT_CHANGED = 'hasScriptAssistantChanged';
    }
    static {
      this.SHOW_PDF_VIEWER = 'showPdfViewer';
    }
    static {
      this.SHOW_MEANING = 'showMeaning';
    }
    static {
      this.TYPING_MODE_CHANGE = 'typingModeChange';
    }
    static {
      this.GO_MOBILE = 'goMobile';
    }
    static {
      this.ACTIVITY_REPORT = 'activityReport';
    }
    static {
      this.CHALLENGE_TIMER_STATE = 'challengeTimerState';
    }
    static {
      this.SESSION_EXPIRED = 'sessionExpired';
    }
    static {
      this.SESSION_EXTENDED = 'sessionExtended';
    }
  }
  return MessageConstants;
})();
const CORRECT_SOUND = 'assets/sounds/correct.mp3';
const INCORRECT_SOUND = 'assets/sounds/incorrect.mp3';
const REFRESH_SOUND = 'assets/sounds/refresh.mp3';
const ACTIVITY_COMPLETE_SOUND = 'assets/sounds/activity-complete.mp3';
const UNIT_COMPLETE_SOUND = 'assets/sounds/unit-complete.mp3';
const EMPTY_SOUND = 'assets/sounds/empty.mp3';
const ITEM_COMPLETE_SOUND = 'assets/sounds/item-complete.mp3';
const START_SPEAKING_SOUND = 'assets/sounds/start-speaking.mp3';
const STOP_SPEAKING_SOUND = 'assets/sounds/stop-speaking.mp3';
const PREVIEW_PRONOUNCE_INTRO_SOUND = 'assets/sounds/preview-pronounce-it-intro.mp3';
const PRODUCE_SAY_INTRO_SOUND = 'assets/sounds/produce-say-it-intro.mp3';
const RECOGNIZE_SAY_INTRO_SOUND = 'assets/sounds/recognize-say-it-intro.mp3';
const GOOD_WORK_SOUND = 'assets/sounds/good-work.mp3';
const baseUrl = getCWBaseUrl();
const ITEM_COMPLETE_DUR = 0.574694;
const START_SPEAKING_DUR = 0.48;
const STOP_SPEAKING_DUR = 0.384;
const PREVIEW_PRONOUNCE_INTRO_DUR = 3.369796;
const PRODUCE_SAY_INTRO_DUR = 3.030204;
const RECOGNIZE_SAY_INTRO_DUR = 3.291429;
const ACTIVITY_COMPLETE_DUR = 1.227755;
const UNIT_COMPLETE_DUR = 1.048667;
const GOOD_WORK_DUR = 2.925714;
function CORRECT_SOUND_URL() {
  return baseUrl + CORRECT_SOUND;
}
function INCORRECT_SOUND_URL() {
  return baseUrl + INCORRECT_SOUND;
}
function REFRESH_SOUND_URL() {
  return baseUrl + REFRESH_SOUND;
}
function ACTIVITY_COMPLETE_SOUND_URL() {
  return baseUrl + ACTIVITY_COMPLETE_SOUND;
}
function UNIT_COMPLETE_SOUND_URL() {
  return baseUrl + UNIT_COMPLETE_SOUND;
}
function EMPTY_SOUND_URL() {
  return baseUrl + EMPTY_SOUND;
}
function ITEM_COMPLETE_SOUND_URL() {
  return baseUrl + ITEM_COMPLETE_SOUND;
}
function START_SPEAKING_SOUND_URL() {
  return baseUrl + START_SPEAKING_SOUND;
}
function STOP_SPEAKING_SOUND_URL() {
  return baseUrl + STOP_SPEAKING_SOUND;
}
function PREVIEW_PRONOUNCE_INTRO_SOUND_URL() {
  return baseUrl + PREVIEW_PRONOUNCE_INTRO_SOUND;
}
function PRODUCE_SAY_INTRO_SOUND_URL() {
  return baseUrl + PRODUCE_SAY_INTRO_SOUND;
}
function RECOGNIZE_SAY_INTRO_SOUND_URL() {
  return baseUrl + RECOGNIZE_SAY_INTRO_SOUND;
}
function GOOD_WORK_SOUND_URL() {
  return baseUrl + GOOD_WORK_SOUND;
}
let AnalyticsLabels = /*#__PURE__*/(() => {
  class AnalyticsLabels {
    /**
     * Activity Help button.
     */
    static {
      this.ACTIVITY_HELP = 'Activity Help Button';
    }
    /**
     * Adjust Microphone
     */
    static {
      this.ADJUST_MICROPHONE = 'Adjust Microphone';
    }
    /**
     * Auto iterate through challenges, e.g. in Preview It is set to off
     */
    static {
      this.AUTO_FLIP_OFF = 'AutoFlip Off';
    }
    /**
     * Auto iterate through challenges, e.g. in Preview It is set to on
     */
    static {
      this.AUTO_FLIP_ON = 'AutoFlip On';
    }
    /**
     * User changes card display settings in card activities.
     */
    static {
      this.CARD_DISPLAY_SETTING = 'Card Display Setting';
    }
    /**
     * Choice SlowSound
     */
    static {
      this.CHOICE_SLOWSOUND = 'Choice SlowSound';
    }
    /**
     * Choice Sound
     */
    static {
      this.CHOICE_SOUND = 'Choice Sound';
    }
    /**
     * Activity completes
     */
    static {
      this.COMPLETED_ACTIVITY = 'Activity Complete';
    }
    /**
     * Correct Answer.
     */
    static {
      this.CORRECT = 'Correct';
    }
    /**
     * Correct answer
     */
    static {
      this.CORRECT_CHALLENGE = 'Correct Challenge';
    }
    /**
     * Disconnected from Server
     */
    static {
      this.DISCONNECTED_FROM_SERVER = 'Disconnected from Server';
    }
    /**
     * Done button.
     */
    static {
      this.DONE_BUTTON = 'Done Button';
    }
    /**
     * Don't use microphone
     */
    static {
      this.DONT_USE_MICROPHONE = 'Don\'t use microphone';
    }
    /**
     * Download list
     */
    static {
      this.DOWNLOAD_LIST = 'Download List';
    }
    /**
     * Elevated Background Noise
     */
    static {
      this.ELEVATED_BACKGROUND_NOISE = 'Elevated Background Noise';
    }
    /**
     * Hide keyboard button.
     */
    static {
      this.HIDE_KEYBOARD_BUTTON = 'Hide Keyboard Button';
    }
    /**
     * Hint is accessed.
     */
    static {
      this.HINT = 'Hint';
    }
    /**
     * Incorrect answer.
     */
    static {
      this.INCORRECT = 'Incorrect';
    }
    /**
     * User click on help.
     */
    static {
      this.INCORRECT_ANSWER_HELP = 'Incorrect Answer Help';
    }
    /**
     * Incorrect answer
     */
    static {
      this.INCORRECT_CHALLENGE = 'Incorrect Challenge';
    }
    /**
     * Learn list
     */
    static {
      this.LEARN_LIST = 'Learn List';
    }
    /**
     * Letter name sound button.
     */
    static {
      this.LETTER_NAME_SOUND_BUTTON = 'Letter Name Sound Button';
    }
    /**
     * Letter sound button
     */
    static {
      this.LETTER_SOUND_BUTTON = 'Letter Sound Button';
    }
    /**
     * Activity completes because content is bad
     */
    static {
      this.MALFORMED_CONTENT = 'Malformed Content';
    }
    /**
     * User changes mode in mc2.
     */
    static {
      this.MANUAL_MODE = 'Manual Mode';
    }
    /**
     * Menu Button is clicked.
     */
    static {
      this.MENU = 'Menu Button';
    }
    /**
     * Native SlowSound
     */
    static {
      this.NATIVE_SLOWSOUND = 'Native SlowSound';
    }
    /**
     * Native Sound
     */
    static {
      this.NATIVE_SOUND = 'Native Sound';
    }
    /**
     * Override answer.
     */
    static {
      this.OVERRIDE = 'Override';
    }
    /**
     * Help for override
     */
    static {
      this.OVERRIDE_HELP = 'Override Help';
    }
    /**
     * Override incorrect answer
     */
    static {
      this.OVERRIDE_INCORRECT = 'Override Incorrect';
    }
    /**
     * Play all is set to pause
     */
    static {
      this.PAUSE_ALL_SOUNDS = 'Pause all sounds';
    }
    /**
     * Play all is invoked
     */
    static {
      this.PLAY_ALL_SOUNDS = 'Play All Sounds';
    }
    /**
     *  Play sound button is clicked
     */
    static {
      this.PLAY_SOUND = 'Play Sound';
    }
    /**
     * Print export button is clicked.
     */
    static {
      this.PRINT_EXPORT = 'Print/Export Button';
    }
    /**
     * Retry button clicked.
     */
    static {
      this.RETRY_BUTTON = 'Retry Button';
    }
    /**
     * Search text
     */
    static {
      this.SEARCH_TEXT = 'Search ';
    }
    /**
     * Pause segment sound
     */
    static {
      this.SEGMENT_SOUND_PAUSE = 'Pause Segment Sound';
    }
    /**
     * Play segment sound
     */
    static {
      this.SEGMENT_SOUND_PLAY = 'Play segment sound';
    }
    /**
     * Show description button.
     */
    static {
      this.SHOW_DESCRIPTION_BUTTON = 'Show Description Button';
    }
    /**
     * Show keyboard button.
     *
     */
    static {
      this.SHOW_KEYBOARD_BUTTON = 'Show Keyboard Button';
    }
    /**
     * Skip Activity
     */
    static {
      this.SKIP_ACTIVITY = 'Skip Activity';
    }
    /**
     * Current challenge is skipped using button
     */
    static {
      this.SKIP_CARD = 'Skip Card';
    }
    /**
     * Play slow sound button is clicked
     */
    static {
      this.SLOW_SOUND = 'Slow Sound';
    }
    /**
     * Submit button clicked.
     */
    static {
      this.SUBMIT_BUTTON = 'Submit Button';
    }
    /**
     * Turn Microphone Off
     */
    static {
      this.TURN_MICROPHONE_OFF = 'Turn Microphone Off';
    }
    /**
     * Turn Microphone On
     */
    static {
      this.TURN_MICROPHONE_ON = 'Turn Microphone On';
    }
    /**
     * Update available list
     */
    static {
      this.UPDATE_LISTS = 'Update Lists';
    }
    /**
     * Update available selected list
     */
    static {
      this.UPDATE_SELECTED_LISTS = 'Update Selected Lists';
    }
    /**
     * User SlowSound
     */
    static {
      this.USER_SLOWSOUND = 'User SlowSound';
    }
    /**
     * User Sound
     */
    static {
      this.USER_SOUND = 'User Sound';
    }
    /**
     * Video current change
     */
    static {
      this.VIDEO_CHANGE_SELECTED = 'Video current change';
    }
    /**
     * Video subtitle fliped
     */
    static {
      this.VIDEO_FLIP_SUBTITLE = 'Video subtitle fliped';
    }
    /**
     * Video fullScreen button
     */
    static {
      this.VIDEO_FULL_SCREEN = 'Video FullScreen Button';
    }
    /**
     * Video mute button
     */
    static {
      this.VIDEO_MUTE = 'Video Mute Button';
    }
    /**
     * Video next segment
     */
    static {
      this.VIDEO_NEXT_SEGMENT = 'Video Next Segment';
    }
    /**
     * Video paused
     */
    static {
      this.VIDEO_PAUSE = 'Video Paused';
    }
    /**
     * Video played
     */
    static {
      this.VIDEO_PLAY = 'Video Played';
    }
    /**
     * Video previous segment
     */
    static {
      this.VIDEO_PREV_SEGMENT = 'Video Previous Segment';
    }
    /**
     * Accept as correct
     */
    static {
      this.ACCEPT_AS_CORRECT = 'Accept as Correct';
    }
    /**
     * Never mind, I got this wrong
     */
    static {
      this.NEVER_MIND = 'Never mind, I got this wrong';
    }
    /**
     * Do not accept this answer
     */
    static {
      this.DO_NOT_ACCEPT = 'Do Not Accept This Answer';
    }
    /**
     * I actually knew this!
     */
    static {
      this.I_KNEW_THIS = 'I Actually Knew this!';
    }
    /**
     * Easy type button
     */
    static {
      this.EASY_TYPE_BUTTON = 'Easy Type Button';
    }
    /**
     * Next button
     */
    static {
      this.NEXT_BUTTON = 'Next Button';
    }
  }
  return AnalyticsLabels;
})();
let AnalyticsActions = /*#__PURE__*/(() => {
  class AnalyticsActions {
    /**
     * An action that generates when answer is selected
     */
    static {
      this.ANSWERED = 'Answered';
    }
    /**
     * An action that generates some form of multimedia, such as sound or a video
     */
    static {
      this.PLAYED = 'Played';
    }
    /**
     *An action where a control changes states (such as “Play All” to “Pause” or a keymapper to “Script Assistant”)
     */
    static {
      this.TOGGLED = 'Toggled';
    }
    /**
     * An action committed against any control that doesn’t have a specific action associated with it
     */
    static {
      this.CLICKED = 'Clicked';
    }
    /**
     * An action committed against any control that doesn’t have a specific action associated with it
     */
    static {
      this.DOUBLE_CLICKED = 'Double Clicked';
    }
    /**
     * An action that occurs when a user completes any activity
     */
    static {
      this.COMPLETED = 'Completed';
    }
    /**
     * An action where any sort of floating window in the activity (such as a keyboard) is moved
     */
    static {
      this.MOVED = 'Moved';
    }
    /**
     * An action where any sort of floating window in the activity (such as a keyboard) is overed
     */
    static {
      this.OVERED = 'Overed';
    }
    /**
     * An action where any text is filtered by the user.
     */
    static {
      this.FILTERED = 'Filtered';
    }
    /**
     * An action for any result.
     */
    static {
      this.RESULT = 'Result';
    }
  }
  return AnalyticsActions;
})();
class UniqueCardsSorter {
  /* eslint-disable max-len */
  static {
    this.PUNCT_PAT = new RegExp('[\\s+\u0022\\u002D\\\u005D\\\u005B\\\u005C\\u0021\\u0023\\u0024\\u0025\\u0026\\u0028\\u0029\\u002A\\u002B\\u002C\\u002E\\u003A\\u003B\\u003C\\u003D\\u003E\\u003F\\u0040\\u005E\\u005F\\u0060\\u007E\\u007C\\u007B\\u007D\\u002F\\u2026\\u2013\\u2014\\u2015\\u2000\\u00A0\\u02C6\\u02C7\\u02C9\\u02D8\\u02D9\\u02DA\\u02DB\\u02DC\\u02DD\\u060C\\u061B\\u061F\\u061E]+', 'gm');
  }
  static {
    this.stripTags = new RegExp('<\\/?[^>]+(>|$)', 'igm');
  }
  /**
   * Creates distractors for activities which present distractors, the activity should choose to present distractors
   * which are similar to the target, so that the answer is not obvious.
   */
  static createDistractors(card, side, cards, isSpeechMode = false) {
    let item;
    let itemPunct;
    let items = [];
    let itemWords;
    let numItems;
    let PUNCT_PAT;
    side = side || 'cardSide2Text';
    /* eslint-disable max-len */
    PUNCT_PAT = /[\u0022\u002D\u005D\u005B\u005C\u0021\u0023\u0024\u0025\u0026\u0028\u0029\u002A\u002B\u002C\u002E\u003A\u003B\u003C\u003D\u003E\u003F\u0040\u005E\u005F\u0060\u007E\u007C\u007B\u007D\u002F\u2026\u2013\u2014\u2015\u2000\u00A0\u02C6\u02C7\u02C9\u02D8\u02D9\u02DA\u02DB\u02DC\u02DD\u060C\u061B\u061F\u061E]/gm;
    let cardText = UniqueCardsSorter.cleanTags(card[side]);
    itemPunct = (cardText.match(PUNCT_PAT) || []).join('');
    itemWords = cardText.split(' ').length;
    const targetCharLen = cardText.length;
    const arr = [];
    const tmpCards = [];
    for (const tmpCard of cards) {
      if (~arr.indexOf(tmpCard[side].replace(UniqueCardsSorter.stripTags, '')) || UniqueCardsSorter.cleanTags(tmpCard[side]) === cardText) {
        continue;
      }
      tmpCards.push(tmpCard);
      arr.push(tmpCard[side].replace(UniqueCardsSorter.stripTags, ''));
    }
    let len = tmpCards.length;
    for (let j = 0; j < len; j++) {
      const tmpCard = tmpCards[j].clone();
      item = {
        points: 0,
        card: tmpCard
      };
      cardText = UniqueCardsSorter.cleanTags(tmpCard[side]);
      if ((cardText.match(PUNCT_PAT) || []).join('') === itemPunct) {
        item.points += 2;
      }
      if (cardText.split(' ').length === itemWords) {
        item.points += 1;
      }
      item.charDiffScore = Math.abs(cardText.length - targetCharLen);
      items.push(item);
    }
    items = items.sort((a, b) => b.points - a.points || a.charDiffScore - b.charDiffScore);
    let filteredArr = [];
    if (isSpeechMode && items.length > 4) {
      filteredArr = items.filter(itm => !(itm.points === 3 && itm.charDiffScore <= 2));
    }
    const samePoints = (filteredArr.length > 4 ? filteredArr : items).filter(itm => itm.points === items[0].points);
    items = samePoints.length > 4 ? samePoints : items.slice(0, 4);
    len = Math.min(3, items.length);
    numItems = items.length;
    const answers = [];
    while (answers.length < len) {
      const ind = Math.floor(Math.random() * numItems);
      item = items.splice(ind, 1)[0].card;
      item.isCorrect = false;
      numItems--;
      answers.push(item);
    }
    return answers;
  }
  /**
   * Creates list of unique cards with audio
   */
  static getAudioCards(inCards, isGameMode = false) {
    const hids = [];
    const cards = [];
    const len = inCards.length;
    for (let i = 0; i < len; i++) {
      const curCard = inCards[i];
      curCard.soundSide2 = curCard.soundSide2 === 'null' || curCard.soundSide2 === '' ? null : curCard.soundSide2;
      if (curCard.soundSide2 /*&& hids.indexOf(curCard.hid) === -1*/) {
        cards.push(curCard);
        hids.push(curCard.hid);
      }
    }
    if (isGameMode) {
      return cards;
    }
    return ArrayUtil.randomize(cards);
  }
  /**
   *  Creates list of unique cards with unscramble text
   */
  static getUnscrambleCards(inCards, isTransliterated, splitChar, isGameMode = false, slitTextFunction) {
    /* eslint-disable max-len */
    const unsramblePattern = /([\u0020\u0021\u002C\u002E\u003A\u003F\u003B\u060C\u061F\u06D4\u00AB\u00BB\u200B\u201E\u201D\u2026\u300C\u300D\uFE41\uFE42\u201C\u0022\u00BF\u00A0\u00A1\u0964\u3001\u3002\u30fc\uff01\uFF0E])/ig;
    let pat;
    pat = splitChar ? new RegExp(splitChar, 'ig') : unsramblePattern;
    // do we need unique cards for unscramble or we just need filter text
    const hids = [];
    const cards = [];
    const len = inCards.length;
    for (let i = 0; i < len; i++) {
      const curCard = inCards[i];
      let str = curCard.cardSide2Text || '';
      str = str.replace(UniqueCardsSorter.stripTags, '');
      let splitedStr = slitTextFunction ? slitTextFunction(str) : str.split(pat);
      splitedStr = UniqueCardsSorter.cutPunctuationFromArray(splitedStr, unsramblePattern);
      if (hids.indexOf(curCard.hid) === -1 && splitedStr.length >= 3) {
        cards.push(curCard);
        hids.push(curCard.hid);
      }
    }
    // if we did not find any card with 3 words lets get cards with 2 words
    if (cards.length === 0) {
      for (let i = 0; i < len; i++) {
        const curCard = inCards[i];
        let str = curCard.cardSide2Text || '';
        str = str.replace(UniqueCardsSorter.stripTags, '');
        let splitedStr = str.split(pat);
        splitedStr = UniqueCardsSorter.cutPunctuationFromArray(splitedStr, unsramblePattern);
        if (hids.indexOf(curCard.hid) === -1 && splitedStr.length >= 2) {
          cards.push(curCard);
          hids.push(curCard.hid);
        }
      }
    }
    return isGameMode ? cards : ArrayUtil.randomize(cards);
  }
  /**
   * Cut punctuations from an Array
   */
  static cutPunctuationFromArray(value, unsramblePattern) {
    // clear array from empty ("") elements
    let emptyIndex = value.indexOf('');
    while (emptyIndex > -1) {
      value.splice(emptyIndex, 1);
      emptyIndex = value.indexOf('');
    }
    const arr = value.concat();
    let index = 0;
    while (arr.length > index) {
      if (UniqueCardsSorter.isPunctuation(arr[index], unsramblePattern)) {
        arr.splice(index, 1);
        continue;
      }
      index++;
    }
    return arr;
  }
  /**
   * Return true if word is punctuation
   */
  static isPunctuation(word, unscramblePattern) {
    if (!word) {
      return false;
    }
    const matchedArr = word.match(unscramblePattern);
    return matchedArr && matchedArr.length > 0 || word === '\u0022';
  }
  /**
   * Filters cards for autoFITB and removes any card which given side has less then three words
   */
  static getUniqueFitbCards(cards, side) {
    side = side || 'cardSide2Text';
    return cards.filter(item => {
      const str = (item[side] || '').replace(UniqueCardsSorter.stripTags, '');
      return str.replace(UniqueCardsSorter.PUNCT_PAT, ' ').replace(new RegExp('\u00A0', 'gm'), ' ').trim().split(' ').length > 1;
    });
  }
  static getUniqueFitbCardsNew(cards, side) {
    side = side || 'cardSide2Text';
    return cards.filter(item => {
      const original = item[side] || '';
      let txt = original;
      txt = txt.replace(UniqueCardsSorter.stripTags, '');
      const words = txt.replace(UniqueCardsSorter.PUNCT_PAT, ' ').replace(new RegExp('\u00A0', 'gm'), ' ').trim().split(' ');
      const len = words.length;
      if (len < 3) {
        return false;
      } else {
        const index = Math.random() * len | 0;
        const delimiter = words[index];
        item.original = original;
        item[side] = delimiter;
        item.ftb = original.replace(delimiter, '___');
        return true;
      }
    });
  }
  /**
   * Filters out cards with length bigger than 30 chars, 20 for rtl
   */
  static getWrittenAssessmentCards(cards, side, numNeeded, isRtl) {
    side = side || 'cardSide2Text';
    const numChars = isRtl ? 20 : 30;
    let res = cards.filter(item => {
      const txt = (item[side] || '').replace(UniqueCardsSorter.stripTags, '');
      return txt.replace(UniqueCardsSorter.PUNCT_PAT, '').length <= numChars;
    });
    numNeeded = Math.min(numNeeded, cards.length);
    if (res.length < numNeeded) {
      numNeeded = numNeeded - res.length;
      const remCards = cards.filter(card => {
        const txt = (card[side] || '').replace(UniqueCardsSorter.stripTags, '');
        return txt.replace(UniqueCardsSorter.PUNCT_PAT, '').length > numChars;
      });
      res = res.concat(remCards.slice(0, numNeeded));
    }
    return res;
  }
  /**
   * Check Required Sound
   */
  static requiredSound(cards, soundsReq) {
    return cards.filter(item => {
      return item.soundSide2 !== '' && item.soundSide2 !== null;
    }).length >= soundsReq;
  }
  /**
   * Creates distractors for activities which present distractors, the activity should choose to present distractors
   * which are similar to the target, so that the answer is not obvious.
   */
  static createSpeechDistractors(answerCard, side, cards) {
    const answers = [];
    let item;
    let items = [];
    let numItems;
    let PUNCT_PAT;
    side = side || 'cardSide2Text';
    /* eslint-disable max-len */
    PUNCT_PAT = /[\u0022\u002D\u005D\u005B\u005C\u0021\u0023\u0024\u0025\u0026\u0028\u0029\u002A\u002B\u002C\u002E\u003A\u003B\u003C\u003D\u003E\u003F\u0040\u005E\u005F\u0060\u007E\u007C\u007B\u007D\u002F\u2026\u2013\u2014\u2015\u2000\u00A0\u02C6\u02C7\u02C9\u02D8\u02D9\u02DA\u02DB\u02DC\u02DD\u060C\u061B\u061F\u061E]/gm;
    let cardText = (answerCard[side] || '').replace(UniqueCardsSorter.stripTags, '');
    cardText = cardText.replace(PUNCT_PAT, '');
    const arr = [];
    const tmpCards = [];
    for (const tmpCard of cards) {
      if (~arr.indexOf(tmpCard[side]) || tmpCard[side] === cardText) {
        continue;
      }
      tmpCards.push(tmpCard);
      arr.push(tmpCard[side]);
    }
    let len = tmpCards.length;
    for (let j = 0; j < len; j++) {
      const card = tmpCards[j].clone();
      item = {
        points: 0,
        card
      };
      let currentText = (card[side] || '').replace(UniqueCardsSorter.stripTags, '');
      currentText = currentText.replace(PUNCT_PAT, '');
      item.points = UniqueCardsSorter.levensteinDistance(currentText, cardText);
      items.push(item);
    }
    items = UniqueCardsSorter.itemsSort(items);
    items = items.slice(0, 4);
    len = Math.min(3, items.length);
    numItems = Math.min(4, items.length);
    while (answers.length < len) {
      const ind = Math.floor(Math.random() * numItems);
      const card = items.splice(ind, 1)[0].card;
      card.isCorrect = false;
      numItems--;
      answers.push(card);
    }
    return answers;
  }
  /**
   * remove duplicate cards
   */
  static removeDuplicateCards(cards, side) {
    const cardTexts = [],
      cloneCards = [];
    cards.forEach(card => {
      if (!cardTexts.includes(card[side])) {
        cardTexts.push(card[side]);
        cloneCards.push(card);
      }
    });
    return cloneCards;
  }
  /**
   * clean html tags and nbsp
   */
  static cleanTags(str) {
    return (str || '').replace(UniqueCardsSorter.stripTags, '').replace(new RegExp('\u00A0', 'gm'), ' ');
  }
  /**
   * sort items
   */
  static itemsSort(items) {
    items.sort((a, b) => {
      if (a.points < b.points) {
        return 1;
      } else if (a.points > b.points) {
        return -1;
      }
      return 0;
    });
    return items;
  }
  /**
   *
   */
  static levensteinDistance(text = '', translit = '') {
    if (text.length === 0 || translit.length === 0) {
      return 0;
    }
    let tmp;
    let i;
    let j;
    let prev;
    let val;
    // swap to save some memory O(min(a,b)) instead of O(a)
    if (text.length > translit.length) {
      tmp = text;
      text = translit;
      translit = tmp;
    }
    const row = Array(text.length + 1);
    // init the row
    for (i = 0; i <= text.length; i++) {
      row[i] = i;
    }
    // fill in the rest
    for (i = 1; i <= translit.length; i++) {
      prev = i;
      for (j = 1; j <= text.length; j++) {
        if (translit[i - 1] === text[j - 1]) {
          val = row[j - 1]; // match
        } else {
          val = Math.min(row[j - 1] + 1,
          // substitution
          Math.min(prev + 1,
          // insertion
          row[j] + 1)); // deletion
        }

        row[j - 1] = prev;
        prev = val;
      }
      row[text.length] = prev;
    }
    return row[text.length];
  }
}
let CardDisplayMode = /*#__PURE__*/(() => {
  class CardDisplayMode {
    /**
     * Static constant for sets visible of display picture and text.
     */
    static {
      this.PICTURE_TEXT = 'pictureText';
    }
    /**
     * Static constant for sets visible of display picture only.
     */
    static {
      this.PICTURE_ONLY = 'pictureOnly';
    }
    /**
     * Static constant for sets visible of display text only.
     */
    static {
      this.TEXT_ONLY = 'textOnly';
    }
  }
  return CardDisplayMode;
})();
class CardLearningMode {
  /**
   * Specifies Preview It mode
   */
  static {
    this.PREVIEW_IT = 'PreviewIt';
  }
  /**
   * Specifies Preview It mode
   */
  static {
    this.PREVIEW_PLUS = 'PreviewPlus';
  }
  /**
   * Specifies Recognize It (Say)
   */
  static {
    this.SELF_REPORTING_RECOGNIZE_IT = 'Self-ReportingRecognizeIt';
  }
  /**
   * Specifies Recognize It (Write)
   */
  static {
    this.WRITTEN_RECOGNIZE_IT = 'WrittenRecognizeIt';
  }
  /**
   * Specifies Produce It (Say)
   */
  static {
    this.SELF_REPORTING_PRODUCE_IT = 'Self-ReportingProduceIt';
  }
  /**
   * Specifies Produce It (Write)
   */
  static {
    this.WRITTEN_PRODUCE_IT = 'WrittenProduceIt';
  }
  /**
   * Specifies learning modes list.
   */
  static {
    this.LEARNING_MODES = [CardLearningMode.PREVIEW_IT, CardLearningMode.SELF_REPORTING_RECOGNIZE_IT, CardLearningMode.WRITTEN_RECOGNIZE_IT, CardLearningMode.SELF_REPORTING_PRODUCE_IT, CardLearningMode.WRITTEN_PRODUCE_IT];
  }
}
let BykiCardScore = /*#__PURE__*/(() => {
  class BykiCardScore {
    constructor() {
      /**
       * Max score for current mode.
       */
      this.maxScore = 0;
      /**
       * The amount of changed score
       */
      this.delta = 0;
      /**
       * If we are adding 2 extracted point we need to know when not to add them
       * if we added them once a score was 0, next time when it chnaed to 0 we will not add 2
       */
      this.prevScore = -1;
      /**
       * Indicates if last user answer was correct or not
       */
      this.isCorrect = false;
      /**
       * Refresh interval
       */
      this.refreshInterval = 0;
      /**
       * Refresh interval
       */
      this.ghostScore = 0;
      /**
       * Indicates if first user answer during the seesion was correctc or not
       */
      this.isFirstWasCorrect = false;
      /**
       * Card unique id
       */
      this.cardId = 0;
      /**
       * User unique id
       */
      this.userId = 0;
      /**
       * Card hid
       */
      this.hid = '';
      /**
       * list Id
       */
      this.listId = '';
      /**
       * Card score from 1 to 8
       */
      this.score = 0;
      /**
       * Tracks learning history for the card
       */
      this.history = 0;
      /**
       * Number of wrong answers by user fir current card
       */
      this.wrongAnswerCounter = 0;
      /**
       * Refresh interval computed by interval algorithm when it is 0 item becames stale
       */
      this.interval = 0;
      /**
       * A String representing learned and unlearned state of the card
       * A card is considered as learned if its score is bigger than 6
       */
      this.bucket = '';
    }
    /**
     * Milliseconds per day
     */
    static {
      this.DAY = 1000 * 60 * 60 * 24;
    }
    /**
     * Learned satte of bucket
     */
    static {
      this.LEARNED = 'LEARNED';
    }
    /**
     * Learned satte of bucket
     */
    static {
      this.UNLEARNED = 'UNLEARNED';
    }
    /**
     * Indicated if a card is sate or fresh
     */
    isStale() {
      if (!this.lastRefreshed) {
        return false;
      }
      return new Date().getTime() > this.lastRefreshed.getTime() + this.interval * BykiCardScore.DAY;
    }
    /**
     * Actual refresh interval for the card
     */
    actualRefreshInterval() {
      if (!this.lastRefreshed) {
        return 0;
      }
      return (new Date().getTime() - this.lastRefreshed.getTime()) / BykiCardScore.DAY;
    }
  }
  return BykiCardScore;
})(); // @ts-ignore
// @ts-nocheck
function normalizeBykiList(source, dest) {
  const arr = ['undefined', 'function'];
  for (const key in source) {
    if (key !== 'cards' && !arr.includes(typeof source[key])) {
      dest[key] = source[key];
    }
  }
  let nf = null;
  const tagPat = /tagalog/ig;
  const vietPat = /vietnamese/ig;
  const yorubaPat = /yoruba/ig;
  if (tagPat.test(dest.side2Lang) || yorubaPat.test(dest.side2Lang)) {
    nf = normalizeTagalog;
  } else if (vietPat.test(dest.side2Lang)) {
    nf = normalizeVietnamese;
  }
  dest.cards = (source.cards || []).map(card => {
    let newCard = new BykiCard();
    for (const key in card) {
      if (!arr.includes(typeof card[key])) {
        newCard[key] = card[key];
      }
    }
    newCard.cardSide1Text = normalizeString(newCard.cardSide1Text);
    newCard.cardSide1Hint = normalizeString(newCard.cardSide1Hint);
    newCard.cardSide2Text = normalizeString(newCard.cardSide2Text);
    newCard.cardSide2Hint = normalizeString(newCard.cardSide2Hint);
    newCard.cardTranslit = normalizeString(newCard.cardTranslit);
    newCard.cardComment = normalizeString(newCard.cardComment);
    newCard.side1AltAnswers = (newCard.side1AltAnswers || []).map(altAnswer => normalizeString(altAnswer));
    newCard.side2AltAnswers = (newCard.side2AltAnswers || []).map(altAnswer => normalizeString(altAnswer));
    newCard.side2AltPhrase = normalizeString(newCard.side2AltPhrase);
    if (nf !== null) {
      newCard = nf(newCard);
    }
    newCard = normalizeEllipsis(newCard);
    return newCard;
  });
  return dest;
}

/**
 * Utility class for parsing b4x list xml file
 */
class B4xParser {
  createBykiList(listJson, rootPath, isTranslit) {
    rootPath = rootPath || '';
    if (rootPath !== '' && rootPath[rootPath.length - 1] !== '/') {
      rootPath = rootPath + '/';
    }
    let bykiList = new BykiList();
    const head = listJson.head;
    if (isDefined(head.name)) {
      bykiList.name = head.name.trim();
    }
    bykiList.side1Lang = head.side1_language_key || head.side1_language || '';
    bykiList.side2Lang = head.side2_language_key || head.side2_language || '';
    bykiList.side1Lang = (bykiList.side1Lang || '').trim();
    bykiList.side2Lang = (bykiList.side2Lang || '').trim();
    // if is translit is not set and language is Cantonese set it to true;
    if (!isDefined(isTranslit)) {
      isTranslit = bykiList.side2Lang === 'CANTONESE';
    }
    bykiList.description = head.description;
    bykiList.creator = head.creator;
    bykiList.creatorURL = head.creator_url;
    bykiList.appCreatorName = head.creator_application;
    bykiList.subjectName = head.subject_name;
    bykiList.side1Name = head.side1_title;
    bykiList.side2Name = head.side2_title;
    bykiList.creationDate = new Date(head.creation_date);
    bykiList.isThemed = head.is_themed === 'true';
    bykiList.isGovernment = head.is_government === 'true';
    bykiList.isLibrary = head.is_library === 'true';
    bykiList.isTransliterationShown = head.is_transliteration_shown === 'true';
    bykiList.isOrdered = head.is_ordered === 'true';
    bykiList.learningModes = parseLearningModes(head.LearningFeatures);
    bykiList.listProtection = parseProtection(head.ListProtection);
    bykiList.uuid = head.uuid;
    bykiList.aaid = head.aaid;
    bykiList.version = head.version | 0;
    let cards = Array.isArray(listJson.cards) ? listJson.cards : listJson.cards.card;
    cards = Array.isArray(cards) ? cards : [cards];
    bykiList = this.parseCards(cards, bykiList, rootPath, isTranslit);
    bykiList.cards.sort((a, b) => a.cardPosition - b.cardPosition);
    return bykiList;
  }
  parseCards(cards, bykiList, rootPath, isTranslit) {
    const parsedCards = [];
    let nf = null;
    const tagPat = /tagalog/ig;
    const vietPat = /vietnamese/ig;
    const yorubaPat = /yoruba/ig;
    if (tagPat.test(bykiList.side2Lang) || yorubaPat.test(bykiList.side2Lang)) {
      nf = normalizeTagalog;
    } else if (vietPat.test(bykiList.side2Lang)) {
      nf = normalizeVietnamese;
    }
    const len = cards.length;
    for (let i = 0; i < len; i++) {
      const card = cards[i];
      let bc = this.parseCard(card, bykiList, rootPath, isTranslit);
      if (nf !== null) {
        bc = nf(bc);
      }
      bc = normalizeEllipsis(bc);
      parsedCards.push(bc);
    }
    bykiList.cards = parsedCards;
    return bykiList;
  }
  parseCard(card, bykiList, rootPath, isTranslit) {
    const bc = new BykiCard();
    const pattern = /\s|\u200B/g;
    bc.cardSide1Text = getStringValue(card.side1_phrase);
    let textValue = getStringValue(card.side2_phrase);
    if (isTranslit && isDefined(card.side2_transliteration)) {
      bc.cardTranslit = textValue;
    } else {
      bc.cardSide2Text = textValue;
    }
    try {
      bc.sideTwoWordCount = bc.cardSide2Text.split(pattern).length + 1;
    } catch (e) {}
    let url = getStringValue(card.side1_sound, '_url') || null;
    if (url) {
      bc.soundSide1 = rootPath + url;
    }
    url = getStringValue(card.side2_sound, '_url') || null;
    if (url) {
      bc.soundSide2 = rootPath + url;
    }
    url = getStringValue(card.side2_picture, '_url') || null;
    if (url) {
      bc.picture = rootPath + url;
    }
    let info = getStringValue(card.side2_picture, 'attribution') || null;
    if (!info) {
      info = getStringValue(card.side2_picture_attribution, '') || null;
    }
    if (info) {
      bc.pictureInfo = info;
    }
    bc.cardSide1Hint = getStringValue(card.side1_hint);
    bc.cardSide2Hint = getStringValue(card.side2_hint);
    textValue = getStringValue(card.side2_transliteration);
    if (isTranslit && textValue) {
      bc.cardSide2Text = textValue;
    } else {
      bc.cardTranslit = textValue;
    }
    bc.cardPosition = +getStringValue(card.list_position);
    bc.cardComment = getStringValue(card.comment, '__text');
    bc.cardGuid = getStringValue(card.guid, '__text');
    bc.cardGuid = bc.cardGuid.replace(/^\{/g, '').replace(/\}$/g, '');
    bc.side1AltAnswers = this.parseAlternative(card.side1_alt_answers);
    bc.side2AltAnswers = this.parseAlternative(card.side2_alt_answers);
    bc.side2AltPhrase = getStringValue(card.alternative_side2_phrase) || getStringValue(card.side2_alternative_phrase);
    bc.hid = card.hid || '';
    if (!bc.hid) {
      let s2 = bykiList.side2Lang;
      if (isTranslit && s2.substr(0, 2) !== 'T_') {
        s2 = 'T_' + s2;
      }
      bc.hid = createHid(bc.cardSide1Text, bc.cardSide2Text, bykiList.side1Lang, s2);
    }
    bc.prompt = getStringValue(card.prompt);
    bc.hideExportPdf = typeof card.hideExportPdf === 'boolean' ? card.hideExportPdf : card.hideExportPdf === 'true';
    return bc;
  }
  parseAlternative(altAnswer) {
    const res = [];
    let list = altAnswer ? altAnswer.alt_answer : [];
    if (!(list instanceof Array)) {
      list = [list];
    }
    const len = list ? list.length : 0;
    for (let j = 0; j < len; j++) {
      if (list[j]) {
        let str = list[j] || '';
        str = normalizeString(str);
        res.push(str);
      }
    }
    return res.length > 0 ? res : null;
  }
}
/**
 * Utility function if value is undefined, false otherwise
 */
function isDefined(value) {
  return typeof value !== 'undefined';
}
/**
 * Utility function for checking objects
 */
function isObject(value) {
  return value !== null && typeof value === 'object';
}
/**
 * Checks if value is string or not
 */
function isString(value) {
  return typeof value === 'string';
}
/**
 * get string value
 */
function getStringValue(value, property) {
  let str = '';
  if (typeof value !== 'boolean' && isDefined(value)) {
    if (isObject(value)) {
      if (property && value.hasOwnProperty(property)) {
        str = value[property] || '';
      } else {
        str = value._text || '';
      }
    } else {
      str = value || '';
    }
    if (!isString(str)) {
      str = str + '';
    }
    normalizeString(str);
  }
  str = str.replace('<![CDATA[', '').replace(']]>', '');
  return normalizeString(str);
}
/**
 * parse as Learning Modes
 */
function parseLearningModes(learningMode) {
  const lm = new LearningModes();
  lm.hasPreviewIt = learningMode.is_PreviewIt === 'true';
  lm.hasSRRecognizeIt = learningMode.is_SR_RecognizeIt === 'true';
  lm.hasWrittenRecognizeIt = learningMode.is_Written_RecognizeIt === 'true';
  lm.hasSRProduceIt = learningMode.is_SR_ProduceIt === 'true';
  lm.hasWrittenProduceIt = learningMode.is_Written_ProduceIt === 'true';
  return lm;
}
function parseProtection(obj) {
  const lp = new ListProtection();
  if (obj) {
    lp.isCopyingProtected = obj.is_Protected_Copying === 'true';
    lp.isSharingProtected = obj.is_Protected_Sharing === 'true';
    lp.isEditingProtected = obj.is_Protected_Editing === 'true';
  }
  return lp;
}
let ActivityService = /*#__PURE__*/(() => {
  class ActivityService {
    constructor() {
      this.aeChange = new Subject();
      this.sgChange = new Subject();
      this.sendMessageToShell = new Subject();
      this.sendMessageToModule = new Subject();
      this.sendReport = new Subject();
    }
    static {
      this.ɵfac = function ActivityService_Factory(t) {
        return new (t || ActivityService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: ActivityService,
        factory: ActivityService.ɵfac
      });
    }
  }
  return ActivityService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ActivityReportService = /*#__PURE__*/(() => {
  class ActivityReportService {
    constructor(activityService, upConfig) {
      this.activityService = activityService;
      this.upConfig = upConfig;
      this.asCorrectsCount = 0;
      this.challengesCount = 0;
      this.correctsCount = 0;
      this.micOnCount = 0;
      this.micOffCount = 0;
      this.incorrectCount = 0;
      this.isComplete = false;
      this.isReportSent = false;
      this.isSessionExpired = false;
      this.isInBackgroundMode = false;
      this._isPaused = false;
      this.prevTimeSpent = 0;
    }
    set isPaused(value) {
      if (this._isPaused !== value && this.isInitialized) {
        this._isPaused = value;
        if (value) {
          this.prevTimeSpent += getTimeSpent(this.initialTime);
          this.initialTime = null;
        } else {
          this.initialTime = new Date();
        }
      }
    }
    get isPaused() {
      return this._isPaused;
    }
    get isInitialized() {
      return !!this.config;
    }
    clean() {
      window.removeEventListener('message', this.onGlobalMessage.bind(this));
      this.msgSub = cleanSubscription(this.msgSub);
      this.visibilitySub = cleanSubscription(this.visibilitySub);
      this.config = null;
      this.initialTime = null;
    }
    /**
     * add Challenge
     */
    addChallenge() {
      this.challengesCount += 1;
    }
    /**
     * add Mic Challenge
     */
    addMicChallenge(countMicOn = 0, countMicOff = 0) {
      this.micOnCount += countMicOn;
      this.micOffCount += countMicOff;
    }
    /**
     * accept as Correct
     */
    acceptAsCorrect(asCorrect = true) {
      this.asCorrectsCount = asCorrect ? this.asCorrectsCount += 1 : this.asCorrectsCount -= 1;
    }
    /**
     *
     *  numberOfChallenges
     */
    initialize(conf, numberOfChallenges = 0, report = null) {
      this.config = conf;
      this.initialTime = new Date();
      if (report) {
        this.asCorrectsCount = report.acceptAsCorrects;
        this.correctsCount = report.correctAnswers;
        this.incorrectCount = report.incorrectAnswers;
        this.micOnCount = report.attemptMicOn;
        this.micOffCount = report.attemptMicOff;
      } else {
        this.asCorrectsCount = 0;
        this.correctsCount = 0;
        this.incorrectCount = 0;
        this.micOnCount = 0;
        this.micOffCount = 0;
      }
      this.challengesCount = numberOfChallenges;
      this.prevTimeSpent = 0;
      this.isComplete = false;
      this.isReportSent = false;
      this.isSessionExpired = false;
      this.isInBackgroundMode = false;
      this.subscribeToMessages();
    }
    /**
     *
     */
    isCorrect(isCorrect) {
      if (isCorrect) {
        this.correctsCount += 1;
      } else {
        this.incorrectCount += 1;
      }
    }
    /**
     *
     */
    answerStatus(correct = 0, incorrect = 0) {
      this.correctsCount += correct;
      this.incorrectCount += incorrect;
    }
    getActivityReport(isComplete = false) {
      if (this.config && (this.initialTime || this.prevTimeSpent)) {
        const rep = {
          uuid: this.config.activityUUID,
          attemptMicOff: this.micOffCount,
          attemptMicOn: this.micOnCount,
          skill: this.config.activitySkill,
          name: this.config.activityNameForReport || this.config.activityName,
          moduleName: this.config.moduleName,
          timeSpent: this.prevTimeSpent + getTimeSpent(this.initialTime),
          challenges: this.correctsCount + this.incorrectCount,
          acceptAsCorrects: this.asCorrectsCount,
          correctAnswers: this.correctsCount,
          incorrectAnswers: this.incorrectCount,
          lessonIds: this.upConfig.lessonIds,
          listIds: this.upConfig.listIds,
          mliHids: this.upConfig.mliHids
        };
        this.isComplete = isComplete;
        if (isComplete) {
          rep.completionStatus = ActivityStatus.COMPLETED;
        } else if (this.correctsCount > 0 || this.incorrectCount > 0 || this.asCorrectsCount > 0 || !this.config.isAssessment && rep.timeSpent > 0) {
          rep.completionStatus = ActivityStatus.INCOMPLETE;
        } else {
          rep.completionStatus = ActivityStatus.NOT_ATTEMPTED;
        }
        if (this.config.isAssessment && rep.moduleName) {
          rep.moduleName = rep.moduleName[rep.moduleName.length - 1] !== 'A' ? rep.moduleName + 'A' : rep.moduleName;
        }
        return rep;
      }
      return null;
    }
    /**
     * Send activity report
     */
    report(isComplete) {
      if (!this.isReportSent && this.config && this.config.moduleName !== 'Assessment' && (this.initialTime || this.prevTimeSpent)) {
        this.isReportSent = true;
        const rep = this.getActivityReport(isComplete);
        console.log('Activity Report: ', rep);
        this.prevTimeSpent = 0;
        this.activityService.sendReport.next(rep);
      }
    }
    subscribeToMessages() {
      cleanSubscription(this.msgSub);
      this.msgSub = this.activityService.sendMessageToModule.subscribe(msg => {
        if (msg.name === MessageConstants.SESSION_EXPIRED && !this.isSessionExpired && !this.isComplete) {
          this.isPaused = true;
          this.isSessionExpired = true;
          this.report(false);
        } else if (msg.name === MessageConstants.SESSION_EXTENDED && this.isSessionExpired && !this.isComplete) {
          if (msg.body) {
            this.isPaused = this.isSessionExpired = this.isReportSent = false;
          }
        }
      });
      let prevVisibilityState = '';
      cleanSubscription(this.visibilitySub);
      this.visibilitySub = visibilityChange().subscribe(visibility => {
        if (!this.isInBackgroundMode && !this.isSessionExpired && prevVisibilityState !== visibility) {
          prevVisibilityState = visibility;
          this.isPaused = visibility === 'hidden';
        }
      });
      window.addEventListener('message', this.onGlobalMessage.bind(this));
    }
    onGlobalMessage(evt) {
      const mesData = evt.data;
      if (!this.isSessionExpired) {
        if (mesData.type === 'backgroundModeIn') {
          this.isInBackgroundMode = true;
          this.isPaused = true;
        } else if (mesData.type === 'backgroundModeOut') {
          this.isInBackgroundMode = false;
          this.isPaused = false;
        }
      }
    }
    static {
      this.ɵfac = function ActivityReportService_Factory(t) {
        return new (t || ActivityReportService)(i0.ɵɵinject(ActivityService), i0.ɵɵinject(PLAYER_CONFIG));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: ActivityReportService,
        factory: ActivityReportService.ɵfac
      });
    }
  }
  return ActivityReportService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * Calculate user time spent
 */
function getTimeSpent(startTime) {
  return startTime ? Math.round((new Date().getTime() - startTime.getTime()) / 1000) : 0;
}
let ActivityLocaleService = /*#__PURE__*/(() => {
  class ActivityLocaleService {
    constructor(http) {
      this.http = http;
      this.props = {};
    }
    clean() {
      this.props = {};
    }
    /**
     * Loads locale and maps its data to key value object
     */
    getLocale(localeName = 'en_US', fileName) {
      return this.http.get('locale/' + localeName + '/' + fileName + '.properties', {
        responseType: 'text'
      }).pipe(map$1(res => {
        // Never create object again. Use the one which exist in class
        stringToMap(res, this.props);
        return this.props;
      }));
    }
    /**
     * Loads prompts and maps its data to key value object
     */
    getPrompt(localeName = 'en_US', fileName) {
      return this.http.get('locale/' + localeName + '/' + fileName + '.properties', {
        responseType: 'text'
      }).pipe(map$1(res => {
        const props = {};
        stringToMap(res, props);
        return props;
      }));
    }
    static {
      this.ɵfac = function ActivityLocaleService_Factory(t) {
        return new (t || ActivityLocaleService)(i0.ɵɵinject(i1.HttpClient));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: ActivityLocaleService,
        factory: ActivityLocaleService.ɵfac
      });
    }
  }
  return ActivityLocaleService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * Convert string delimited with = to hashmap
 */
function stringToMap(str, hash) {
  str.split(/\n+/).filter(item => item[0] !== '#' && item.indexOf('=') !== -1).map(item => {
    const [key, value] = item.split('=');
    hash[key.trim()] = value.trim();
  });
}
const keyboardActivities = ['Dictation', 'Glossary', 'PowerSlides', 'ProduceWritten', 'RecognizeWritten', 'TextTranslation', 'TranscribeIt', 'TransformWrite', 'VideoPlayer', 'WIC'];
const fullPat = /^(http|https|file)?(:)?\/\//;
let ConfigService = /*#__PURE__*/(() => {
  class ConfigService {
    constructor(upConfig) {
      this.upConfig = upConfig;
      this.alphabetURL = '';
      this.asr = false;
      this.arabicFont = 'Arabic';
      this.baseHelpURL = '';
      this.configChange = new EventEmitter();
      this.currentHelpUrl = 'CWUsing_Objectives.htm';
      this.moduleHelpUrl = '';
      this.fontUrl = 'fonts/';
      this.hasChallengeTimer = false;
      this.hasInputSettings = false;
      this.href = '';
      this.dontShowMarkAsLearnedPopup = false;
      this.isSoundServerAvailable = false;
      this.isTransliterated = false;
      this.knownEasyType = false;
      this.knownFontSize = 18;
      this.languages = {};
      this.ldsUrl = '//lds.transparent.com/';
      this.learningFontSize = 18;
      this.translitFontFamily = 'Latin';
      this.translitFontSize = 18;
      this.uiDirection = 'ltr';
      this.uiFontFamily = 'Latin';
      this.wasIMEPopupShown = false;
      this.useLetterWriter = false;
      this.isAssignmentPlayer = false;
      this._hasScriptAssistant = false;
      this._soundEffectsEnabled = true;
      this._showChallengeTimer = true;
      this._showStartScreen = true;
      this._useSystemIme = false;
      this._showIndicationPattern = false;
      this._disableSingleCharsHotKey = false;
      this._skipHearingActivities = false;
      this._captionControl = false;
      this.init();
    }
    /**
     *  show start screen
     */
    set showChallengeTimer(value) {
      if (this._showChallengeTimer !== value) {
        this._showChallengeTimer = value;
        this.configChange.emit({
          name: 'showChallengeTimer',
          value
        });
      }
    }
    get showChallengeTimer() {
      return this._showChallengeTimer;
    }
    set captionControl(value) {
      if (this._captionControl !== value) {
        this._captionControl = value;
        if (this.upConfig.isLessonGin) {
          document.cookie = 'isLGCaptionControl=' + value;
        }
        this.configChange.emit({
          name: 'captionControl',
          value
        });
      }
    }
    get captionControl() {
      return this._captionControl;
    }
    set showIndicationPattern(value) {
      if (this._showIndicationPattern !== value) {
        this._showIndicationPattern = value;
        if (this.upConfig.isLessonGin) {
          document.cookie = 'isLGShowIndicationPattern=' + value;
        }
        this.configChange.emit({
          name: 'showIndicationPattern',
          value
        });
      }
    }
    get showIndicationPattern() {
      return this._showIndicationPattern;
    }
    set disableSingleCharsHotKey(value) {
      if (this._disableSingleCharsHotKey !== value) {
        this._disableSingleCharsHotKey = value;
        if (this.upConfig.isLessonGin) {
          document.cookie = 'isLGDisableSingleCharsHotKey=' + value;
        }
        this.configChange.emit({
          name: 'disableSingleCharsHotKey',
          value
        });
      }
    }
    get disableSingleCharsHotKey() {
      return this._disableSingleCharsHotKey;
    }
    set skipHearingActivities(value) {
      if (this._skipHearingActivities !== value) {
        this._skipHearingActivities = value;
        this.configChange.emit({
          name: 'skipHearingActivities',
          value
        });
      }
    }
    get skipHearingActivities() {
      return this._skipHearingActivities;
    }
    set userData(value) {
      this.showStartScreen = value.showStartScreen;
      this.showChallengeTimer = value.showChallengeTimer;
      this.captionControl = value.captionControl;
      this.showIndicationPattern = value.showIndicationPattern;
      this.disableSingleCharsHotKey = value.disableSingleCharsHotKey;
      this.skipHearingActivities = value.skipHearingActivities;
      this.soundEffectsEnabled = value.soundFeedbackEnabled;
      this.hearingActivitiesState = value.hearingActivitiesState || [];
      this.dontShowMarkAsLearnedPopup = value.dontShowMarkAsLearnedPopup;
    }
    get userData() {
      return {
        showChallengeTimer: this._showChallengeTimer,
        showStartScreen: this._showStartScreen,
        soundEffectsEnabled: this._soundEffectsEnabled,
        soundFeedbackEnabled: this._soundEffectsEnabled,
        captionControl: this._captionControl,
        showIndicationPattern: this._showIndicationPattern,
        disableSingleCharsHotKey: this._disableSingleCharsHotKey,
        skipHearingActivities: this._skipHearingActivities,
        hearingActivitiesState: this.hearingActivitiesState,
        dontShowMarkAsLearnedPopup: this.dontShowMarkAsLearnedPopup
      };
    }
    /**
     *  show start screen
     */
    set showStartScreen(value) {
      if (this._showStartScreen !== value) {
        this._showStartScreen = value;
        if (this.upConfig.isLessonGin) {
          document.cookie = 'isLGHelpOverState=' + value;
        }
        this.configChange.emit({
          name: 'showStartScreen',
          value
        });
      }
    }
    get showStartScreen() {
      return this._showStartScreen;
    }
    /**
     *  enable or disable sound effects
     */
    set soundEffectsEnabled(value) {
      if (this._soundEffectsEnabled !== value) {
        this._soundEffectsEnabled = value;
        if (this.upConfig.isLessonGin) {
          document.cookie = 'isLGSoundEffectsEnabled=' + value;
        }
        this.configChange.emit({
          name: 'soundEffectsEnabled',
          value
        });
      }
    }
    get soundEffectsEnabled() {
      return this._soundEffectsEnabled;
    }
    /**
     * useSystemIme
     */
    set useSystemIme(value) {
      if (this._useSystemIme !== value) {
        this._useSystemIme = value;
        this.configChange.emit({
          name: 'useSystemIme',
          value
        });
      }
    }
    get useSystemIme() {
      return this._useSystemIme;
    }
    /**
     * hasScriptAssistant
     */
    set hasScriptAssistant(value) {
      if (this._hasScriptAssistant !== value) {
        this._hasScriptAssistant = value;
        this.configChange.emit({
          name: 'hasScriptAssistant',
          value
        });
      }
    }
    get hasScriptAssistant() {
      return this._hasScriptAssistant;
    }
    /**
     * root data path
     */
    get rootDataPath() {
      this.upConfig.rootDataPath = this.upConfig.rootDataPath || '';
      if (fullPat.test(this.upConfig.rootDataPath)) {
        return this.upConfig.rootDataPath;
      } else {
        return this.href + this.upConfig.rootDataPath;
      }
    }
    /**
     * Prepare for gb
     */
    clean() {
      this.languages = null;
    }
    /**
     * For help overlay checkbox component, sometimes we need just to change it, without sending event
     */
    changeStartScreen(value) {
      this._showStartScreen = value;
    }
    /**
     * Generates configuration object and returns it
     */
    getConfig() {
      const configVo = new ConfigurationVO();
      configVo.alphabetUrl = this.alphabetURL;
      configVo.arabicFont = this.arabicFont;
      configVo.asr = this.asr;
      configVo.disableRightClick = this.upConfig.disableRightClick;
      configVo.easyType = this.easyType;
      configVo.fontUrl = this.fontUrl;
      configVo.hasScriptAssistant = this.hasScriptAssistant;
      configVo.isKeyboardVisible = this.isKeyboardVisible(this.learningLanguageCode);
      configVo.isSoundServerAvailable = this.isSoundServerAvailable;
      configVo.isTransliterated = this.isTransliterated;
      configVo.knownDirection = this.knownDirection;
      configVo.knownFontFamily = this.knownFontFamily;
      configVo.knownFontSize = this.knownFontSize;
      configVo.knownLanguage = this.knownLanguage;
      configVo.knownLanguageCode = this.knownLanguageCode;
      configVo.knownLanguageIsLatin = this.knownLanguageIsLatin;
      configVo.LDSUrl = this.ldsUrl;
      configVo.learningDirection = this.learningDirection;
      configVo.learningFontFamily = this.learningFontFamily;
      configVo.learningFontSize = this.learningFontSize;
      configVo.learningLanguage = this.learningLanguage;
      configVo.learningLanguageCode = this.learningLanguageCode;
      configVo.learningLanguageIsLatin = this.learningLanguageIsLatin;
      configVo.showChallengeTimer = this.showChallengeTimer;
      configVo.showStartScreen = this.showStartScreen;
      configVo.soundEffectsEnabled = this.soundEffectsEnabled;
      configVo.soundServer = this.soundServer;
      configVo.translitFontSize = this.translitFontSize;
      configVo.uiDirection = this.uiDirection;
      configVo.uiFontFamily = this.uiFontFamily;
      configVo.uiLanguageCode = this.uiLanguageCode;
      configVo.userName = this.userName;
      configVo.userUUID = this.userUUID;
      configVo.wasIMEPopupShown = this.wasIMEPopupShown;
      configVo.useSystemIme = this.useSystemIme;
      configVo.useLetterWriter = this.useLetterWriter;
      configVo.captionControl = this.captionControl;
      configVo.showIndicationPattern = this.showIndicationPattern;
      configVo.disableSingleCharsHotKey = this.disableSingleCharsHotKey;
      configVo.knownEasyType = this.knownEasyType;
      configVo.isAssignmentPlayer = this.isAssignmentPlayer;
      return configVo;
    }
    /**
     *  is keyboard visible
     */
    isKeyboardVisible(languageCode) {
      let isLangLatin = true;
      if (/VIETNAMESE/.test(languageCode)) {
        isLangLatin = false;
      }
      if (/T_/.test(languageCode)) {
        isLangLatin = true;
      }
      const lang = this.languages[languageCode];
      if (lang) {
        isLangLatin = lang.font === 'Latin';
      }
      return !isLangLatin && languageCode !== 'JAVANESE';
    }
    /**
     * Sets flag fro ime input settings hide show based on activity and language codes
     */
    setHasInputSetting(activityName) {
      const imePat = /chinese|mandarin|mandarin_traditional|korean/i;
      if (!this.isTransliterated && (imePat.test(this.learningLanguageCode) || imePat.test(this.knownLanguageCode))) {
        activityName = (activityName || '').replace(/A$/, '');
        this.hasInputSettings = keyboardActivities.indexOf(activityName) !== -1;
      } else {
        this.hasInputSettings = false;
      }
    }
    /**
     *  Initialize properties
     */
    init() {
      this.href = getCWBaseUrl();
      if (/https?:/.test(this.href)) {
        this.href = this.href.replace(/https?:/, '');
      }
      this.baseHelpURL = this.upConfig.baseHelpUrl || 'help/';
      this.useLetterWriter = this.upConfig.useLetterWriter;
      this.soundServer = appendLastSlash(this.upConfig.soundServer || '');
      this.fontUrl = appendLastSlash(this.upConfig.fontsUrl || this.href + 'fonts/');
      const protocol = window.location.protocol;
      const hostname = window.location.hostname;
      if (hostname !== 'localhost' && fullPat.test(protocol) && !fullPat.test(this.fontUrl)) {
        this.fontUrl = protocol + '//tplsites.s3.amazonaws.com/webfonts/';
      }
    }
    static {
      this.ɵfac = function ConfigService_Factory(t) {
        return new (t || ConfigService)(i0.ɵɵinject(PLAYER_CONFIG));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: ConfigService,
        factory: ConfigService.ɵfac
      });
    }
  }
  return ConfigService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class ActivityData {}

/**
 * The data structure representing a diff is an array of tuples:
 * [[DIFF_DELETE, 'Hello'], [DIFF_INSERT, 'Goodbye'], [DIFF_EQUAL, ' world.']]
 * which means: delete 'Hello', add 'Goodbye' and keep ' world.'
 */
const REMOVE_CHARS = /[\u0021\u0022\u002C\u002D\u002E\u003F\u00A1\u00BF\u2018\u201C\u201D\u2026]/gm;
const DIFF_DELETE = -1;
const DIFF_INSERT = 1;
const DIFF_EQUAL = 0;
// Number of seconds to map a diff before giving up (0 for infinity).
const Timeout = 1.0;
// Define some regex patterns for matching boundaries.
const nonAlphaNumericRegex_ = /[^a-zA-Z0-9]/;
const whitespaceRegex_ = /\s/;
const linebreakRegex_ = /[\r\n]/;
const blanklineEndRegex_ = /\n\r?\n$/;
const blanklineStartRegex_ = /^\r?\n\r?\n/;
/**
 * Function that create array of items from
 * text by the way splitting by spaces.
 */
let getSplittedWords;
function formatterText(value) {
  return getSpaceFormatter(value);
}
/**
 * Closure function for space formatter
 */
function getSpaceFormatter(value) {
  return (value || '').replace(/\s+/igm, ' ').trim();
}
/**
 * Closure function for space formatter
 */
function getPunctuationFormatter(value) {
  return (value || '').replace(new RegExp('[' + PUNCTUATIONS_UNICODE + ']', 'igm'), '');
}
/**
 * Closure function for regexp formatter
 */
function getRegexpFormatter(value) {
  return (value || '').replace(REMOVE_CHARS, ' ');
}
/**
 * Find the differences between two texts.  Simplifies the problem by stripping
 * any common prefix or suffix off the texts before diffing.
 */
function diff(text1, text2, splitWordsFn, opt_checklines = true, opt_deadline = null) {
  // Set a deadline by which time the diff must be complete.
  if (!opt_deadline) {
    if (Timeout <= 0) {
      opt_deadline = Number.MAX_VALUE;
    } else {
      opt_deadline = new Date().getTime() + Timeout * 3000;
    }
  }
  const deadline = opt_deadline;
  // Check for null inputs.
  if (text1 === null || text2 === null || text1 === undefined || text2 === undefined) {
    throw new Error('Null input. (diff_main)');
  }
  text1 = formatterText(text1);
  text2 = formatterText(text2);
  // Check for equality (speedup).
  if (text1 === text2) {
    return [[DIFF_EQUAL, text1 || '']];
  }
  getSplittedWords = splitWordsFn;
  const checklines = opt_checklines;
  const longtext = text1.length > text2.length ? text1 : text2;
  // Trim off common prefix (speedup).
  let commonlength = commonPrefix(text1, text2);
  const commonprefix = longtext.substring(0, commonlength);
  text1 = text1.substring(commonlength);
  text2 = text2.substring(commonlength);
  // Trim off common suffix (speedup).
  commonlength = commonSuffix(text1, text2);
  const commonsuffix = longtext.substring(longtext.length - commonlength);
  text1 = text1.substring(0, text1.length - commonlength);
  text2 = text2.substring(0, text2.length - commonlength);
  // Compute the diff on the middle block.
  const diffs = compute_(text1, text2, checklines, deadline);
  // Restore the prefix and suffix.
  if (commonprefix) {
    diffs.unshift([DIFF_EQUAL, commonprefix]);
  }
  if (commonsuffix) {
    diffs.push([DIFF_EQUAL, commonsuffix]);
  }
  cleanupMerge(diffs);
  return diffs;
}
/**
 * Convert a diff array into a pretty HTML report.
 */
function prettyHtml(diffs, splitWordsFn, diffStyle = 'background-color:#f5d865;', preserveNewLines = true) {
  const html = [];
  diffs = diffs.filter(diffArr => diffArr[0] !== -1);
  for (let i = 0; i < diffs.length; i++) {
    const op = diffs[i][0]; // Operation (insert, delete, equal)
    const text = cleanString(diffs[i][1], preserveNewLines);
    switch (op) {
      case DIFF_INSERT:
        const arr = diffs[i + 1];
        if (arr && arr[0] === 0) {
          const startPartWords = splitWordsFn(text);
          const words = splitWordsFn(text + cleanString(arr[1], preserveNewLines));
          html[i] = `<span style="${diffStyle}">${words.slice(0, startPartWords.length).join('')}</span>${(words.slice(startPartWords.length) || []).join('')}`;
          i++;
        } else {
          html[i] = `<span style="${diffStyle}">${text}</span>`;
        }
        break;
      case DIFF_EQUAL:
        html[i] = text;
        break;
    }
  }
  return html.join('');
}
function diffToHtml(diffs = []) {
  const html = [];
  for (let x = 0; x < diffs.length; x++) {
    const op = diffs[x][0]; // Operation (insert, delete, equal)
    const text = diffs[x][1]; // Text of change.
    let node;
    switch (op) {
      case DIFF_DELETE:
      case DIFF_INSERT:
        node = document.createElement('span');
        node.classList.add(op === DIFF_INSERT ? 'no-words' : 'incorrect');
        node.appendChild(document.createTextNode(text));
        html[x] = node.outerHTML;
        break;
      case DIFF_EQUAL:
        node = document.createTextNode(text);
        html[x] = node.textContent;
        break;
    }
  }
  return html.join('');
}
function cleanString(str, preserveNewLines = true) {
  const pattern_amp = /&/g;
  const pattern_lt = /</g;
  const pattern_gt = />/g;
  const pattern_br = /\n/g;
  return (str || '').replace(pattern_amp, '&amp;').replace(pattern_lt, '&lt;').replace(pattern_gt, '&gt;').replace(pattern_br, preserveNewLines ? '<br/>' : '');
}
/**
 * Find the differences between two texts.  Assumes that the texts do not
 * have any common prefix or suffix.
 * text1 Old string to be diffed.
 * text2 New string to be diffed.
 * checklines Speedup flag.  If false, then don't run a
 *     line-level diff first to identify the changed areas.
 *     If true, then run a faster, slightly less optimal diff.
 * deadline Time when the diff should be complete by.
 * !Array.<!diff.Diff> Array of diff tuples.
 */
function compute_(text1, text2, checklines, deadline) {
  let diffs;
  if (!text1) {
    // Just add some text (speedup).
    return [[DIFF_INSERT, text2]];
  }
  if (!text2) {
    // Just delete some text (speedup).
    return [[DIFF_DELETE, text1]];
  }
  let longtext = text1.length > text2.length ? text1 : text2;
  let shorttext = text1.length > text2.length ? text2 : text1;
  const i = longtext.indexOf(shorttext);
  if (i !== -1) {
    if (getSplittedWords(longtext).length === getSplittedWords(shorttext).length) {
      // Trim off common prefix (speedup).
      let commonlength = commonPrefix(longtext, shorttext);
      const commonprefix = longtext.substring(0, commonlength);
      longtext = longtext.substring(commonlength);
      shorttext = shorttext.substring(commonlength);
      // Trim off common suffix (speedup).
      commonlength = commonSuffix(longtext, shorttext);
      const commonsuffix = longtext.substring(longtext.length - commonlength);
      longtext = longtext.substring(0, longtext.length - commonlength);
      shorttext = shorttext.substring(0, shorttext.length - commonlength);
      // Shorter text is inside the longer text (speedup).
      if (!commonprefix && !commonsuffix) {
        if (shorttext === text2) {
          diffs = [[DIFF_DELETE, longtext], [DIFF_INSERT, shorttext]];
        } else {
          diffs = [[DIFF_DELETE, shorttext], [DIFF_INSERT, longtext]];
        }
      } else {
        diffs = [[DIFF_INSERT, commonprefix], [DIFF_EQUAL, shorttext], [DIFF_INSERT, commonsuffix]];
        // Swap insertions for deletions if diff is reversed.
        if (text1.length > text2.length) {
          diffs[0][0] = diffs[2][0] = DIFF_DELETE;
        }
      }
    } else {
      // Shorter text is inside the longer text (speedup).
      diffs = [[DIFF_INSERT, longtext.substring(0, i)], [DIFF_EQUAL, shorttext], [DIFF_INSERT, longtext.substring(i + shorttext.length)]];
      // Swap insertions for deletions if diff is reversed.
      if (text1.length > text2.length) {
        diffs[0][0] = diffs[2][0] = DIFF_DELETE;
      }
    }
    return diffs;
  }
  if (shorttext.length === 1 || getSplittedWords(text1).length === 1 && getSplittedWords(text2).length === 1) {
    // Single character string.
    // After the previous speedup, the character can't be an equality.
    return [[DIFF_DELETE, text1], [DIFF_INSERT, text2]];
  }
  // Check to see if the problem can be split in two.
  const hm = halfMatch_(text1, text2);
  if (hm) {
    // A half-match was found, sort out the return data.
    const text1_a = hm[0];
    const text1_b = hm[1];
    const text2_a = hm[2];
    const text2_b = hm[3];
    const mid_common = hm[4];
    // Send both pairs off for separate processing.
    const diffs_a = diff(text1_a, text2_a, getSplittedWords, checklines, deadline);
    const diffs_b = diff(text1_b, text2_b, getSplittedWords, checklines, deadline);
    // Merge the results.
    return diffs_a.concat([[DIFF_EQUAL, mid_common]], diffs_b);
  }
  if (checklines && text1.length > 100 && text2.length > 100) {
    return lineMode_(text1, text2, deadline);
  }
  return [[DIFF_DELETE, text1], [DIFF_INSERT, text2]];
}
/**
 * Do a quick line-level diff on both strings, then rediff the parts for
 * greater accuracy.
 * This speedup can produce non-minimal diffs.
 */
function lineMode_(text1, text2, deadline) {
  // Scan the text on a line-by-line basis first.
  const a = linesToChars_(text1, text2);
  text1 = a.chars1;
  text2 = a.chars2;
  const linearray = a.lineArray;
  const diffs = diff(text1, text2, getSplittedWords, false, deadline);
  // Convert the diff back to original text.
  charsToLines_(diffs, linearray);
  // Eliminate freak matches (e.g. blank lines)
  cleanupSemantic(diffs);
  // Rediff any replacement blocks, this time character-by-character.
  // Add a dummy entry at the end.
  diffs.push([DIFF_EQUAL, '']);
  let pointer = 0;
  let count_delete = 0;
  let count_insert = 0;
  let text_delete = '';
  let text_insert = '';
  while (pointer < diffs.length) {
    switch (diffs[pointer][0]) {
      case DIFF_INSERT:
        count_insert++;
        text_insert += diffs[pointer][1];
        break;
      case DIFF_DELETE:
        count_delete++;
        text_delete += diffs[pointer][1];
        break;
      case DIFF_EQUAL:
        // Upon reaching an equality, check for prior redundancies.
        if (count_delete >= 1 && count_insert >= 1) {
          // Delete the offending records and add the merged ones.
          diffs.splice(pointer - count_delete - count_insert, count_delete + count_insert);
          pointer = pointer - count_delete - count_insert;
          const a1 = diff(text_delete, text_insert, getSplittedWords, false, deadline);
          for (let j = a1.length - 1; j >= 0; j--) {
            diffs.splice(pointer, 0, a1[j]);
          }
          pointer = pointer + a1.length;
        }
        count_insert = 0;
        count_delete = 0;
        text_delete = '';
        text_insert = '';
        break;
    }
    pointer++;
  }
  diffs.pop(); // Remove the dummy entry at the end.
  return diffs;
}
/**
 * Split two texts into an array of strings.  Reduce the texts to a string of
 * hashes where each Unicode character represents one line.
 * text1 First string.
 * text2 Second string.
 * {{chars1: string, chars2: string, lineArray: !Array.<string>}}
 *     An object containing the encoded text1, the encoded text2 and
 *     the array of unique strings.
 *     The zeroth element of the array of unique strings is intentionally blank.
 */
function linesToChars_(text1, text2) {
  const lineArray = []; // e.g. lineArray[4] ===  'Hello\n'
  const lineHash = {}; // e.g. lineHash['Hello\n'] ===  4
  // '\x00' is a valid character, but various debuggers don't like it.
  // So we'll insert a junk entry to avoid generating a null character.
  lineArray[0] = '';
  /**
   * Split a text into an array of strings.  Reduce the texts to a string of
   * hashes where each Unicode character represents one line.
   * Modifies linearray and linehash through being a closure.
   */
  function diff_linesToCharsMunge_(text) {
    let chars = '';
    // Walk the text, pulling out a substring for each line.
    // text.split('\n') would would temporarily double our memory footprint.
    // Modifying text would create many large strings to garbage collect.
    let lineStart = 0;
    let lineEnd = -1;
    // Keeping our own length variable is faster than looking it up.
    let lineArrayLength = lineArray.length;
    while (lineEnd < text.length - 1) {
      lineEnd = text.indexOf('\n', lineStart);
      if (lineEnd === -1) {
        lineEnd = text.length - 1;
      }
      const line = text.substring(lineStart, lineEnd + 1);
      lineStart = lineEnd + 1;
      if (lineHash.hasOwnProperty ? lineHash.hasOwnProperty(line) : lineHash[line] !== undefined) {
        chars += String.fromCharCode(lineHash[line]);
      } else {
        chars += String.fromCharCode(lineArrayLength);
        lineHash[line] = lineArrayLength;
        lineArray[lineArrayLength++] = line;
      }
    }
    return chars;
  }
  const chars1 = diff_linesToCharsMunge_(text1);
  const chars2 = diff_linesToCharsMunge_(text2);
  return {
    chars1,
    chars2,
    lineArray
  };
}
/**
 * Rehydrate the text in a diff from a string of line hashes to real lines of
 * text.
 */
function charsToLines_(diffs, lineArray) {
  for (let x = 0; x < diffs.length; x++) {
    const chars = diffs[x][1];
    const text = [];
    for (let y = 0; y < chars.length; y++) {
      text[y] = lineArray[chars.charCodeAt(y)];
    }
    diffs[x][1] = text.join('');
  }
}
/**
 * Determine the common prefix of two strings.
 */
function commonPrefix(text1, text2) {
  // Quick check for common null cases.
  if (!text1 || !text2 || text1.charAt(0) !== text2.charAt(0)) {
    return 0;
  }
  // Binary search.
  // Performance analysis: http://neil.fraser.name/news/2007/10/09/
  let pointermin = 0;
  let pointermax = Math.min(text1.length, text2.length);
  let pointermid = pointermax;
  let pointerstart = 0;
  while (pointermin < pointermid) {
    if (text1.substring(pointerstart, pointermid) === text2.substring(pointerstart, pointermid)) {
      pointermin = pointermid;
      pointerstart = pointermin;
    } else {
      pointermax = pointermid;
    }
    pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
  }
  const longtext = text1.length > text2.length ? text1 : text2;
  const words = getSplittedWords(longtext);
  if (words.length === 1) {
    return 0;
  }
  let pos = 0;
  for (let i = 0; i < words.length; i++) {
    const word = words[i];
    pos += word.length;
    if (pos > pointermid) {
      pointermid = pos - word.length;
      break;
    }
  }
  return pointermid;
}
/**
 * Determine the common suffix of two strings.
 */
function commonSuffix(text1, text2) {
  // Quick check for common null cases.
  if (!text1 || !text2 || text1.charAt(text1.length - 1) !== text2.charAt(text2.length - 1)) {
    return 0;
  }
  // Binary search.
  // Performance analysis: http://neil.fraser.name/news/2007/10/09/
  let pointermin = 0;
  let pointermax = Math.min(text1.length, text2.length);
  let pointermid = pointermax;
  let pointerend = 0;
  while (pointermin < pointermid) {
    if (text1.substring(text1.length - pointermid, text1.length - pointerend) === text2.substring(text2.length - pointermid, text2.length - pointerend)) {
      pointermin = pointermid;
      pointerend = pointermin;
    } else {
      pointermax = pointermid;
    }
    pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
  }
  const longtext = text1.length > text2.length ? text1 : text2;
  const words = getSplittedWords(longtext).reverse();
  if (words.length === 1) {
    return 0;
  }
  let pos = 0;
  for (let i = 0; i < words.length; i++) {
    const word = words[i];
    pos += word.length;
    if (pos > pointermid) {
      pointermid = pos - word.replace(/\s$/, '').length;
      break;
    }
  }
  return pointermid;
}
/**
 * Determine if the suffix of one string is the prefix of another.
 */
function commonOverlap_(text1, text2) {
  // Cache the text lengths to prevent multiple calls.
  const text1_length = text1.length;
  const text2_length = text2.length;
  // Eliminate the null case.
  if (text1_length === 0 || text2_length === 0) {
    return 0;
  }
  // Truncate the longer string.
  if (text1_length > text2_length) {
    text1 = text1.substring(text1_length - text2_length);
  } else if (text1_length < text2_length) {
    text2 = text2.substring(0, text1_length);
  }
  const text_length = Math.min(text1_length, text2_length);
  // Quick check for the worst case.
  if (text1 === text2) {
    return text_length;
  }
  // Start by looking for a single character match
  // and increase length until no match is found.
  // Performance analysis: http://neil.fraser.name/news/2010/11/04/
  let best = 0;
  let length = 1;
  while (true) {
    const pattern = text1.substring(text_length - length);
    const found = text2.indexOf(pattern);
    if (found === -1) {
      return best;
    }
    length += found;
    if (found === 0 || text1.substring(text_length - length) === text2.substring(0, length)) {
      best = length;
      length++;
    }
  }
}
/**
 * Do the two texts share a substring which is at least half the length of the
 * longer text?
 * This speedup can produce non-minimal diffs.
 */
function halfMatch_(text1, text2) {
  if (Timeout <= 0) {
    // Don't risk returning a non-optimal diff if we have unlimited time.
    return null;
  }
  const longtext = text1.length > text2.length ? text1 : text2;
  const shorttext = text1.length > text2.length ? text2 : text1;
  if (longtext.length < 4 || shorttext.length * 2 < longtext.length) {
    return null; // Pointless.
  }
  /**
   * Does a substring of shorttext exist within longtext such that the substring
   * is at least half the length of longtext?
   * Closure, but does not reference any external variables.
   */
  function diff_halfMatchI_(longtext1, shorttext1, i) {
    // Start with a 1/4 length substring at position i as a seed.
    const seed = longtext1.substring(i, i + Math.floor(longtext1.length / 4));
    let j = -1;
    let best_common = '';
    let best_longtext_a, best_longtext_b, best_shorttext_a, best_shorttext_b;
    while ((j = shorttext1.indexOf(seed, j + 1)) !== -1) {
      const prefixLength = commonPrefix(longtext1.substring(i), shorttext1.substring(j));
      const suffixLength = commonSuffix(longtext1.substring(0, i), shorttext1.substring(0, j));
      if (best_common.length < suffixLength + prefixLength) {
        best_common = shorttext1.substring(j - suffixLength, j) + shorttext1.substring(j, j + prefixLength);
        best_longtext_a = longtext1.substring(0, i - suffixLength);
        best_longtext_b = longtext1.substring(i + prefixLength);
        best_shorttext_a = shorttext1.substring(0, j - suffixLength);
        best_shorttext_b = shorttext1.substring(j + prefixLength);
      }
    }
    if (best_common.length * 2 >= longtext1.length || best_longtext_a !== best_shorttext_a || best_longtext_b !== best_shorttext_b) {
      return [best_longtext_a, best_longtext_b, best_shorttext_a, best_shorttext_b, best_common];
    } else {
      return null;
    }
  }
  // First check if the second quarter is the seed for a half-match.
  const hm1 = diff_halfMatchI_(longtext, shorttext, Math.ceil(longtext.length / 4));
  // Check again based on the third quarter.
  const hm2 = diff_halfMatchI_(longtext, shorttext, Math.ceil(longtext.length / 2));
  let hm;
  if (!hm1 && !hm2) {
    return null;
  } else if (!hm2) {
    hm = hm1;
  } else if (!hm1) {
    hm = hm2;
  } else {
    // Both matched.  Select the longest.
    hm = hm1[4].length > hm2[4].length ? hm1 : hm2;
  }
  // A half-match was found, sort out the return data.
  let text1_a, text1_b, text2_a, text2_b;
  if (text1.length > text2.length) {
    text1_a = hm[0];
    text1_b = hm[1];
    text2_a = hm[2];
    text2_b = hm[3];
  } else {
    text2_a = hm[0];
    text2_b = hm[1];
    text1_a = hm[2];
    text1_b = hm[3];
  }
  const mid_common = hm[4];
  return [text1_a, text1_b, text2_a, text2_b, mid_common];
}
/**
 * Reduce the number of edits by eliminating semantically trivial equalities.
 */
function cleanupSemantic(diffs) {
  let changes = false;
  const equalities = []; // Stack of indices where equalities are found.
  let equalitiesLength = 0; // Keeping our own length const is faster in JS.
  let lastequality = null;
  // Always equal to diffs[equalities[equalitiesLength - 1]][1]
  let pointer = 0; // Index of current position.
  // Number of characters that changed prior to the equality.
  let length_insertions1 = 0;
  let length_deletions1 = 0;
  // Number of characters that changed after the equality.
  let length_insertions2 = 0;
  let length_deletions2 = 0;
  while (pointer < diffs.length) {
    if (diffs[pointer][0] === DIFF_EQUAL) {
      // Equality found.
      equalities[equalitiesLength++] = pointer;
      length_insertions1 = length_insertions2;
      length_deletions1 = length_deletions2;
      length_insertions2 = 0;
      length_deletions2 = 0;
      lastequality = diffs[pointer][1];
    } else {
      // An insertion or deletion.
      if (diffs[pointer][0] === DIFF_INSERT) {
        length_insertions2 += diffs[pointer][1].length;
      } else {
        length_deletions2 += diffs[pointer][1].length;
      }
      // Eliminate an equality that is smaller or equal to the edits on both
      // sides of it.
      if (lastequality && lastequality.length <= Math.max(length_insertions1, length_deletions1) && lastequality.length <= Math.max(length_insertions2, length_deletions2)) {
        // Duplicate record.
        diffs.splice(equalities[equalitiesLength - 1], 0, [DIFF_DELETE, lastequality]);
        // Change second copy to insert.
        diffs[equalities[equalitiesLength - 1] + 1][0] = DIFF_INSERT;
        // Throw away the equality we just deleted.
        equalitiesLength--;
        // Throw away the previous equality (it needs to be reevaluated).
        equalitiesLength--;
        pointer = equalitiesLength > 0 ? equalities[equalitiesLength - 1] : -1;
        length_insertions1 = 0; // Reset the counters.
        length_deletions1 = 0;
        length_insertions2 = 0;
        length_deletions2 = 0;
        lastequality = null;
        changes = true;
      }
    }
    pointer++;
  }
  // Normalize the diff.
  if (changes) {
    cleanupMerge(diffs);
  }
  cleanupSemanticLossless(diffs);
  // Find any overlaps between deletions and insertions.
  // e.g: <del>abcxxx</del><ins>xxxdef</ins>
  //   -> <del>abc</del>xxx<ins>def</ins>
  // e.g: <del>xxxabc</del><ins>defxxx</ins>
  //   -> <ins>def</ins>xxx<del>abc</del>
  // Only extract an overlap if it is as big as the edit ahead or behind it.
  pointer = 1;
  while (pointer < diffs.length) {
    if (diffs[pointer - 1][0] === DIFF_DELETE && diffs[pointer][0] === DIFF_INSERT) {
      const deletion = diffs[pointer - 1][1];
      const insertion = diffs[pointer][1];
      const overlap_length1 = commonOverlap_(deletion, insertion);
      const overlap_length2 = commonOverlap_(insertion, deletion);
      if (overlap_length1 >= overlap_length2) {
        if (overlap_length1 >= deletion.length / 2 || overlap_length1 >= insertion.length / 2) {
          // Overlap found.  Insert an equality and trim the surrounding edits.
          diffs.splice(pointer, 0, [DIFF_EQUAL, insertion.substring(0, overlap_length1)]);
          diffs[pointer - 1][1] = deletion.substring(0, deletion.length - overlap_length1);
          diffs[pointer + 1][1] = insertion.substring(overlap_length1);
          pointer++;
        }
      } else {
        if (overlap_length2 >= deletion.length / 2 || overlap_length2 >= insertion.length / 2) {
          // Reverse overlap found.
          // Insert an equality and swap and trim the surrounding edits.
          diffs.splice(pointer, 0, [DIFF_EQUAL, deletion.substring(0, overlap_length2)]);
          diffs[pointer - 1][0] = DIFF_INSERT;
          diffs[pointer - 1][1] = insertion.substring(0, insertion.length - overlap_length2);
          diffs[pointer + 1][0] = DIFF_DELETE;
          diffs[pointer + 1][1] = deletion.substring(overlap_length2);
          pointer++;
        }
      }
      pointer++;
    }
    pointer++;
  }
  return diffs;
}
/**
 * Look for single edits surrounded on both sides by equalities
 * which can be shifted sideways to align the edit to a word boundary.
 * e.g: The c<ins>at c</ins>ame. -> The <ins>cat </ins>came.
 */
function cleanupSemanticLossless(diffs) {
  /**
   * Given two strings, compute a score representing whether the internal
   * boundary falls on logical boundaries.
   * Scores range from 6 (best) to 0 (worst).
   * Closure, but does not reference any external variables.
   */
  function diff_cleanupSemanticScore_(one, two) {
    if (!one || !two) {
      // Edges are the best.
      return 6;
    }
    // Each port of this function behaves slightly differently due to
    // subtle differences in each language's definition of things like
    // 'whitespace'.  Since this function's purpose is largely cosmetic,
    // the choice has been made to use each language's native features
    // rather than force total conformity.
    const char1 = one.charAt(one.length - 1);
    const char2 = two.charAt(0);
    const nonAlphaNumeric1 = char1.match(nonAlphaNumericRegex_);
    const nonAlphaNumeric2 = char2.match(nonAlphaNumericRegex_);
    const whitespace1 = nonAlphaNumeric1 && char1.match(whitespaceRegex_);
    const whitespace2 = nonAlphaNumeric2 && char2.match(whitespaceRegex_);
    const lineBreak1 = whitespace1 && char1.match(linebreakRegex_);
    const lineBreak2 = whitespace2 && char2.match(linebreakRegex_);
    const blankLine1 = lineBreak1 && one.match(blanklineEndRegex_);
    const blankLine2 = lineBreak2 && two.match(blanklineStartRegex_);
    if (blankLine1 || blankLine2) {
      // Five points for blank lines.
      return 5;
    } else if (lineBreak1 || lineBreak2) {
      // Four points for line breaks.
      return 4;
    } else if (nonAlphaNumeric1 && !whitespace1 && whitespace2) {
      // Three points for end of sentences.
      return 3;
    } else if (whitespace1 || whitespace2) {
      // Two points for whitespace.
      return 2;
    } else if (nonAlphaNumeric1 || nonAlphaNumeric2) {
      // One point for non-alphanumeric.
      return 1;
    }
    return 0;
  }
  let pointer = 1;
  // Intentionally ignore the first and last element (don't need checking).
  while (pointer < diffs.length - 1) {
    if (diffs[pointer - 1][0] === DIFF_EQUAL && diffs[pointer + 1][0] === DIFF_EQUAL) {
      // This is a single edit surrounded by equalities.
      let equality1 = diffs[pointer - 1][1];
      let edit = diffs[pointer][1];
      let equality2 = diffs[pointer + 1][1];
      // First, shift the edit as far left as possible.
      const commonOffset = commonSuffix(equality1, edit);
      if (commonOffset) {
        const commonString = edit.substring(edit.length - commonOffset);
        equality1 = equality1.substring(0, equality1.length - commonOffset);
        edit = commonString + edit.substring(0, edit.length - commonOffset);
        equality2 = commonString + equality2;
      }
      // Second, step character by character right, looking for the best fit.
      let bestEquality1 = equality1;
      let bestEdit = edit;
      let bestEquality2 = equality2;
      let bestScore = diff_cleanupSemanticScore_(equality1, edit) + diff_cleanupSemanticScore_(edit, equality2);
      while (edit.charAt(0) === equality2.charAt(0)) {
        equality1 += edit.charAt(0);
        edit = edit.substring(1) + equality2.charAt(0);
        equality2 = equality2.substring(1);
        const score = diff_cleanupSemanticScore_(equality1, edit) + diff_cleanupSemanticScore_(edit, equality2);
        // The >= encourages trailing rather than leading whitespace on edits.
        if (score >= bestScore) {
          bestScore = score;
          bestEquality1 = equality1;
          bestEdit = edit;
          bestEquality2 = equality2;
        }
      }
      if (diffs[pointer - 1][1] !== bestEquality1) {
        // We have an improvement, save it back to the diff.
        if (bestEquality1) {
          diffs[pointer - 1][1] = bestEquality1;
        } else {
          diffs.splice(pointer - 1, 1);
          pointer--;
        }
        diffs[pointer][1] = bestEdit;
        if (bestEquality2) {
          diffs[pointer + 1][1] = bestEquality2;
        } else {
          diffs.splice(pointer + 1, 1);
          pointer--;
        }
      }
    }
    pointer++;
  }
}
/**
 * Reorder and merge like edit sections.  Merge equalities.
 * Any edit section can move as long as it doesn't cross an equality.
 */
function cleanupMerge(diffs) {
  diffs.push([DIFF_EQUAL, '']); // Add a dummy entry at the end.
  let pointer = 0;
  let count_delete = 0;
  let count_insert = 0;
  let text_delete = '';
  let text_insert = '';
  let commonlength;
  while (pointer < diffs.length) {
    switch (diffs[pointer][0]) {
      case DIFF_INSERT:
        count_insert++;
        text_insert += diffs[pointer][1];
        pointer++;
        break;
      case DIFF_DELETE:
        count_delete++;
        text_delete += diffs[pointer][1];
        pointer++;
        break;
      case DIFF_EQUAL:
        // Upon reaching an equality, check for prior redundancies.
        if (count_delete + count_insert > 1) {
          if (count_delete !== 0 && count_insert !== 0) {
            // Factor out any common prefixies.
            commonlength = commonPrefix(text_insert, text_delete);
            if (commonlength !== 0) {
              if (pointer - count_delete - count_insert > 0 && diffs[pointer - count_delete - count_insert - 1][0] === DIFF_EQUAL) {
                diffs[pointer - count_delete - count_insert - 1][1] += text_insert.substring(0, commonlength);
              } else {
                diffs.splice(0, 0, [DIFF_EQUAL, text_insert.substring(0, commonlength)]);
                pointer++;
              }
              text_insert = text_insert.substring(commonlength);
              text_delete = text_delete.substring(commonlength);
            }
            // Factor out any common suffixies.
            commonlength = commonSuffix(text_insert, text_delete);
            if (commonlength !== 0) {
              diffs[pointer][1] = text_insert.substring(text_insert.length - commonlength) + diffs[pointer][1];
              text_insert = text_insert.substring(0, text_insert.length - commonlength);
              text_delete = text_delete.substring(0, text_delete.length - commonlength);
            }
          }
          // Delete the offending records and add the merged ones.
          if (count_delete === 0) {
            diffs.splice(pointer - count_insert, count_delete + count_insert, [DIFF_INSERT, text_insert]);
          } else if (count_insert === 0) {
            diffs.splice(pointer - count_delete, count_delete + count_insert, [DIFF_DELETE, text_delete]);
          } else {
            diffs.splice(pointer - count_delete - count_insert, count_delete + count_insert, [DIFF_DELETE, text_delete], [DIFF_INSERT, text_insert]);
          }
          pointer = pointer - count_delete - count_insert + (count_delete ? 1 : 0) + (count_insert ? 1 : 0) + 1;
        } else if (pointer !== 0 && diffs[pointer - 1][0] === DIFF_EQUAL) {
          // Merge this equality with the previous one.
          diffs[pointer - 1][1] += diffs[pointer][1];
          diffs.splice(pointer, 1);
        } else {
          pointer++;
        }
        count_insert = 0;
        count_delete = 0;
        text_delete = '';
        text_insert = '';
        break;
    }
  }
  if (diffs[diffs.length - 1][1] === '') {
    diffs.pop(); // Remove the dummy entry at the end.
  }
  // Second pass: look for single edits surrounded on both sides by equalities
  // which can be shifted sideways to eliminate an equality.
  // e.g: A<ins>BA</ins>C -> <ins>AB</ins>AC
  let changes = false;
  pointer = 1;
  // Intentionally ignore the first and last element (don't need checking).
  while (pointer < diffs.length - 1) {
    if (diffs[pointer - 1][0] === DIFF_EQUAL && diffs[pointer + 1][0] === DIFF_EQUAL) {
      // This is a single edit surrounded by equalities.
      if (diffs[pointer][1].substring(diffs[pointer][1].length - diffs[pointer - 1][1].length) === diffs[pointer - 1][1]) {
        // Shift the edit over the previous equality.
        diffs[pointer][1] = diffs[pointer - 1][1] + diffs[pointer][1].substring(0, diffs[pointer][1].length - diffs[pointer - 1][1].length);
        diffs[pointer + 1][1] = diffs[pointer - 1][1] + diffs[pointer + 1][1];
        diffs.splice(pointer - 1, 1);
        changes = true;
      } else if (diffs[pointer][1].substring(0, diffs[pointer + 1][1].length) === diffs[pointer + 1][1]) {
        // Shift the edit over the next equality.
        diffs[pointer - 1][1] += diffs[pointer + 1][1];
        diffs[pointer][1] = diffs[pointer][1].substring(diffs[pointer + 1][1].length) + diffs[pointer + 1][1];
        diffs.splice(pointer + 1, 1);
        changes = true;
      }
    }
    pointer++;
  }
  // If shifts were made, the diff needs reordering and another shift sweep.
  if (changes) {
    cleanupMerge(diffs);
  }
}
const hotPoint3DWidth = 0.045;
let positions;
let pointsMap;
function calculatePosDelta(pos1, pos2) {
  return Math.round((Math.abs(Math.abs(pos1) - Math.abs(pos2)) + Number.EPSILON) * 10000) / 10000;
}
function getIntersectedPoint(xPos, yPos) {
  return positions.find(arr => {
    if (Math.sign(arr[0]) !== Math.sign(xPos) && Math.sign(arr[1]) !== Math.sign(yPos)) {
      return false;
    }
    const xPos1 = calculatePosDelta(arr[0], xPos);
    const yPos1 = calculatePosDelta(arr[1], yPos);
    if (xPos1 < hotPoint3DWidth && yPos1 < hotPoint3DWidth) {
      return true;
    }
    return false;
  });
}
function getIntersectedPointDelta(xPos, yPos) {
  const deltaArr = [0, 0];
  for (let i = 0; i < positions.length; i++) {
    const arr = positions[i];
    const xPos1 = calculatePosDelta(arr[0], xPos);
    const yPos1 = calculatePosDelta(arr[1], yPos);
    if (xPos1 < hotPoint3DWidth && yPos1 < hotPoint3DWidth) {
      deltaArr[0] = hotPoint3DWidth - xPos1;
      deltaArr[1] = hotPoint3DWidth - yPos1;
      break;
    }
  }
  return deltaArr;
}
function getFreePointPosition(pointPositions) {
  for (let i = 0; i < pointPositions.length; i++) {
    const arr = pointPositions[i];
    if (!getIntersectedPoint(arr[0], arr[1]) && !positions.includes(arr)) {
      positions.push(arr);
      return arr;
    }
  }
  return null;
}
function sortFunction(a, b) {
  if (a[0] === b[0]) {
    return 0;
  } else {
    return a[0] < b[0] ? -1 : 1;
  }
}
// Function to sort the array of
// points by its distance from P
function sortByReferencePoint(points, basePoint) {
  // Storing the distance with its
  // distance in the vector array
  return points.map(posArr => [Math.pow(basePoint[0] - posArr[0], 2) + Math.pow(basePoint[1] - posArr[1], 2), posArr]).sort(sortFunction).map(item => item[1]);
}
function positionPointOnSibling(hotPoint) {
  const xPos = hotPoint.position[0],
    yPos = hotPoint.position[1];
  let [deltaX, deltaY] = getIntersectedPointDelta(xPos, yPos),
    count = 0;
  let xPosM = xPos - deltaX,
    xPosP = xPos + deltaX,
    yPosM = yPos - deltaY,
    yPosP = yPos + deltaY;
  while (true && count < 10) {
    const arr2 = [[xPosP, yPos], [xPosM, yPos], [xPos, yPosP], [xPos, yPosM], [xPos + hotPoint3DWidth, yPos], [xPos - hotPoint3DWidth, yPos], [xPos, yPos + hotPoint3DWidth], [xPos, yPos - hotPoint3DWidth], [xPosP, yPosP], [xPosP, yPosM], [xPosM, yPosP], [xPosM, yPosM]];
    for (let i = 5; i > 1; i--) {
      const hotPointWidthDelta = hotPoint3DWidth / i;
      const xPosMI = xPos - deltaX / i,
        xPosPI = xPos + deltaX / i,
        yPosMI = yPos - deltaY / i,
        yPosPI = yPos + deltaY / i,
        xPosMMD = xPosM - hotPointWidthDelta,
        xPosMPD = xPosM + hotPointWidthDelta,
        xPosPMD = xPosP - hotPointWidthDelta,
        xPosPPD = xPosP + hotPointWidthDelta,
        yPosMMD = yPosM - hotPointWidthDelta,
        yPosMPD = yPosM + hotPointWidthDelta,
        yPosPPD = yPosP + hotPointWidthDelta,
        yPosPMD = yPosP - hotPointWidthDelta,
        xPosMIMD = xPosMI - hotPointWidthDelta,
        xPosMIPD = xPosMI + hotPointWidthDelta,
        xPosPIMD = xPosPI - hotPointWidthDelta,
        xPosPIPD = xPosPI + hotPointWidthDelta,
        yPosMIMD = yPosMI - hotPointWidthDelta,
        yPosMIPD = yPosMI + hotPointWidthDelta,
        yPosPIMD = yPosPI - hotPointWidthDelta,
        yPosPIPD = yPosPI + hotPointWidthDelta;
      arr2.push([xPosPPD, yPos], [xPosPMD, yPos], [xPosMPD, yPos], [xPosMMD, yPos], [xPos, yPosPPD], [xPos, yPosPMD], [xPos, yPosMPD], [xPos, yPosMMD], [xPosPPD, yPosPPD], [xPosPMD, yPosPMD], [xPosMPD, yPosMPD], [xPosMMD, yPosMMD], [xPosP, yPosPI], [xPosP, yPosMI], [xPosM, yPosPI], [xPosM, yPosMI], [xPosPI, yPosP], [xPosPI, yPosM], [xPosMI, yPosP], [xPosMI, yPosM], [xPosPI, yPosPI], [xPosPI, yPosMI], [xPosMI, yPosPI], [xPosMI, yPosMI], [xPosP, yPosPIPD], [xPosP, yPosMIPD], [xPosM, yPosPIPD], [xPosM, yPosMIPD], [xPosPI, yPosPPD], [xPosPI, yPosMPD], [xPosMI, yPosPPD], [xPosMI, yPosMPD], [xPosPI, yPosPIPD], [xPosPI, yPosMIPD], [xPosMI, yPosPIPD], [xPosMI, yPosMIPD], [xPosPPD, yPosPI], [xPosPPD, yPosMI], [xPosMPD, yPosPI], [xPosMPD, yPosMI], [xPosPIPD, yPosP], [xPosPIPD, yPosM], [xPosMIPD, yPosP], [xPosMIPD, yPosM], [xPosPIPD, yPosPI], [xPosPIPD, yPosMI], [xPosMIPD, yPosPI], [xPosMIPD, yPosMI], [xPosP, yPosPIMD], [xPosP, yPosMIMD], [xPosM, yPosPIMD], [xPosM, yPosMIMD], [xPosPI, yPosPMD], [xPosPI, yPosMMD], [xPosMI, yPosPMD], [xPosMI, yPosMMD], [xPosPI, yPosPIMD], [xPosPI, yPosMIMD], [xPosMI, yPosPIMD], [xPosMI, yPosMIMD], [xPosPMD, yPosPI], [xPosPMD, yPosMI], [xPosMMD, yPosPI], [xPosMMD, yPosMI], [xPosPIMD, yPosP], [xPosPIMD, yPosM], [xPosMIMD, yPosP], [xPosMIMD, yPosM], [xPosPIMD, yPosPI], [xPosPIMD, yPosMI], [xPosMIMD, yPosPI], [xPosMIMD, yPosMI], [xPosPMD, yPosPIMD], [xPosPMD, yPosMIMD], [xPosMMD, yPosPIMD], [xPosMMD, yPosMIMD], [xPosPPD, yPosPIPD], [xPosPPD, yPosMIPD], [xPosMPD, yPosPIPD], [xPosMPD, yPosMIPD], [xPosPIMD, yPosPMD], [xPosPIMD, yPosMMD], [xPosMIMD, yPosPMD], [xPosMIMD, yPosMMD], [xPosPIPD, yPosPPD], [xPosPIPD, yPosMPD], [xPosMIPD, yPosPPD], [xPosMIPD, yPosMPD], [xPosPIMD, yPosPIMD], [xPosPIMD, yPosMIMD], [xPosMIMD, yPosPIMD], [xPosMIMD, yPosMIMD], [xPosPIPD, yPosPIPD], [xPosPIPD, yPosMIPD], [xPosMIPD, yPosPIPD], [xPosMIPD, yPosMIPD]);
    }
    const posArr = getFreePointPosition(sortByReferencePoint(arr2, hotPoint.position));
    if (posArr) {
      const originHotPoint = pointsMap.get(hotPoint);
      originHotPoint.position = posArr;
      break;
    }
    if (count === 0) {
      deltaX = deltaY = Math.min(deltaX, deltaY);
    } else {
      deltaX += deltaX;
      deltaY += deltaY;
      xPosM = xPos - deltaX;
      xPosP = xPos + deltaX;
      yPosM = yPos - deltaY;
      yPosP = yPos + deltaY;
    }
    count++;
  }
}
function getIntersectedPoints(hotPoints) {
  positions = [];
  pointsMap = new Map();
  return hotPoints.filter(hotPoint => {
    pointsMap.set(hotPoint, hotPoint);
    if (getIntersectedPoint(hotPoint.position[0], hotPoint.position[1])) {
      return true;
    }
    positions.push(hotPoint.position);
    return false;
  });
}
function normalizeHotPointsPosition(hotPoints) {
  getIntersectedPoints(hotPoints || []).forEach(positionPointOnSibling);
  return Array.from(pointsMap?.values());
}
const SIMPLE_TYPES = ['string', 'boolean', 'number'];
/**
 * Unsubscribes from all available subscriptions in component remove memory leaks
 */
function CleanSubscriptionsAndMemoryLeaks(settings) {
  return constructor => {
    const original = constructor.prototype.ngOnDestroy;
    constructor.prototype.ngOnDestroy = function () {
      if (original && typeof original.apply === 'function') {
        original.apply(this);
      }
      for (const prop in this) {
        if (this.hasOwnProperty(prop) && !/^(__ngContext__|__zone)/i.test(prop) && !settings?.excludeProperties?.includes(prop)) {
          const item = this[prop];
          if (item && !SIMPLE_TYPES.includes(typeof item)) {
            if (Array.isArray(item) && item.length > 0 && isSubscription(item[0])) {
              this[prop] = cleanSubscriptions(item);
            } else if (isSubscription(item)) {
              this[prop] = cleanSubscription(item);
            } else if (typeof item !== 'function' && !isAngularEntity(item)) {
              if (item.nativeElement && !/^(firstElement|lastElement)$/i.test(prop)) {
                this[prop] = blurElementRef(item);
              } else {
                this[prop] = null;
              }
            }
          }
        }
      }
    };
  };
}
function isSubscription(obj) {
  return obj && typeof obj.unsubscribe === 'function' && typeof obj.closed !== 'undefined';
}
function isAngularEntity(obj) {
  return obj && typeof obj.constructor === 'function' && !obj.nativeElement && !obj['__ngContext__'] && (typeof obj.constructor.__NG_ELEMENT_ID__ !== 'undefined' || typeof obj.constructor.ɵfac !== 'undefined' || typeof obj.constructor.ɵprov !== 'undefined' || Array.isArray(obj.constructor.decorators) && obj.constructor.decorators.length);
}

/*
 * Public API Surface of coretypes
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ACTIVITY_COMPLETE_DUR, ACTIVITY_COMPLETE_SOUND_URL, ActivityConfig, ActivityData, ActivityLocaleService, ActivityMode, ActivityReportService, ActivityService, ActivityStatus, AlphabetCard, AlternativeAnswerVO, AnalyticsActions, AnalyticsLabels, ArrayUtil, AssessmentAnswerItem, B4xLoaderService, B4xParser, Base32, BpahService, BykiCard, BykiCardScore, BykiList, CJKUtil, CJK_PUNTUATIONS_UNICODE, CORRECT_SOUND_URL, CWDetection, CWGAService, CardDisplayMode, CardLearningMode, CleanSubscriptionsAndMemoryLeaks, ConfigService, ConfigurationVO, DASHES_UNICODE, DataLoaderService, EMPTY_SOUND_URL, ElementUnderPoint, FontSizeConstants, GOOD_WORK_DUR, GOOD_WORK_SOUND_URL, HALFWIDTH_FULLWIDTH_PUNTUATIONS_UNICODE, HYPHEN_UNICODE, Hmac, INCORRECT_SOUND_URL, ITEM_COMPLETE_DUR, ITEM_COMPLETE_SOUND_URL, LanguagePairVO, LanguageUtil, LocaleService, MessageConstants, NO_SPACE_LANGUAGES, PLAYER_CONFIG, PREVIEW_PRONOUNCE_INTRO_DUR, PREVIEW_PRONOUNCE_INTRO_SOUND_URL, PRODUCE_SAY_INTRO_DUR, PRODUCE_SAY_INTRO_SOUND_URL, PUNCTUATIONS_UNICODE, Params12, Params2004, RECOGNIZE_SAY_INTRO_DUR, RECOGNIZE_SAY_INTRO_SOUND_URL, REFRESH_SOUND_URL, RectangleUtil, SCSUtil, SPACES_UNICODE, START_SPEAKING_DUR, START_SPEAKING_SOUND_URL, STOP_SPEAKING_DUR, STOP_SPEAKING_SOUND_URL, ScoreVO, Scorm, ScormParamsConstants, ScormState, Sha1, StatusUtil, StringUtil, TLF, TextHighlightUtil, TrackAnalyticsVO, UIDUtil, UNIT_COMPLETE_DUR, UNIT_COMPLETE_SOUND_URL, UniqueCardsSorter, UserAnswerVO, XMLUtil, animateItem, appendLastSlash, blurElementRef, cleanSubscription, cleanSubscriptions, convertConfigToObject, countNumCorrectChar, createBykiListFromXmlList, createHid, createHtmlMarkup, createMarkup, createMouseEvent, createPatternForGivenString, createSafeHtmlMarkup, decomposeVietnamese, diff, diffText, diffTextToHtml, diffToHtml, escapeRegExpString, findDropTarget, focusElementRef, getAPI, getAlphabetMode$1 as getAlphabetMode, getArabicFont, getBaseHref, getBaseUrl, getBykiListInfo, getCWBaseUrl, getCoordinates, getDirection, getDirectionFromMarkup, getEasyMode, getFontFamily, getFromLocalStorage, getFullUrl, getFullUrlOld, getIntersectedPoints, getJunction, getLanguageCode, getMediaBase, getModuleBaseUrl, getNodeItems, getNodeValue, getUpConfig, getWhich, getWordBoundaryRegex, groupByQuestionType, intersectRect, interval, isAbsoluteURL, isDelimiter, isNeutral, isSpace, mergeStyles, normalizeArabicText, normalizeBykiList, normalizeEllipsis, normalizeFontName, normalizeFontNameForPdf, normalizeFontSizeForIOS, normalizeHotPointsPosition, normalizeHtml, normalizeNewLines, normalizePath, normalizeString, normalizeTagalog, normalizeVietnamese, openMobileLink, parseXmlToBykiCards, pixelStrToRemStr, pixelToRem, prettyHtml, preventEvent, replaceCRLF, replaceFloatComma, replaceHTMLEntities, replaceHyphenBetweenWords, replaceSpacesBeforePunctuations, rgbToHex, safePreventDefault, saveEasyMode, scanParentsForApi, scrollContainer, selectBestOfWrong, setMergedStyleToChild, setMergedStyleToParent, setToLocalStorage, shuffleArray, styleToObject, timer, unEscapeEntity, updateCSSArabicFont, visibilityChange };
